webpackJsonp([2],{

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bcc90ab8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports) {

exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-402.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-402.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_arrow.09476cf.png";

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(512),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(506);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("25d42b7b", content, true);

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".title{margin:0;padding:0;height:5rem;background:#fff}.title img,.title p{display:block;height:5rem}.title img{width:100%}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/downloadHeader.vue"],"names":[],"mappings":"AACA,OACE,SAAU,AACV,UAAW,AACX,YAAa,AACb,eAAiB,CAClB,AAKD,oBAHE,cAAe,AACf,WAAa,CAMd,AAJD,WACE,UAAY,CAGb","file":"downloadHeader.vue","sourcesContent":["\n.title {\n  margin: 0;\n  padding: 0;\n  height: 5rem;\n  background: #fff;\n}\n.title p {\n  display: block;\n  height: 5rem;\n}\n.title img {\n  width: 100%;\n  height: 5rem;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headerTitle',
    data: function data() {
        var query = this.$route.query || {};
        return {
            imageSrc: query && (query.language === 'en' || query.language === 'es') ? __webpack_require__(508)("./header-" + query.language + '.jpg') : __webpack_require__(511),
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL
        };
    },
    mounted: function mounted() {
        var utilObj = __webpack_require__(500);
        utilObj.checkOperamini();
        if (utilObj.checkOperamini()) {
            ga('send', 'event', 'm', 'browers', 'opreamini');
        }
    },

    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(500);
            utilObj.checkOperamini();
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'download', 'opreamini');
            }
            fbq('track', 'Lead');
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.iPad = ua.match(/ipad/);
            browers.iPhone = ua.match(/iphone/);
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            browers.ie = ua.match(/iemobile/);
            browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
            browers.force_ssl = ua.match(/Android (5|6)/i);
            browers.is_ios_6 = ua.match(/iOS 6/i);
            browers.is_liveapp = ua.match(/LiveApp/i);
            if (browers.iOS) {
                utilObj.jumpUrl();
            } else if (browers.Android) {
                location.href = '/download';
            }
        }
    }
});

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./header-en.jpg": 509,
	"./header-es.jpg": 510
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 508;

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-en.3375c0e.jpg";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-es.fac9b76.jpg";

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header.93b20d6.png";

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isInApp) ? _vm._m(0) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', {
    on: {
      "click": _vm.jumpUrl
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.imageSrc),
      "alt": "download All Football App",
      "width": "100%"
    }
  })])])
}]}

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(517),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0291f98f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(515);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("04af5aa6", content, true);

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "#download-popup[data-v-0291f98f]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10000;background-color:rgba(0,0,0,.6)}#download-popup .popup-body[data-v-0291f98f]{position:relative;width:75%;height:200px;margin:0 auto;margin-top:10rem;background-size:100%}#download-popup .popup-body-head[data-v-0291f98f]{display:block;width:140px;margin:0 auto}#download-popup .popup-body-content[data-v-0291f98f]{margin-top:-45px;padding-bottom:10px;border-radius:5px;background:#fff}#download-popup .popup-body-clsoe[data-v-0291f98f]{position:absolute;top:-.5rem;right:-.5rem;width:2.6rem;height:2.6rem;line-height:1.6rem}#download-popup .popup-body-go[data-v-0291f98f]{display:block;width:90%;height:2.6rem;margin:0 auto;margin-top:5px;color:#fff;text-align:center;line-height:2.6rem;border-radius:5px;font-weight:800;background-color:#25c023}#download-popup .popup-body-text[data-v-0291f98f]{padding:0 10px;padding-top:50px;margin-bottom:15px;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/downloadPopup.vue"],"names":[],"mappings":"AACA,iCACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,cAAe,AACf,+BAAqC,CACtC,AACD,6CACE,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,cAAe,AACf,iBAAkB,AAClB,oBAAsB,CACvB,AACD,kDACE,cAAe,AACf,YAAa,AACb,aAAe,CAChB,AACD,qDACE,iBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,kBAAmB,AACnB,WAAa,AACb,aAAe,AACf,aAAc,AACd,cAAe,AACf,kBAAoB,CACrB,AACD,gDACE,cAAe,AACf,UAAW,AACX,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,wBAA0B,CAC3B,AACD,kDACE,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadPopup.vue","sourcesContent":["\n#download-popup[data-v-0291f98f] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n#download-popup .popup-body[data-v-0291f98f] {\n  position: relative;\n  width: 75%;\n  height: 200px;\n  margin: 0 auto;\n  margin-top: 10rem;\n  background-size: 100%;\n}\n#download-popup .popup-body-head[data-v-0291f98f] {\n  display: block;\n  width: 140px;\n  margin: 0 auto;\n}\n#download-popup .popup-body-content[data-v-0291f98f] {\n  margin-top: -45px;\n  padding-bottom: 10px;\n  border-radius: 5px;\n  background: #fff;\n}\n#download-popup .popup-body-clsoe[data-v-0291f98f] {\n  position: absolute;\n  top: -0.5rem;\n  right: -0.5rem;\n  width: 2.6rem;\n  height: 2.6rem;\n  line-height: 1.6rem;\n}\n#download-popup .popup-body-go[data-v-0291f98f] {\n  display: block;\n  width: 90%;\n  height: 2.6rem;\n  margin: 0 auto;\n  margin-top: 5px;\n  color: #fff;\n  text-align: center;\n  line-height: 2.6rem;\n  border-radius: 5px;\n  font-weight: 800;\n  background-color: #25c023;\n}\n#download-popup .popup-body-text[data-v-0291f98f] {\n  padding: 0 10px;\n  padding-top: 50px;\n  margin-bottom: 15px;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            popup_show: false,
            popup_text: 'Download All Football App to enjoy the best football experience',
            popp_btn: true,
            now_local_date: new Date().toLocaleDateString()
        };
    },
    mounted: function mounted() {
        if (!window.sessionStorage) {
            window.sessionStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        if (!window.localStorage) {
            window.localStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        this.recodePopupState();
    },

    methods: {
        closePopop: function closePopop() {
            this.popup_show = false;
            var start_date = sessionStorage.getItem('start_date');
            var end_time = new Date().valueOf();
        },
        goDownload: function goDownload() {
            sessionStorage.setItem('loop_run', 'true');
            this.popup_show = false;
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                location.href = '/download';
            } else if (browers.iOS) {
                var utilObj = __webpack_require__(500);
                utilObj.jumpUrl();
            }
        },
        recodePopupState: function recodePopupState() {
            if (!localStorage.getItem('local_date')) {
                this.showPopup();
            } else {
                var local_date = localStorage.getItem('local_date');
                if (local_date != this.now_local_date) {
                    this.showPopup();
                } else {
                    return;
                }
            }
            if (!sessionStorage.getItem('start_date')) {
                var start_date = new Date().valueOf();
                sessionStorage.setItem('start_date', start_date);
            }
        },
        showPopup: function showPopup(is_stop) {
            var that = this;
            var type = this.$route.query && this.$route.query.type;
            var isInApp =  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL;
            var loopFn = function loopFn() {
                if (isInApp) {
                    return;
                }

                var start_date = sessionStorage.getItem('start_date');
                var end_time = new Date().valueOf();
                if (sessionStorage.getItem('loop_run') == 'true') {
                    clearInterval(loopFnTimer);
                }
                if ((end_time - start_date) / 1000 >= 30 && (end_time - start_date) / 1000 < 32) {
                    that.popup_show = true;
                } else if ((end_time - start_date) / 1000 >= 60 && (end_time - start_date) / 1000 < 62) {
                    clearInterval(loopFnTimer);

                    if (type === 'share') {
                        return;
                    }
                    if (document.cookie.indexOf('utm_source=ALL_FOOTBALL_PWA')) {
                        return;
                    }
                    var browers = {};
                    var ua = navigator.userAgent.toLowerCase();
                    browers.Android = ua.match(/android/);
                    browers.iOS = ua.match(/ipad|iphone|ios/);
                    if (browers.Android) {
                        that.popup_text = 'Add our website to Home screen or Bookmarks to follow the latest football news.';
                    } else if (browers.iOS) {
                        that.popup_text = 'Add our website to Home screen or Favorites to follow the latest football news.';
                    }
                    that.popp_btn = false;
                    that.popup_show = true;
                    localStorage.setItem('local_date', that.now_local_date);
                } else if ((end_time - start_date) / 1000 > 62) {
                    clearInterval(loopFnTimer);
                }
            };
            var loopFnTimer = setInterval(loopFn, 1000);
        }
    }
});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_show),
      expression: "popup_show"
    }],
    attrs: {
      "id": "download-popup"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticClass: "popup-body-head",
    attrs: {
      "src": __webpack_require__(518),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body-content"
  }, [_c('p', {
    staticClass: "popup-body-text"
  }, [_vm._v(_vm._s(_vm.popup_text))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popp_btn),
      expression: "popp_btn"
    }],
    staticClass: "popup-body-go",
    on: {
      "click": function($event) {
        _vm.goDownload()
      }
    }
  }, [_vm._v("GO NOW")])]), _vm._v(" "), _c('img', {
    staticClass: "popup-body-clsoe",
    attrs: {
      "src": __webpack_require__(519)
    },
    on: {
      "click": function($event) {
        _vm.closePopop()
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_icon.c1b2864.png";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/close_icon.9c943d6.png";

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(552), __esModule: true };

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(553);
module.exports = __webpack_require__(32).Object.keys;


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(88);
var $keys = __webpack_require__(126);

__webpack_require__(554)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(48);
var core = __webpack_require__(32);
var fails = __webpack_require__(85);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/video_arrow.04eb228.png";

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

module.exports = {
    'en': {
        'events': 'Events',
        'goal': 'Goal',
        'penalty': 'Penalty',
        'penaltySaved': 'Penalty Saved',
        'ownGoal': 'Own Goal',
        'assist': 'Assist',
        'statistics': 'Statistic',
        'noData': 'No Data',
        'notPrepared': 'Match does not start',

        'prediction': 'Support Your Team',
        'vote': 'Vote',
        'voted': 'Voted',
        'home': 'Home',
        'draw': 'Draw',
        'away': 'Away',
        'voteNum': '(1 vote) | ({count} votes)',
        'voteFail': 'Vote failed, please retry~',
        'matchVoted': 'You have already voted~',
        'matchNotStart': 'Match does not start',
        'predictionEnd': 'Prediction is end, remember to predict before the match',
        'statistic': 'Statistics',
        'broadcast': 'Broadcast Info',
        'past_games': 'Past Games',
        'pg_no': 'No Past Games',
        'pg_lng': 'Last {count} Games',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Date',
        'pg_competition': 'Competition',
        'pg_home': 'Home',
        'pg_result': 'Result',
        'pg_away': 'Away',
        'absentee': 'Absentee',
        'absentee_no': 'No Absentee',
        'recent_games': 'Recent Games',
        'rg_no': 'No Recent Games',
        'rg_date': 'Date',
        'rg_competition': 'Competition',
        'rg_home': 'Home',
        'rg_result': 'Result',
        'rg_away': 'Away',
        'league_table': 'League Table',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Home',
        'lt_away': 'Away',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Rank',
        'lt_wp': 'WP',
        'ct_team': 'Team',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Odds',
        'odds_no': 'No Odds',
        'odds_no_data': 'No Data',
        'odds_handicap': 'Handicap',
        'odds_ou': 'Over/Under',
        'odds_1x2': '1x2',
        'odds_over': 'Over',
        'odds_under': 'Under',
        'odds_total': 'Total',
        'odds_more': 'More',
        'odds_company': 'Company',
        'odds_type': 'Type',
        'odds_spot': 'Spot',
        'odds_initial': 'Initial',
        'odds_home_win': 'Home',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Away',
        'odds_tu': 'Time Updated',
        'odds_home_lose': 'Home',
        'odds_draw': 'Draw',
        'odds_away_win': 'Away',
        'odds_highest': 'Highest',
        'odds_lowest': 'Lowest',
        'odds_average': 'Average',
        'odds_changes': 'Odds Changes',
        'odds_dc': 'Detail Changes',
        'Decimal': 'Decimal',
        'American': 'American',
        'Fractional': 'Fractional',
        'more': 'more',
        'matchPredictionTip': 'Match Tips',
        'matchPredictionResult': 'Predicted results by Match Tips',
        'matchPredictionView': 'View',
        'matchPredictionFreeChance': 'You have <b>{count}</b> chance(s) check out for free',
        'matchPredictionIncorrect': 'You\'ll get another chance to check out for free if we made an incorrect prediction'
    },
    'es': {
        'events': 'Eventos',
        'goal': 'Gol',
        'penalty': 'Penalti',
        'penaltySaved': 'Penalti rechazado',
        'ownGoal': 'Gol en propia puerta',
        'assist': 'Asistencia',
        'statistics': 'Estadística',
        'noData': 'Sin datos',
        'notPrepared': 'Partido no se inicia',

        'prediction': 'Apoya a tu equipo',
        'vote': 'Votar',
        'voted': 'Votado',
        'home': 'Casa',
        'draw': 'Empate',
        'away': 'Fuera',
        'voteNum': '(1 voto) | ({count} votos)',
        'voteFail': 'El voto falló, reintenta ~',
        'matchVoted': 'Ya has votado ~',
        'matchNotStart': 'La partida no comienza',
        'predictionEnd': 'La predicción es final, recuerda predecir antes del partido',
        'broadcast': 'Información de transmisión',
        'statistic': 'Estadísticas de Jugador',
        'past_games': 'Partidos Pasados',
        'pg_no': 'No partidos pasados',
        'pg_lng': 'Últimos Partidos',
        'pg_w': '{count} PG',
        'pg_d': '{count} PE',
        'pg_date': 'Fecha',
        'pg_competition': 'Competición',
        'pg_home': 'Casa',
        'pg_result': 'Resultado',
        'pg_away': 'Fuera',
        'absentee': 'Ausente',
        'absentee_no': 'No hay ausente',
        'recent_games': 'Partidos Recientes',
        'rg_no': 'No hay partidos recientes',
        'rg_date': 'Fecha',
        'rg_competition': 'Competición',
        'rg_home': 'Casa',
        'rg_result': 'Resultado',
        'rg_away': 'Fuera',
        'league_table': 'Tabla de la liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Casa',
        'lt_away': 'Fuera',
        'lt_p': 'PJ',
        'lt_w': 'PG',
        'lt_d': 'PE',
        'lt_l': 'PP',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'PT',
        'lt_rank': 'Rango',
        'lt_wp': 'Porcentaje de victorias',
        'ct_team': 'Equipo',
        'ct_p': 'PJ',
        'ct_w': 'PG',
        'ct_d': 'PE',
        'ct_l': 'PP',
        'ct_fa': '+/-',
        'ct_pts': 'PT',
        'odds': 'Cuotas',
        'odds_no': 'No hay cuotas',
        'odds_no_data': 'Sin datos',
        'odds_handicap': 'Desventaja',
        'odds_ou': 'Más/Menos',
        'odds_1x2': '1x2',
        'odds_over': 'Más',
        'odds_under': 'Menos',
        'odds_total': 'Total',
        'odds_more': ' Más',
        'odds_company': 'Empresa',
        'odds_type': 'Tipo',
        'odds_spot': 'Lugar',
        'odds_initial': 'Inicial',
        'odds_home_win': 'Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Fuera',
        'odds_tu': 'Actualización',
        'odds_home_lose': 'Casa',
        'odds_draw': 'Empate',
        'odds_away_win': 'Fuera',
        'odds_highest': 'Máximo',
        'odds_lowest': 'Mínimo',
        'odds_average': 'Promedio',
        'odds_changes': 'La probabilidad cambia',
        'odds_dc': 'El detalle cambia',
        'Decimal': 'Decimal',
        'American': 'Americano',
        'Fractional': 'Fraccional',
        'more': 'Más'
    },
    'pt': {
        'events': 'Eventos',
        'goal': 'Gol',
        'penalty': 'Pênalti',
        'penaltySaved': 'Pênalti Defendido',
        'ownGoal': 'Gol Contra',
        'assist': 'Assistência',
        'statistics': 'Estatística  ',
        'noData': 'Não há dados',
        'notPrepared': 'O jogo não começa',

        'prediction': 'Previsões para a partida',
        'vote': 'Voto',
        'voted': 'Votado',
        'home': 'Em Casa',
        'draw': 'Empate',
        'away': 'Fora',
        'voteNum': '(1 voto) | ({count} votos)',
        'voteFail': 'Falha ao enviar o voto. Por favor, tente novamente~',
        'matchVoted': 'Você já votou ~',
        'matchNotStart': 'O jogo não começa',
        'predictionEnd': 'O prazo para as previsões terminou. Lembre-se de enviar suas previsões antes do início da partida.',
        'statistic': 'Estatisticas',
        'past_games': 'Jogos passados',
        'pg_no': 'Nenhum Jogo Passado',
        'pg_lng': 'Últimos{count} Jogos',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Data',
        'pg_competition': 'Competição',
        'pg_home': 'Em Casa',
        'pg_result': 'Resultado',
        'pg_away': 'Fora',
        'absentee': 'Ausência',
        'absentee_no': 'Nenhuma ausência',
        'recent_games': 'Jogos Recentes',
        'rg_no': 'Nenhum Jogo Recente',
        'rg_date': 'Data',
        'rg_competition': 'Competição',
        'rg_home': 'Em Casa',
        'rg_result': 'Resultado',
        'rg_away': 'Fora',
        'league_table': 'Tabela da Liga',
        'lt_format': 'Formato',
        'lt_total': 'Total',
        'lt_home': 'Em Casa',
        'lt_away': 'Fora',
        'lt_p': 'J',
        'lt_w': 'V',
        'lt_d': 'E',
        'lt_l': 'D',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Ranking',
        'lt_wp': 'WP',
        'ct_team': 'Time',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Probabilidade',
        'odds_no': 'Nenhuma Probabilidade',
        'odds_no_data': 'Nenhum Dado',
        'odds_handicap': 'Lesões',
        'odds_ou': 'Acima/Sub',
        'odds_1x2': '1x2',
        'odds_over': 'Acima  ',
        'odds_under': 'Sub',
        'odds_total': 'Total',
        'odds_more': 'Mais',
        'odds_company': 'Empresa',
        'odds_type': 'Tip',
        'odds_spot': 'Ponto',
        'odds_initial': 'Inicial',
        'odds_home_win': 'Em Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Fora',
        'odds_tu': 'Tempo Atualizado',
        'odds_home_lose': 'Em Casa',
        'odds_draw': 'Empate',
        'odds_away_win': 'Fora',
        'odds_highest': 'Mais alto',
        'odds_lowest': 'Mais baixo',
        'odds_average': 'Média',
        'odds_changes': 'Alterações nas Probabilidades',
        'odds_dc': 'Alterações nos Detalhes',
        'more': 'mais',
        'broadcast': 'Informações da Transmissão',
        'Decimal': 'Decimal',
        'American': 'Americano',
        'Fractional': 'Fracional',
        'matchPredictionTip': 'Dicas para a Partida',
        'matchPredictionResult': 'Previsões de resultados pelas Dicas para a Partida',
        'matchPredictionView': 'Visualizar',
        'matchPredictionFreeChance': 'Você tem <b>{count}</b> chance(s). Confira gratuitamente.',
        'matchPredictionIncorrect': 'Você receberá outra chance para conferir gratuitamente se nós fizermos uma previsão incorreta.'
    },
    'it': {
        'events': 'Eventi',
        'goal': 'Gol',
        'penalty': 'Rigore',
        'penaltySaved': 'Rigore Salvato',
        'ownGoal': 'Autogol',
        'assist': 'Assistenze',
        'statistics': 'Statistica',
        'noData': 'Nessun Dato',
        'notPrepared': 'Partita non cominciata',

        'prediction': 'Sostieni Tua Squadra',
        'vote': 'Voti',
        'voted': 'Votato',
        'home': 'Casa',
        'draw': 'Pareggio',
        'away': 'Via',
        'voteNum': '(1 voto) | ({conteggio} voti)',
        'voteFail': 'Voto fallito, per favore provi~',
        'matchVoted': 'Hai già votato~',
        'matchNotStart': 'Partita non cominciata',
        'predictionEnd': 'Previsione è finita, ricordi di prevedere prima della partita',
        'statistic': 'Statistiche',
        'past_games': 'Partite Passate',
        'pg_no': 'Nessuna Partita Passata',
        'pg_lng': 'Ultimi {conteggio} Giochi',
        'pg_w': '{conteggio} W',
        'pg_d': '{conteggio} D',
        'pg_date': 'Dati',
        'pg_competition': 'Concorso',
        'pg_home': 'Casa',
        'pg_result': 'Risultato',
        'pg_away': 'Via',
        'absentee': 'Assente',
        'absentee_no': 'Nessun assente',
        'recent_games': 'Recenti Partite',
        'rg_no': 'Nessun Recente Partita',
        'rg_date': 'Data',
        'rg_competition': 'Concorso',
        'rg_home': 'Casa',
        'rg_result': 'Risultato',
        'rg_away': 'Via',
        'league_table': 'Classica a punti',
        'lt_format': 'Formato',
        'lt_total': 'Totale',
        'lt_home': 'Casa',
        'lt_away': 'Trasferta',
        'lt_p': 'G',
        'lt_w': 'V',
        'lt_d': 'N',
        'lt_l': 'P',
        'lt_f': '+',
        'lt_a': 'S',
        'lt_pts': 'Pt',
        'lt_rank': 'Classifica',
        'lt_wp': 'VP',
        'ct_team': 'Squadra',
        'ct_p': 'G',
        'ct_w': 'V',
        'ct_d': 'N',
        'ct_l': 'P',
        'ct_fa': 'F/S',
        'ct_pts': 'Pt',
        'odds': 'Probabilità',
        'odds_no': 'Nessuna Probabilità',
        'odds_no_data': 'Nessun Dato',
        'odds_handicap': 'Disabile',
        'odds_ou': 'Sopra/Sotto',
        'odds_1x2': '1x2',
        'odds_over': 'Fine',
        'odds_under': 'Sopra',
        'odds_total': 'Sotto',
        'odds_more': 'Più',
        'odds_company': 'Società',
        'odds_type': 'Tipo',
        'odds_spot': 'Punto',
        'odds_initial': 'Iniziale',
        'odds_home_win': 'Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Via',
        'odds_tu': 'Tempo aggiornato',
        'odds_home_lose': 'Casa',
        'odds_draw': 'Pareggio',
        'odds_away_win': 'Via',
        'odds_highest': 'Altissimo',
        'odds_lowest': 'Bassissimo',
        'odds_average': 'Media',
        'odds_changes': 'Cambiamenti Probabilità',
        'odds_dc': 'Cambiamenti Dettagli',
        'more': 'più',
        'broadcast': 'Info di trasmissione',
        'Decimal': 'Decimale',
        'American': 'Americano',
        'Fractional': 'Frazionale',
        'matchPredictionTip': 'Match Tips',
        'matchPredictionResult': 'Risultati previsti da Match Tips',
        'matchPredictionView': 'Vista',
        'matchPredictionFreeChance': 'Hai <b>{conteggio}</b> opportunità di controllo gratuito',
        'matchPredictionIncorrect': 'Ottenerai un’altra opportunità di controllare gratuitamente se abbiamo fatto una previsione incorretta'
    },
    'fr': {
        'events': 'Événements',
        'goal': 'Objectif',
        'penalty': 'Pénalité',
        'penaltySaved': 'Pénalité enregistrée',
        'ownGoal': ' Objectif propre',
        'assist': 'Assistez',
        'statistics': 'Statistique',
        'noData': 'Pas de données',
        'notPrepared': 'Le match ne commence pas',

        'prediction': 'Soutenez votre équipe',
        'vote': 'Vote',
        'voted': 'Voté',
        'home': 'Domicile',
        'draw': 'Dessiner',
        'away': ' Invitée',
        'voteNum': '(1 vote) | ({count} votes)',
        'voteFail': 'Vote échoué, bien vouloir réessayer ~',
        'matchVoted': 'Vous avez déjà voté ~',
        'matchNotStart': 'Le match ne commence pas',
        'predictionEnd': 'La prédiction c\'est la fin, ne pas oublier de prédire avant le match',
        'statistic': 'Statistiques',
        'past_games': 'Jeux précédents',
        'pg_no': 'Aucun jeu précédent',
        'pg_lng': 'Derniers {count} Jeux',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Date',
        'pg_competition': 'Compétition',
        'pg_home': 'Domicile',
        'pg_result': 'Résultat',
        'pg_away': 'Invitée',
        'absentee': 'Absent',
        'absentee_no': 'Pas d\'absent',
        'recent_games': 'Jeux récents',
        'rg_no': 'Pas de jeux récents',
        'rg_date': 'Date',
        'rg_competition': 'Compétition',
        'rg_home': 'Domicile',
        'rg_result': 'Résultat',
        'rg_away': 'Invitée',
        'league_table': 'Table ligue',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Domicile',
        'lt_away': 'Invitée',
        'lt_p': 'J',
        'lt_w': 'G',
        'lt_d': 'N',
        'lt_l': 'P',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Rang',
        'lt_wp': 'WP',
        'ct_team': 'Équipe',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Chances',
        'odds_no': 'Aucune chance',
        'odds_no_data': 'Pas de données',
        'odds_handicap': 'Handicap',
        'odds_ou': 'Au dessus de/En dessous de',
        'odds_1x2': '1x2',
        'odds_over': 'Au dessus de',
        'odds_under': 'En dessous de',
        'odds_total': 'Total',
        'odds_more': 'Plus',
        'odds_company': 'Compagnie',
        'odds_type': 'Type',
        'odds_spot': 'Place',
        'odds_initial': 'Initial',
        'odds_home_win': 'Domicile',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Invitée',
        'odds_tu': 'Heure mise à jour',
        'odds_home_lose': 'Domicile',
        'odds_draw': 'Dessiner',
        'odds_away_win': 'Invitée',
        'odds_highest': 'Le plus élevé',
        'odds_lowest': 'Le plus bas',
        'odds_average': 'Moyenne',
        'odds_changes': 'Modifications de cotes',
        'odds_dc': 'Modifications de détail',
        'more': 'plus',
        'broadcast': 'Infos diffusion',
        'Decimal': 'Décimal',
        'American': 'Américain',
        'Fractional': 'Fractionnaire',
        'matchPredictionTip': 'Match Tips',
        'matchPredictionResult': 'Résultats prévus par Match Tips',
        'matchPredictionView': 'Vue',
        'matchPredictionFreeChance': 'Vous avez <b> {count} </ b> chance (s) consulter gratuitement',
        'matchPredictionIncorrect': 'Vous aurez une autre occasion de consulter gratuitement si nous avons fait une mauvaise prédiction'
    },
    'ru': {
        'events': 'Мероприятия',
        'goal': 'Цель',
        'penalty': 'Пенальти',
        'penaltySaved': 'Отбитый Пенальти',
        'ownGoal': 'Автогол',
        'assist': 'голевые передачи',
        'statistics': 'Статистика',
        'noData': 'Нет данных',
        'notPrepared': 'Матч не начат',

        'prediction': 'Поддержите вашу команду',
        'vote': 'Голосовать',
        'voted': 'проголосовавший',
        'home': 'Домашний',
        'draw': 'рисовать',
        'away': 'потерять',
        'voteNum': '(1 голос) | ({count} голосов)',
        'voteFail': 'Проголосовать не удалось, повторите попытку ~',
        'matchVoted': 'Вы уже голосовали ~',
        'matchNotStart': 'Матч не начат',
        'predictionEnd': 'Прогнозирование окончено, не забудьте предсказать перед матчем',
        'statistic': 'Статистика',
        'past_games': 'Прошедшие игры',
        'pg_no': 'Нет прошлых игр',
        'pg_lng': 'Последние {count} игры',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Дата',
        'pg_competition': 'Соревнование',
        'pg_home': 'Домашний',
        'pg_result': 'результат',
        'pg_away': 'потерять',
        'absentee': 'отсутствующий',
        'absentee_no': 'Нет отсутствующих',
        'recent_games': 'Недавние игры',
        'rg_no': 'Нет недавних игр',
        'rg_date': 'Дата',
        'rg_competition': 'Соревнование',
        'rg_home': 'Домашний',
        'rg_result': 'Результат',
        'rg_away': 'потерять',
        'league_table': 'Таблица Лиги',
        'lt_format': 'Формат',
        'lt_total': 'Всего',
        'lt_home': 'Домашний',
        'lt_away': 'потерять',
        'lt_p': 'И',
        'lt_w': 'В',
        'lt_d': 'Н',
        'lt_l': 'П',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Очки',
        'lt_rank': 'Разряд',
        'lt_wp': 'WP',
        'ct_team': 'Команда',
        'ct_p': 'И',
        'ct_w': 'В',
        'ct_d': 'Н',
        'ct_l': 'П',
        'ct_fa': 'F/A',
        'ct_pts': 'ОЧКИ',
        'odds': 'Вероятность выигрыша',
        'odds_no': 'Нет вероятности выигрыша',
        'odds_no_data': 'Нет данных',
        'odds_handicap': 'Фора',
        'odds_ou': 'Больше / Меньше',
        'odds_1x2': '1х2',
        'odds_over': 'Больше',
        'odds_under': 'Меньше',
        'odds_total': 'Всего',
        'odds_more': 'Еще',
        'odds_company': 'Компания',
        'odds_type': 'Тип',
        'odds_spot': 'Одиннадцатиметровая отметка',
        'odds_initial': 'Начальный',
        'odds_home_win': 'Домашний',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'потерять',
        'odds_tu': 'Время обновлено',
        'odds_home_lose': 'Домашний',
        'odds_draw': 'постановочный бросок',
        'odds_away_win': 'потерять',
        'odds_highest': 'Наибольший',
        'odds_lowest': 'Низший',
        'odds_average': 'Средний',
        'odds_changes': 'Изменения вероятности выигрыша',
        'odds_dc': 'Изменения Деталей',
        'more': 'еще',
        'broadcast': 'Информация о трансляции',
        'Decimal': 'Десятичная дробь',
        'American': 'Американский',
        'Fractional': 'Дробный',
        'matchPredictionTip': 'Советы по игре',
        'matchPredictionResult': 'Прогнозируемые результаты от Советов по игре',
        'matchPredictionView': 'Посмотреть',
        'matchPredictionFreeChance': 'У вас есть <b> {count} </ b> шанс (ы) проверьте бесплатно',
        'matchPredictionIncorrect': 'У вас будет еще один шанс узнать бесплатно, если мы допустим неправильное предсказание'
    },
    'tr': {
        'prediction': 'Maç Tahmini',
        'vote': 'Oy',
        'voted': 'oy',
        'home': 'birincil',
        'draw': 'çizmek',
        'away': 'yolcu',
        'voteNum': '(1 oy) | ({count} oy)',
        'voteFail': 'Oy veremedi, lütfen tekrar deneyin ~',
        'matchVoted': 'Zaten oy kullandın ~',
        'matchNotStart': 'Maç başlamıyor',
        'predictionEnd': 'Tahmin son, maçtan önce tahmin etmeyi unutmayın'
    },
    'in': {
        'prediction': 'Prediksi Pertandingani',
        'vote': 'Memilih',
        'voted': 'Terpilih',
        'home': 'Tuhan',
        'draw': 'Draw',
        'away': 'Tamu',
        'voteNum': '(1 suara) | ({count} suara)',
        'voteFail': 'Vote gagal, mohon dicoba ~',
        'matchVoted': 'Kamu sudah memilih ~',
        'matchNotStart': 'Pertandingan tidak dimulai',
        'predictionEnd': 'Prediksi sudah berakhir, ingatlah untuk memprediksi sebelum pertandingan',
        'statistic': 'Statistik',
        'past_games': 'Pertandingan Terakhir',
        'pg_no': 'Tidak Ada Pertandingan Terakhir',
        'pg_lng': 'Pertandingan {count} Terakhir',
        'pg_w': 'M',
        'pg_d': 'H',
        'pg_date': 'Tanggal',
        'pg_competition': 'Persaingan',
        'pg_home': 'Kandang',
        'pg_result': 'Hasil',
        'pg_away': 'Tandang',
        'absentee': 'Pemain yang Tidak Hadir',
        'absentee_no': 'No Pemain yang Tidak Hadir',
        'recent_games': 'Pertandingan Terkini',
        'rg_no': 'Tidak Ada Pertandingan Terkini',
        'rg_date': 'Tanggal',
        'rg_competition': 'Persaingan',
        'rg_home': 'Kandang',
        'rg_result': 'Hasil',
        'rg_away': 'Tandang',
        'league_table': 'Klasemen Liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Kandang',
        'lt_away': 'Tandang',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Poin',
        'lt_rank': 'Peringkat',
        'lt_wp': 'WP',
        'ct_team': 'Tim',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Poin',
        'odds': 'Odd',
        'odds_no': 'Tidak Ada Odd',
        'odds_no_data': 'Tidak Ada Data',
        'odds_handicap': 'Handicap',
        'odds_ou': 'Atas/Bawah',
        'odds_1x2': '1x2',
        'odds_over': 'Atas',
        'odds_under': 'Bawah',
        'odds_total': 'Total',
        'odds_more': 'Lebih Lanjut',
        'odds_company': 'Perusahaan',
        'odds_type': 'Jenis',
        'odds_spot': 'Titik',
        'odds_initial': 'Awal',
        'odds_home_win': 'Kandang',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Tandang',
        'odds_tu': 'Waktu yang Diperbarui',
        'odds_home_lose': 'Kandang',
        'odds_draw': 'Penarikan',
        'odds_away_win': 'Tandang',
        'odds_highest': 'Tertinggi',
        'odds_lowest': 'Terendah',
        'odds_average': 'Rata-rata',
        'odds_changes': 'Perubahan Odd',
        'odds_dc': 'Perubahan Detail',
        'more': 'lebih lanjut'
    },
    'th': {
        'events': 'เหตุการณ์',
        'goal': 'ประตู',
        'penalty': 'ลูกโทษ',
        'penaltySaved': 'ลูกโทษที่ถูกป้องกัน',
        'ownGoal': 'การทำเข้าประตูตัวเอง',
        'assist': 'การจ่ายบอลแล้วเป็นประตู',
        'statistics': 'สถิติ',
        'noData': 'ไม่มีข้อมูล',
        'notPrepared': 'การแข่งขันยังไม่เริ่มต้น',

        'prediction': 'สนับสนุนทีมของคุณ',
        'vote': 'โหวต',
        'voted': 'โหวตแล้ว',
        'home': 'เจ้าบ้าน',
        'draw': 'เสมอ',
        'away': 'ทีมเยือน',
        'voteNum': '(1 โหวต) | ({count} โหวต)',
        'voteFail': 'การโหวตล้มเหลว โปรดลองอีกครั้ง ~',
        'matchVoted': 'คุณได้โหวตเรียบร้อยแล้ว ~',
        'matchNotStart': 'การแข่งขันยังไม่เริ่มต้น',
        'predictionEnd': 'การทำนายสิ้นสุดแล้ว อย่าลืมทำนายก่อนการแข่งขัน',
        'statistic': 'สถิติ',
        'broadcast': 'ข้อมูลการออกอากาศ',
        'past_games': 'เกมที่ผ่านมา',
        'pg_no': 'ไม่มีเกมที่ผ่านมา',
        'pg_lng': '{count} เกมล่าสุด',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'วันที่',
        'pg_competition': 'การแข่งขัน',
        'pg_home': 'เจ้าบ้าน',
        'pg_result': 'ผลการแข่งขัน',
        'pg_away': 'ทีมเยือน',
        'absentee': 'ผู้ที่ไม่มา',
        'absentee_no': 'ไม่มีผู้ที่ไม่มา',
        'recent_games': 'เกมล่าสุด',
        'rg_no': 'ไม่มีเกมล่าสุด',
        'rg_date': 'วันที่',
        'rg_competition': 'การแข่งขัน',
        'rg_home': 'เจ้าบ้าน',
        'rg_result': 'ผลการแข่งขัน',
        'rg_away': 'ทีมเยือน',
        'league_table': 'ตารางลีก',
        'lt_format': 'รูปแบบ',
        'lt_total': 'รวม',
        'lt_home': 'เจ้าบ้าน',
        'lt_away': 'ทีมเยือน',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'อันดับ',
        'lt_wp': 'WP',
        'ct_team': 'ทีม',
        'ct_p': 'แข่ง',
        'ct_w': 'ชนะ',
        'ct_d': 'เสมอ',
        'ct_l': 'แพ้',
        'ct_fa': 'F/A',
        'ct_pts': 'คะแนน',
        'odds': 'ราคาต่อรอง',
        'odds_no': 'ไม่มีราคาต่อรอง',
        'odds_no_data': 'ไม่มีข้อมูล',
        'odds_handicap': 'แฮนดิแคป',
        'odds_ou': 'สูง/ต่ำ',
        'odds_1x2': '1x2',
        'odds_over': 'สูง',
        'odds_under': 'ต่ำ',
        'odds_total': 'รวม',
        'odds_more': 'เพิ่มเติม',
        'odds_company': 'บริษัท',
        'odds_type': 'ชนิด',
        'odds_spot': 'จุด',
        'odds_initial': 'เริ่มต้น',
        'odds_home_win': 'เจ้าบ้าน',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'ทีมเยือน',
        'odds_tu': 'อัปเดตเวลาแล้ว',
        'odds_home_lose': 'เจ้าบ้าน',
        'odds_draw': 'เสมอ',
        'odds_away_win': 'ทีมเยือน',
        'odds_highest': 'สูงสุด',
        'odds_lowest': 'ต่ำสุด',
        'odds_average': 'ค่าเฉลี่ย',
        'odds_changes': 'การเปลี่ยนแปลงราคาต่อรอง',
        'odds_dc': 'การเปลี่ยนแปลงรายละเอียด',
        'Decimal': 'ทศนิยม',
        'American': 'อเมริกัน',
        'Fractional': 'เป็นเศษส่วน',
        'more': 'เพิ่มเติม',
        'matchPredictionTip': 'เทคนิคในการแข่งขัน (Match Tips)',
        'matchPredictionResult': 'ผลลัพธ์ที่คาดการณ์โดย เทคนิคในการแข่งขัน',
        'matchPredictionView': 'ดู',
        'matchPredictionFreeChance': 'คุณมีโอกาส <b>{count}</b> ในการเช็คเอาท์ฟรี',
        'matchPredictionIncorrect': 'คุณจะได้รับโอกาสอีกครั้งในการเช็คเอาท์ฟรีถ้าทำนายไม่ถูกต้อง'
    },
    'de': {
        'events': 'Veranstaltungen',
        'goal': 'Tor',
        'penalty': 'Elfmeter',
        'penaltySaved': 'Strafe gespeichert',
        'ownGoal': 'Eigentor',
        'assist': 'Helfen',
        'statistics': 'Statistik',
        'noData': 'Keine Daten',
        'notPrepared': 'Das Match beginnt nicht',

        'prediction': 'Unterstütze dein Team',
        'vote': 'Abstimmung',
        'voted': 'Abgestimmt',
        'home': 'Zuhause',
        'draw': 'Unentschieden',
        'away': 'Nicht anwesend',
        'voteNum': '(1 Stimme) | ({count} Stimmen)',
        'voteFail': 'Abstimmung fehlgeschlagen, bitte wiederholen ~',
        'matchVoted': 'Du hast bereits abgestimmt~',
        'matchNotStart': 'Das Match beginnt nicht',
        'predictionEnd': 'Vorhersage ist beendet, denke daran, vor dem Spiel vorherzusagen',
        'statistic': 'Statistiken',
        'broadcast': 'Info senden',
        'past_games': 'Vorherige Spiele',
        'pg_no': 'Keine vorherigen Spiele',
        'pg_lng': 'Letzte {count} Spiele',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Datum',
        'pg_competition': 'Wettbewerb',
        'pg_home': 'Zuhause',
        'pg_result': 'Ergebnis',
        'pg_away': 'Nicht anwesend',
        'absentee': 'Abwesenheit',
        'absentee_no': 'Kein Abwesender',
        'recent_games': 'Neueste Spiele',
        'rg_no': 'Keine neuesten Spiele',
        'rg_date': 'Datum',
        'rg_competition': 'Wettbewerb',
        'rg_home': 'Zuhause',
        'rg_result': 'Ergebnis',
        'rg_away': 'Nicht anwesend',
        'league_table': 'Ligatabelle',
        'lt_format': 'Format',
        'lt_total': 'Gesamt',
        'lt_home': 'Zuhause',
        'lt_away': 'Nicht anwesend',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pkte',
        'lt_rank': 'Rang',
        'lt_wp': 'WP',
        'ct_team': 'Mannschaft',
        'ct_p': 'Sp',
        'ct_w': 'G',
        'ct_d': 'U',
        'ct_l': 'V',
        'ct_fa': 'F/A',
        'ct_pts': 'Pkt',
        'odds': 'Chancen',
        'odds_no': 'Keine Chancen',
        'odds_no_data': 'Keine Daten',
        'odds_handicap': 'Behinderung',
        'odds_ou': 'Über/Unter',
        'odds_1x2': '1x2',
        'odds_over': 'Über',
        'odds_under': 'Unter',
        'odds_total': 'Gesamt',
        'odds_more': 'Mehr',
        'odds_company': 'Unternehmen',
        'odds_type': 'Art',
        'odds_spot': 'Stelle',
        'odds_initial': 'Start',
        'odds_home_win': 'Zuhause',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Nicht anwesend',
        'odds_tu': 'Zeit aktualisiert',
        'odds_home_lose': 'Zuhause',
        'odds_draw': 'Unentschieden',
        'odds_away_win': 'Nicht anwesend',
        'odds_highest': 'Höchste',
        'odds_lowest': 'Niedrigste',
        'odds_average': 'Durchschnittliche',
        'odds_changes': 'Quotenänderungen',
        'odds_dc': 'Detailänderungen',
        'Decimal': 'Dezimal',
        'American': 'Amerikanisch',
        'Fractional': 'Fraktional',
        'more': 'mehr',
        'matchPredictionTip': 'Spieltipps',
        'matchPredictionResult': 'Voraussichtliche Ergebnisse gemäss Spieltipps',
        'matchPredictionView': 'Aussicht',
        'matchPredictionFreeChance': 'Du hast <b>{count}</b> Chance(n) kostenlos auszuchecken',
        'matchPredictionIncorrect': 'Du erhältst eine weitere Chance, kostenlos auszuchecken, falls wir eine falsche Vorhersage getroffen haben'
    },
    'id': {
        'events': 'Acara',
        'goal': 'Gol',
        'penalty': 'Penalti',
        'penaltySaved': 'Penyelamatan Tendangan Penalti',
        'ownGoal': 'Gol Bunuh Diri',
        'assist': 'Umpan',
        'statistics': 'Statistik',
        'noData': 'Tidak Ada Data',
        'notPrepared': 'Pertandingan tidak dimulai',

        'prediction': 'Dukung Tim Anda',
        'vote': 'Memilih',
        'voted': 'Dipilih',
        'home': 'Kandang',
        'draw': 'Seri',
        'away': 'Tandang',
        'voteNum': '(1 suara) | ({count} suara)',
        'voteFail': 'Pemungutan suara gagal, coba lagi~',
        'matchVoted': 'Anda telah memilih~',
        'matchNotStart': 'Pertandingan tidak dimulai',
        'predictionEnd': 'Prediksi telah berakhir, ingatlah untuk memprediksi sebelum pertandingan',
        'statistic': 'Statistik',
        'broadcast': 'Info Siaran',
        'past_games': 'Permainan yang Lalu',
        'pg_no': 'Tidak ada Permainan yang Lalu',
        'pg_lng': 'Pertandingan {count} yang Terakhir',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Tanggal',
        'pg_competition': 'Kompetisi',
        'pg_home': 'Kandang',
        'pg_result': 'Hasil',
        'pg_away': 'Tandang',
        'absentee': 'Absen',
        'absentee_no': 'Tidak Absen',
        'recent_games': 'Game Terbaru',
        'rg_no': 'Tidak ada permainan terbaru',
        'rg_date': 'Tanggal',
        'rg_competition': 'Kompetisi',
        'rg_home': 'Kandang',
        'rg_result': 'Hasil',
        'rg_away': 'Tandang',
        'league_table': 'Tabel Liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Kandang',
        'lt_away': 'Tandang',
        'lt_p': 'P',
        'lt_w': 'M',
        'lt_d': 'S',
        'lt_l': 'K',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Peringkat',
        'lt_wp': 'WP',
        'ct_team': 'Tim',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Tolak ukur kekuatan tim',
        'odds_no': 'Tidak ada tolak ukur kekuatan tim',
        'odds_no_data': 'Tidak ada data',
        'odds_handicap': 'Keunggulan',
        'odds_ou': 'Atas/Bawah',
        'odds_1x2': '1x2',
        'odds_over': 'Atas',
        'odds_under': 'Bawah',
        'odds_total': 'Total',
        'odds_more': 'Lebih',
        'odds_company': 'Perusahaan',
        'odds_type': 'Tipe',
        'odds_spot': 'Titik',
        'odds_initial': 'Awal',
        'odds_home_win': 'Kandang',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Tandang',
        'odds_tu': 'Waktu Diperbarui',
        'odds_home_lose': 'Kandang',
        'odds_draw': 'Seri',
        'odds_away_win': 'Tandang',
        'odds_highest': 'Paling tinggi',
        'odds_lowest': 'Terendah',
        'odds_average': 'Rata-rata',
        'odds_changes': 'Perubahan Tolak ukur kekuatan tim',
        'odds_dc': 'Perubahan Detail',
        'Decimal': 'Desimal',
        'American': 'Amerika',
        'Fractional': 'Pecahan',
        'more': 'lebih',
        'matchPredictionTip': 'Tips Pertandingan',
        'matchPredictionResult': 'Prediksi hasil dengan Tips Pertandingan',
        'matchPredictionView': 'Tampilan',
        'matchPredictionFreeChance': 'Anda memiliki <b>{count}</ b> kesempatan untuk check out secara gratis',
        'matchPredictionIncorrect': 'Anda akan mendapatkan kesempatan lain untuk check out secara gratis jika membuat prediksi yang salah'
    },
    'ja': {
        'events': 'イベント',
        'goal': 'ゴール',
        'penalty': 'ペナルティ',
        'penaltySaved': '保存されたパンルティ',
        'ownGoal': '自らの目標',
        'assist': 'アシスト',
        'statistics': '統計',
        'noData': 'データありません',
        'notPrepared': '試合は開始していません。',

        'prediction': 'お客様のチームをサポートします。',
        'vote': '投票',
        'voted': '投票しました。',
        'home': 'ホーム',
        'draw': '描く',
        'away': 'アウェイ',
        'voteNum': '（１回投票）) | ({count} 投票)',
        'voteFail': '投票失敗しました。再度お試しください～',
        'matchVoted': '既に投票済でした。',
        'matchNotStart': '試合は開始していません。',
        'predictionEnd': '予測は終了しました。試合の前に予測するようにご注意ください。',
        'statistic': '統計',
        'broadcast': '放送情報',
        'past_games': '過去ゲーム',
        'pg_no': '過去ゲームがありません。',
        'pg_lng': '過去 {count}ゲーム',
        'pg_w': '{count}W',
        'pg_d': '{count}D',
        'pg_date': '期日',
        'pg_competition': '対戦',
        'pg_home': 'ホーム',
        'pg_result': '結果',
        'pg_away': 'アウェイ',
        'absentee': '欠席',
        'absentee_no': '欠席なし',
        'recent_games': '最近のゲーム',
        'rg_no': '最近のゲームがありません',
        'rg_date': '期日',
        'rg_competition': '対戦',
        'rg_home': 'ホーム',
        'rg_result': '結果',
        'rg_away': 'アウェイ',
        'league_table': '順位表',
        'lt_format': 'フォーマット',
        'lt_total': 'トータル',
        'lt_home': 'ホーム',
        'lt_away': 'アウェイ',
        'lt_p': '試',
        'lt_w': '勝',
        'lt_d': '分',
        'lt_l': '負',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': '勝点',
        'lt_rank': 'ランキング',
        'lt_wp': 'WP',
        'ct_team': 'チーム',
        'ct_p': '試',
        'ct_w': '勝',
        'ct_d': '分',
        'ct_l': '負',
        'ct_fa': 'F/A',
        'ct_pts': '勝点',
        'odds': '勝目',
        'odds_no': '勝目がありません',
        'odds_no_data': 'データがありません',
        'odds_handicap': 'ハンディキャップ',
        'odds_ou': '以上/以下',
        'odds_1x2': '1x2',
        'odds_over': '以上',
        'odds_under': '以下',
        'odds_total': 'トータル',
        'odds_more': 'より多く',
        'odds_company': '会社',
        'odds_type': 'タイプ',
        'odds_spot': 'スポット',
        'odds_initial': 'イニシャル',
        'odds_home_win': 'ホーム',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'アウェイ',
        'odds_tu': '更新された時間',
        'odds_home_lose': 'ホーム',
        'odds_draw': '描く',
        'odds_away_win': 'アウェイ',
        'odds_highest': '一番高い',
        'odds_lowest': '一番低い',
        'odds_average': '平均',
        'odds_changes': '確率の変化',
        'odds_dc': '詳細変更内容',
        'Decimal': '１０進数',
        'American': 'アメリカ',
        'Fractional': '分数',
        'more': 'より多く',
        'matchPredictionTip': '試合のヒント',
        'matchPredictionResult': '試合ヒントによる予測結果',
        'matchPredictionView': 'ビューア',
        'matchPredictionFreeChance': ' 無料で<b>{count}回のチェックアウト</b> チャンス があります。',
        'matchPredictionIncorrect': '弊社は誤りの予測をした場合、別途一回の無料チェックアウトチャンスを提供いたします。'
    },
    'vi': {
        'events': 'Sự kiện',
        'goal': 'Bàn thắng',
        'penalty': 'Phạt đền',
        'penaltySaved': 'Pha cứu thua phạt đền',
        'ownGoal': 'Bàn thắng riêng',
        'assist': 'Hỗ trợ',
        'statistics': 'Số liệu thống kê',
        'noData': 'Không có dữ liệu',
        'notPrepared': 'Trận đấu chưa bắt đầu',

        'prediction': 'Ủng hộ đội của bạn',
        'vote': 'Bầu chọn',
        'voted': 'Đã bầu chọn',
        'home': 'Sân nhà',
        'draw': 'Hòa',
        'away': 'Sân khách',
        'voteNum': '(1 bầu chọn) | ({count} bầu chọn)',
        'voteFail': 'Bầu chọn không thành công, vui lòng thử lại~',
        'matchVoted': 'Bạn đã bầu chọn~',
        'matchNotStart': 'Trận đấu chưa bắt đầu',
        'predictionEnd': 'Kết thúc dự đoán, hãy nhớ dự đoán trước trận đấu',
        'statistic': 'Số liệu thống kê',
        'broadcast': 'Thông tin Phát sóng',
        'past_games': 'Các Trận đấu trước',
        'pg_no': 'Không có trận đấu trước',
        'pg_lng': 'Những trận {count} gần nhất',
        'pg_w': '{count} T.',
        'pg_d': '{count} H.',
        'pg_date': 'Ngày',
        'pg_competition': 'Cuộc thi đấu',
        'pg_home': 'Sân nhà',
        'pg_result': 'Kết quả',
        'pg_away': 'Sân khách',
        'absentee': 'Người vắng mặt',
        'absentee_no': 'Không có người vắng mặt',
        'recent_games': 'Những trận đấu gần đây',
        'rg_no': 'Không có trận đấu gần đây',
        'rg_date': 'Ngày',
        'rg_competition': 'Cuộc thi đấu',
        'rg_home': 'Sân nhà',
        'rg_result': 'Kết quả',
        'rg_away': 'Sân khách',
        'league_table': 'Bảng Vị trí Thi đấu',
        'lt_format': 'Định dạng',
        'lt_total': 'Tổng ',
        'lt_home': 'Sân nhà',
        'lt_away': 'Sân khách',
        'lt_p': 'S.T.',
        'lt_w': 'T.',
        'lt_d': 'H.',
        'lt_l': 'B',
        'lt_f': 'B.Tg.',
        'lt_a': 'B.Th.',
        'lt_pts': 'Đ.',
        'lt_rank': 'Xếp hạng',
        'lt_wp': 'WP',
        'ct_team': 'Đội',
        'ct_p': 'S.T.',
        'ct_w': 'T.',
        'ct_d': 'H.',
        'ct_l': 'B.',
        'ct_fa': 'F/A',
        'ct_pts': 'Đ.',
        'odds': 'Lợi thế',
        'odds_no': 'Không có lợi thế',
        'odds_no_data': 'Không có dữ liệu',
        'odds_handicap': 'Bất lợi',
        'odds_ou': 'Trên/Dưới',
        'odds_1x2': '1x2',
        'odds_over': 'Trên',
        'odds_under': 'Dưới',
        'odds_total': 'Tổng',
        'odds_more': 'Hơn',
        'odds_company': 'Công ty',
        'odds_type': 'Loại',
        'odds_spot': 'Điểm',
        'odds_initial': 'Ban đầu',
        'odds_home_win': 'Sân nhà',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Sân khách',
        'odds_tu': 'Thời gian cập nhật',
        'odds_home_lose': 'Sân nhà',
        'odds_draw': 'Hòa',
        'odds_away_win': 'Sân khách',
        'odds_highest': 'Cao nhất',
        'odds_lowest': 'Thấp nhất',
        'odds_average': 'Trung bình',
        'odds_changes': 'Thay đổi lợi thế',
        'odds_dc': 'Chi tiết thay đổi',
        'Decimal': 'Phần thập phân',
        'American': 'Người Mỹ',
        'Fractional': 'Phân số',
        'more': 'hơn',
        'matchPredictionTip': 'Thủ thuật trận đấu',
        'matchPredictionResult': 'Kết quả dự đoán theo thủ thuật trận đấu',
        'matchPredictionView': 'Xem',
        'matchPredictionFreeChance': 'Bạn có <b> {count} </ b> cơ hội thanh toán miễn phí',
        'matchPredictionIncorrect': 'Bạn sẽ có cơ hội khác để thanh toán miễn phí nếu chúng tôi đưa ra dự đoán không chính xác'
    },
    'ar': {
        'events': 'فعاليات',
        'goal': 'هدف',
        'penalty': 'ركلة جزاء',
        'penaltySaved': 'ركلة جزاء مصدودة',
        'ownGoal': 'هدف عكسي',
        'assist': 'صناعة هدف',
        'statistics': 'إحصائيات',
        'noData': 'لا توجد بيانات',
        'notPrepared': 'المباراة لم تبدأ',

        'prediction': 'ادعم فريقك',
        'vote': 'تصويت',
        'voted': 'تم التصويت',
        'home': 'على ملعبه',
        'draw': 'تعادل',
        'away': 'خارج ملعبه',
        'voteNum': '(1 صوت) | ({count} أصوات)',
        'voteFail': 'فشل التصويت، يُرجى إعادة المحاولة~',
        'matchVoted': 'قمت بالتصويت بالفعل~',
        'matchNotStart': 'المباراة لم تبدأ',
        'predictionEnd': 'انتهت فترة التوقع، تذكر أن تقدم توقعك قبل المباراة',
        'statistic': 'إحصائيات',
        'broadcast': 'معلومات البث',
        'past_games': 'مباريات سابقة',
        'pg_no': 'لا توجد مباريات سابقة',
        'pg_lng': 'آخر {count} مباراة',
        'pg_w': '{count} فوز',
        'pg_d': '{count} تعادل',
        'pg_date': 'تاريخ',
        'pg_competition': 'منافسة',
        'pg_home': 'على ملعبه',
        'pg_result': 'نتيجة',
        'pg_away': 'خارج ملعبه',
        'absentee': 'غيابات',
        'absentee_no': 'لا توجد غيابات',
        'recent_games': 'المباريات الحالية',
        'rg_no': ' توجد مباريات حالية',
        'rg_date': 'تاريخ',
        'rg_competition': 'منافسة',
        'rg_home': 'على ملعبه',
        'rg_result': 'نتيجة',
        'rg_away': 'خارج ملعبه',
        'league_table': 'جدول الدوري',
        'lt_format': 'التشكيل',
        'lt_total': 'إجمالي',
        'lt_home': 'على ملعبه',
        'lt_away': 'خارج ملعبه',
        'lt_p': 'لعب',
        'lt_w': 'فوز',
        'lt_d': 'تعادل',
        'lt_l': 'هزيمة',
        'lt_f': 'أهداف له',
        'lt_a': 'أهداف عليه',
        'lt_pts': 'النقاط',
        'lt_rank': 'التصنيف',
        'lt_wp': 'النقاط المحصَّلة',
        'ct_team': 'الفريق',
        'ct_p': 'لعب',
        'ct_w': 'فوز',
        'ct_d': 'تعادل',
        'ct_l': 'هزيمة',
        'ct_fa': 'أهداف له/أهداف عليه',
        'ct_pts': 'النقاط',
        'odds': 'احتمالات',
        'odds_no': 'لا توجد احتمالات',
        'odds_no_data': 'لا توجد بيانات',
        'odds_handicap': 'هانديكاب',
        'odds_ou': 'أكثر/أقل',
        'odds_1x2': '1x2',
        'odds_over': 'أكثر',
        'odds_under': 'أقل',
        'odds_total': 'إجمالي',
        'odds_more': 'المزيد',
        'odds_company': 'شركة',
        'odds_type': 'نوع',
        'odds_spot': 'نقطة اللعب',
        'odds_initial': 'أولي',
        'odds_home_win': 'على ملعبه',
        'odds_hdp': 'هانديكاب',
        'odds_away_lose': 'خارج ملعبه',
        'odds_tu': 'تحديث الوقت',
        'odds_home_lose': 'على ملعبه',
        'odds_draw': 'تعادل',
        'odds_away_win': 'خارج ملعبه',
        'odds_highest': 'أعلى',
        'odds_lowest': 'أدنى',
        'odds_average': 'متوسط',
        'odds_changes': 'تغييرات الاحتمالات',
        'odds_dc': 'تغييرات التفاصيل',
        'Decimal': 'رقم عشري',
        'American': 'أمريكي',
        'Fractional': 'رقم كسري',
        'more': 'المزيد',
        'matchPredictionTip': 'نصائح المباراة',
        'matchPredictionResult': 'النتائج المتوقعة من خلال نصائح المباراة',
        'matchPredictionView': 'عرض',
        'matchPredictionFreeChance': 'لديك <b>{count}</b> فرصة (فرص)، تحقق منها مجانًا',
        'matchPredictionIncorrect': 'ستحصل على فرصة أخرى للتحقق من ذلك مجانًا إذا قمنا بتوقع غير صحيح'
    }
};

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/videoMatchBannerBg.42eb49b.jpg";

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fab71ee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("7a5c3a38", content, true);

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".nav[data-v-0fab71ee]{margin:0;padding:0;height:2.4rem;background:var(--mainColor);line-height:2.4rem;overflow:hidden}.nav a[data-v-0fab71ee]{width:24.3%;text-align:center;color:#fff;font-size:.9rem;float:left;text-decoration:none!important;position:relative;height:1.4rem;line-height:1.4rem;padding:.5rem 0;overflow:hidden;font-weight:700;-webkit-tap-highlight-color:rgba(0,0,0,0)}.selected[data-v-0fab71ee]{display:inline-block;width:.5rem;height:.4rem;line-height:1.2rem;background:url(" + __webpack_require__(503) + ") no-repeat;background-size:100% auto;position:absolute;bottom:-.1rem;left:50%;margin-left:-.2rem;z-index:10}.newsSubTit[data-v-0fab71ee]{height:2.2rem;width:100%;font-size:.68rem;line-height:2.5rem;text-align:center;color:#2d2f32;border-bottom:.01rem solid #eff1f4;background:#fff}.newsSubTit p[data-v-0fab71ee]{height:2.4rem;overflow:scroll;white-space:nowrap;padding:0 .8rem;position:relative;top:0;-webkit-overflow-scrolling:touch}[data-v-0fab71ee]:not(html){-webkit-transform:translateZ(0)}.newsSubTit a[data-v-0fab71ee]{display:inline-block;padding:0 .7rem;position:relative;height:1.1rem;line-height:1.1rem;padding:.3rem .7rem;color:inherit;font-size:.9rem;-webkit-tap-highlight-color:rgba(0,0,0,0)}.newsSubTit p[data-v-0fab71ee]::-webkit-scrollbar{display:none}.subTitSelected[data-v-0fab71ee]{color:var(--mainColor)!important;border-bottom:.15rem solid var(--mainColor)}.thirdTitwrap[data-v-0fab71ee]{height:3.2rem;background:#333d46;overflow:hidden;color:#929cad}.thirdTit[data-v-0fab71ee]{height:1.5rem;width:94%;margin:.8rem auto;line-height:1.5rem;border:1px solid #1d2328;border-radius:.01rem}.thirdTit a[data-v-0fab71ee]{width:25%;color:#929cad;float:left;text-align:center;border-right:1px solid #1d2328;text-decoration:none;box-sizing:border-box;height:1.5rem;line-height:1.5rem;font-size:.8rem}.thirdTit>a.thirdTitSelected[data-v-0fab71ee]{background:#1d2328!important;color:#fff!important}.thirdTit>a[data-v-0fab71ee]:last-of-type{border-right:none}.topFixedWrap[data-v-0fab71ee]{width:100%;z-index:100;position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0}.main>.tab-box-fixed[data-v-0fab71ee]{position:fixed!important;z-index:10;top:0;left:0}.main>.tab-box-testFix[data-v-0fab71ee]{z-index:10;top:0;left:0}.tab-box-sticky[data-v-0fab71ee]{position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0;left:0;z-index:10}.pad[data-v-0fab71ee]{margin:0 3rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/nav.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,UAAW,AACX,cAAe,AACf,4BAA6B,AAC7B,mBAAoB,AACpB,eAAiB,CAClB,AACD,wBACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,gBAAkB,AAClB,WAAY,AACZ,+BAAiC,AACjC,kBAAmB,AACnB,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,AAClB,yCAA8C,CAC/C,AACD,2BACE,qBAAsB,AACtB,YAAa,AACb,aAAc,AACd,mBAAoB,AACpB,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,cAAgB,AAChB,SAAU,AACV,mBAAqB,AACrB,UAAY,CACb,AACD,6BACE,cAAe,AACf,WAAY,AACZ,iBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,cAAe,AACf,mCAAqC,AACrC,eAAiB,CAClB,AACD,+BACE,cAAe,AACf,gBAAiB,AACjB,mBAAoB,AACpB,gBAAiB,AACjB,kBAAmB,AACnB,MAAU,AACV,gCAAkC,CACnC,AACD,4BACE,+BAAwC,CACzC,AACD,+BACE,qBAAsB,AACtB,gBAAiB,AACjB,kBAAmB,AACnB,cAAe,AACf,mBAAoB,AACpB,oBAAqB,AACrB,cAAe,AACf,gBAAiB,AACjB,yCAA8C,CAC/C,AACD,kDACE,YAAc,CACf,AACD,iCACE,iCAAmC,AACnC,2CAA8C,CAC/C,AAED,+BACE,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,aAAe,CAChB,AACD,2BACE,cAAe,AACf,UAAW,AACX,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,oBAAuB,CACxB,AACD,6BACE,UAAW,AACX,cAAe,AAEf,WAAY,AACZ,kBAAmB,AACnB,+BAAgC,AAChC,qBAAsB,AACtB,sBAAuB,AACvB,cAAe,AACf,mBAAoB,AACpB,eAAiB,CAClB,AACD,8CACE,6BAA+B,AAC/B,oBAAuB,CACxB,AACD,0CACE,iBAAmB,CACpB,AAED,+BACE,WAAY,AACZ,YAAa,AACb,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,KAAU,CACX,AACD,sCACE,yBAA2B,AAC3B,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,wCACE,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,iCACE,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AACD,sBACE,aAAe,CAChB","file":"nav.vue","sourcesContent":["\n.nav[data-v-0fab71ee] {\n  margin: 0;\n  padding: 0;\n  height: 2.4rem;\n  background: var(--mainColor);\n  line-height: 2.4rem;\n  overflow: hidden;\n}\n.nav a[data-v-0fab71ee] {\n  width: 24.3%;\n  text-align: center;\n  color: #fff;\n  font-size: 0.9rem;\n  float: left;\n  text-decoration: none !important;\n  position: relative;\n  height: 1.4rem;\n  line-height: 1.4rem;\n  padding: .5rem 0;\n  overflow: hidden;\n  font-weight: bold;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.selected[data-v-0fab71ee] {\n  display: inline-block;\n  width: .5rem;\n  height: .4rem;\n  line-height: 1.2rem;\n  background: url(\"../assets/home/home_arrow.png\") no-repeat;\n  background-size: 100% auto;\n  position: absolute;\n  bottom: -0.1rem;\n  left: 50%;\n  margin-left: -0.2rem;\n  z-index: 10;\n}\n.newsSubTit[data-v-0fab71ee] {\n  height: 2.2rem;\n  width: 100%;\n  font-size: 0.68rem;\n  line-height: 2.5rem;\n  text-align: center;\n  color: #2d2f32;\n  border-bottom: 0.01rem solid #eff1f4;\n  background: #fff;\n}\n.newsSubTit p[data-v-0fab71ee] {\n  height: 2.4rem;\n  overflow: scroll;\n  white-space: nowrap;\n  padding: 0 .8rem;\n  position: relative;\n  top: 0rem;\n  -webkit-overflow-scrolling: touch;\n}\n*[data-v-0fab71ee]:not(html) {\n  -webkit-transform: translate3d(0, 0, 0);\n}\n.newsSubTit a[data-v-0fab71ee] {\n  display: inline-block;\n  padding: 0 .7rem;\n  position: relative;\n  height: 1.1rem;\n  line-height: 1.1rem;\n  padding: .3rem .7rem;\n  color: inherit;\n  font-size: .9rem;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.newsSubTit p[data-v-0fab71ee]::-webkit-scrollbar {\n  display: none;\n}\n.subTitSelected[data-v-0fab71ee] {\n  color: var(--mainColor) !important;\n  border-bottom: 0.15rem solid var(--mainColor);\n}\n/*stat 三级导航*/\n.thirdTitwrap[data-v-0fab71ee] {\n  height: 3.2rem;\n  background: #333d46;\n  overflow: hidden;\n  color: #929cad;\n}\n.thirdTit[data-v-0fab71ee] {\n  height: 1.5rem;\n  width: 94%;\n  margin: .8rem auto;\n  line-height: 1.5rem;\n  border: 1px solid #1d2328;\n  border-radius: 0.01rem;\n}\n.thirdTit a[data-v-0fab71ee] {\n  width: 25%;\n  color: #929cad;\n  /*display: inline-block;*/\n  float: left;\n  text-align: center;\n  border-right: 1px solid #1d2328;\n  text-decoration: none;\n  box-sizing: border-box;\n  height: 1.5rem;\n  line-height: 1.5rem;\n  font-size: .8rem;\n}\n.thirdTit > a.thirdTitSelected[data-v-0fab71ee] {\n  background: #1d2328 !important;\n  color: #fff !important;\n}\n.thirdTit > a[data-v-0fab71ee]:last-of-type {\n  border-right: none;\n}\n/*定位*/\n.topFixedWrap[data-v-0fab71ee] {\n  width: 100%;\n  z-index: 100;\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0rem;\n}\n.main > .tab-box-fixed[data-v-0fab71ee] {\n  position: fixed !important;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.main > .tab-box-testFix[data-v-0fab71ee] {\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.tab-box-sticky[data-v-0fab71ee] {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.pad[data-v-0fab71ee] {\n  margin: 0 3rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'navVue',
    props: ['subtitleData', 'navSelected', 'isThirdTit', 'pad', 'loadingShowProp'],
    data: function data() {
        return {
            subtitChoose: '',
            subtitData: [],
            thirdTotalTitle: [],
            thirdTotalTitInfor: [],
            thirdTitChoose: '',
            navMap: {
                'NEWS': '/home',
                'MATCH': '/match',
                'VIDEO': '/video',
                'STATS': '/stats'
            },
            currentListData: [],
            loading: false,
            subNavTranslateX: function subNavTranslateX() {},
            stickyFn: function stickyFn() {},
            googlePlayUrl: 'intent://open/#Intent;scheme=allfootball;package=com.allfootball.news;end',
            isExternalAccess: null
        };
    },
    methods: {
        showDefaultSubtitle: function showDefaultSubtitle() {
            var _this = this;

            if (!this.isThirdTit) {
                this.subtitle = this.$route.params.subtitle && this.$route.params.subtitle.replace(/-/g, ' ');

                if (this.subtitle) {
                    this.subtitChoose = this.subtitle;
                    this.subtitleData.forEach(function (elem, index) {
                        if (elem.label == _this.subtitle) {
                            _this.getDataUrlApi = elem.urlApi;
                        }
                    });
                } else {
                    this.subtitChoose = this.subtitleData[0].label;
                    this.getDataUrlApi = this.subtitleData[0].urlApi;
                }
                this.subNavEmit();
            } else {
                this.subtitle = this.$route.params.subtitle && this.$route.params.subtitle.replace(/-/g, ' ');
                if (this.subtitle) {
                    this.subtitChoose = this.subtitle;
                    this.subtitleData.forEach(function (elem, index) {
                        if (elem.label == _this.subtitle) {
                            elem.urlApi.forEach(function (m, n) {
                                var infor = { 'ThirdLabel': m.title, 'ThirdLabelUrl': m.url };
                                _this.thirdTotalTitle.push(m.title);
                                _this.thirdTotalTitInfor.push(infor);
                            });
                            _this.getDataUrlApi = elem.urlApi[0].url;
                            _this.thirdTitChoose = elem.urlApi[0].title;
                        }
                    });
                } else {
                    this.subtitleData[0].urlApi.forEach(function (elem, index) {
                        var infor = { 'ThirdLabel': elem.title, 'ThirdLabelUrl': elem.url };
                        _this.thirdTotalTitle.push(elem.title);
                        _this.thirdTotalTitInfor.push(infor);
                    });
                    this.subtitChoose = this.subtitleData[0].label;
                    this.thirdTitChoose = this.subtitleData[0].urlApi[0].title;
                    this.getDataUrlApi = this.subtitleData[0].urlApi[0].url;
                }
                this.subNavEmit();
            }
        },
        subNavEmit: function subNavEmit() {
            this.$emit('subNavDataFromchild', {
                loadingShowObj: true,
                noDataModeObj: false,
                tabTagObj: false,
                goalTagObj: false,
                assTagObj: false,
                fixtureTagObj: false,
                subtitChooseObj: this.subtitChoose,
                thirdTitChooseObj: this.thirdTitChoose,
                getDataUrlApiObj: this.getDataUrlApi.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '')
            });
        },
        thirdNavEmit: function thirdNavEmit() {
            this.$emit('thirdNavDataFromchild', {
                loadingShowObj: true,
                noDataModeObj: false,
                tabTagObj: false,
                goalTagObj: false,
                assTagObj: false,
                fixtureTagObj: false,
                thirdTitChooseObj: this.thirdTitChoose,
                thirdTitChooseUrl: this.thirdTitChooseUrl.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '')
            });
        },
        subTitToggle: function subTitToggle(item, index) {
            var _this2 = this;

            if (this.loadingShowProp) return;
            if (this.subtitChoose == item.label) return;
            if (!this.isThirdTit) {
                console.log('****999****');
                this.subNavTranslateX(index);

                var subTitle = this.getUrlTitle(item.label);
                if (this.$route.params.subtitle) {
                    history.replaceState(null, null, './' + subTitle);
                } else {
                    history.replaceState(null, null, this.$route.path + '/' + subTitle);
                }
                this.scrollFn(item.label);

                this.subtitChoose = item.label;

                this.getDataUrlApi = item.urlApi;
                this.subNavEmit();
            } else {
                console.log('101010');
                this.subNavTranslateX(index);

                var _subTitle = this.getUrlTitle(item.label);
                if (this.$route.params.subtitle) {
                    history.replaceState(null, null, './' + _subTitle);
                } else {
                    history.replaceState(null, null, this.$route.path + '/' + _subTitle);
                }
                this.scrollFn(item.label);

                this.subtitChoose = item.label;

                this.getDataUrlApi = item.urlApi[0].url;
                this.thirdTotalTitle = [];

                item.urlApi.forEach(function (elem, i) {
                    var infor = { 'ThirdLabel': elem.title, 'ThirdLabelUrl': elem.url };
                    _this2.thirdTotalTitle.push(elem.title);
                    _this2.thirdTotalTitInfor.push(infor);
                });
                this.thirdTitChoose = this.thirdTotalTitle[0];
                this.thirdTitChooseUrl = this.thirdTotalTitle[0];
                this.subNavEmit();
            }
        },
        thirdTitleToggle: function thirdTitleToggle(elem, index) {
            var _this3 = this;

            if (this.loadingShowProp) return;
            if (this.thirdTitChoose == elem) return;
            this.scrollFn(this.subtitChoose);
            this.thirdTitChoose = elem;
            this.thirdTotalTitInfor.forEach(function (e, i) {
                if (elem === e.ThirdLabel) {
                    _this3.thirdTitChooseUrl = e.ThirdLabelUrl;
                }
            });
            this.thirdNavEmit();
        },
        titleName: function titleName() {
            if (this.subtitChoose == 'Headline') {
                document.title = 'All Football - Live Scores, News, Videos & Highlights';
            } else {
                document.title = 'All Football - ' + this.subtitChoose + ' Live Scores, News, Videos & Highlights';
            }
        },
        scrollFn: function scrollFn(label) {
            var that = this;
            window.browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);

            var headwrap = document.getElementById('headwrap');
            var headHeight = headwrap.offsetHeight;
            var topFixedWrap = document.getElementById('topFixedWrap');
            var topFixedWrapHeight = topFixedWrap.offsetHeight;
            var contentWrap = document.getElementById('contentWrap');
            if (document.body.scrollTop || document.documentElement.scrollTop >= headwrap.offsetHeight) {
                console.log('*隐藏了下载引导模块');
                this.downLoadHeaderShow = false;
                setTimeout(function () {
                    that.downLoadHeaderShow = true;
                }, 10);
                if (browers.Android) {
                    console.log('*********');

                    topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                    setTimeout(function () {
                        topFixedWrap.className = 'topFixedWrap';
                    }, 10);
                    contentWrap.style.paddingTop = 0 + 'px';
                    console.log(contentWrap.style.paddingTop);
                } else if (browers.iOS) {
                    console.log('&&&&&&&&');
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }

                setTimeout(function () {
                    console.log('**滚了 ', headHeight);
                    document.body.scrollTop = headHeight;
                    document.documentElement.scrollTop = headHeight;
                }, 10);
                console.log('document.body.scrollTop:' + document.body.scrollTop);
            } else {
                if (browers.Android) {
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }
            }
        }
    },
    watch: {
        subtitleData: function subtitleData() {
            this.showDefaultSubtitle();
        }
    },
    created: function created() {},
    mounted: function mounted() {
        this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1;
        if (this.isExternalAccess) {
            __webpack_require__.e/* import() */(20/* duplicate */).then(__webpack_require__.bind(null, 501)).then(function (module) {
                console.log('module', module);
            });
        } else {
            __webpack_require__.e/* import() */(19/* duplicate */).then(__webpack_require__.bind(null, 502)).then(function (module) {});
        }
        this.subNavTranslateX = function (index) {
            var scrollBar = document.getElementById('scroll');
            var scrollBarTab = scrollBar.querySelectorAll('a');
            var screenWidth = document.documentElement.clientWidth;
            this.scrollLeft = scrollBar.scrollLeft;
            this.leftToScreen = scrollBarTab[index].getBoundingClientRect().left;
            this.rightToScreen = screenWidth - (this.leftToScreen + scrollBarTab[index].getBoundingClientRect().width);
            var average = (this.leftToScreen + this.rightToScreen) / 2;
            if (this.leftToScreen < this.rightToScreen) {
                scrollBar.scrollLeft -= average - this.leftToScreen;
            } else {
                scrollBar.scrollLeft += average - this.rightToScreen;
            }
        };
    }
});

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topFixedWrap",
    attrs: {
      "id": "topFixedWrap"
    }
  }, [_c('nav', {
    staticClass: "nav"
  }, _vm._l((_vm.navMap), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": item
      }
    }, [(_vm.navSelected == index) ? _c('span', {
      staticClass: "selected"
    }) : _vm._e(), _vm._v(_vm._s(index) + "\n        ")])
  })), _vm._v(" "), _c('nav', {
    staticClass: "newsSubTit"
  }, [_c('p', {
    staticClass: "newTit",
    attrs: {
      "id": "scroll"
    }
  }, _vm._l((_vm.subtitleData), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        'subTitSelected': _vm.subtitChoose == item.label, 'pad': _vm.pad
      },
      attrs: {
        "href": ("/" + (_vm.getUrlTitle(_vm.navMap[_vm.navSelected])) + "/" + (_vm.getUrlTitle(item.label)))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.subTitToggle(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))]), _vm._v(" "), (_vm.isThirdTit) ? _c('nav', {
    staticClass: "thirdTitwrap"
  }, [_c('div', {
    staticClass: "thirdTit"
  }, _vm._l((_vm.thirdTotalTitle), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        'thirdTitSelected': _vm.thirdTitChoose == item
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.thirdTitleToggle(item, index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(590);
var objectAssign = __webpack_require__(591);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license Fraction.js v4.0.8 09/09/2015
 * http://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2015, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/


/**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <nominator>, 1 => <denominator> ]
 * [ n => <nominator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */

(function(root) {

  "use strict";

  // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
  // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
  // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
  var MAX_CYCLE_LEN = 2000;

  // Parsed data to avoid calling "new" all the time
  var P = {
    "s": 1,
    "n": 0,
    "d": 1
  };

  function createError(name) {

    function errorConstructor() {
      var temp = Error.apply(this, arguments);
      temp['name'] = this['name'] = name;
      this['stack'] = temp['stack'];
      this['message'] = temp['message'];
    }

    /**
     * Error constructor
     *
     * @constructor
     */
    function IntermediateInheritor() {}
    IntermediateInheritor.prototype = Error.prototype;
    errorConstructor.prototype = new IntermediateInheritor();

    return errorConstructor;
  }

  var DivisionByZero = Fraction['DivisionByZero'] = createError('DivisionByZero');
  var InvalidParameter = Fraction['InvalidParameter'] = createError('InvalidParameter');

  function assign(n, s) {

    if (isNaN(n = parseInt(n, 10))) {
      throwInvalidParam();
    }
    return n * s;
  }

  function throwInvalidParam() {
    throw new InvalidParameter();
  }

  var parse = function(p1, p2) {

    var n = 0, d = 1, s = 1;
    var v = 0, w = 0, x = 0, y = 1, z = 1;

    var A = 0, B = 1;
    var C = 1, D = 1;

    var N = 10000000;
    var M;

    if (p1 === undefined || p1 === null) {
      /* void */
    } else if (p2 !== undefined) {
      n = p1;
      d = p2;
      s = n * d;
    } else
      switch (typeof p1) {

        case "object":
        {
          if ("d" in p1 && "n" in p1) {
            n = p1["n"];
            d = p1["d"];
            if ("s" in p1)
              n *= p1["s"];
          } else if (0 in p1) {
            n = p1[0];
            if (1 in p1)
              d = p1[1];
          } else {
            throwInvalidParam();
          }
          s = n * d;
          break;
        }
        case "number":
        {
          if (p1 < 0) {
            s = p1;
            p1 = -p1;
          }

          if (p1 % 1 === 0) {
            n = p1;
          } else if (p1 > 0) { // check for != 0, scale would become NaN (log(0)), which converges really slow

            if (p1 >= 1) {
              z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
              p1 /= z;
            }

            // Using Farey Sequences
            // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/

            while (B <= N && D <= N) {
              M = (A + C) / (B + D);

              if (p1 === M) {
                if (B + D <= N) {
                  n = A + C;
                  d = B + D;
                } else if (D > B) {
                  n = C;
                  d = D;
                } else {
                  n = A;
                  d = B;
                }
                break;

              } else {

                if (p1 > M) {
                  A += C;
                  B += D;
                } else {
                  C += A;
                  D += B;
                }

                if (B > N) {
                  n = C;
                  d = D;
                } else {
                  n = A;
                  d = B;
                }
              }
            }
            n *= z;
          } else if (isNaN(p1) || isNaN(p2)) {
            d = n = NaN;
          }
          break;
        }
        case "string":
        {
          B = p1.match(/\d+|./g);

          if (B === null)
            throwInvalidParam();

          if (B[A] === '-') {// Check for minus sign at the beginning
            s = -1;
            A++;
          } else if (B[A] === '+') {// Check for plus sign at the beginning
            A++;
          }

          if (B.length === A + 1) { // Check if it's just a simple number "1234"
            w = assign(B[A++], s);
          } else if (B[A + 1] === '.' || B[A] === '.') { // Check if it's a decimal number

            if (B[A] !== '.') { // Handle 0.5 and .5
              v = assign(B[A++], s);
            }
            A++;

            // Check for decimal places
            if (A + 1 === B.length || B[A + 1] === '(' && B[A + 3] === ')' || B[A + 1] === "'" && B[A + 3] === "'") {
              w = assign(B[A], s);
              y = Math.pow(10, B[A].length);
              A++;
            }

            // Check for repeating places
            if (B[A] === '(' && B[A + 2] === ')' || B[A] === "'" && B[A + 2] === "'") {
              x = assign(B[A + 1], s);
              z = Math.pow(10, B[A + 1].length) - 1;
              A += 3;
            }

          } else if (B[A + 1] === '/' || B[A + 1] === ':') { // Check for a simple fraction "123/456" or "123:456"
            w = assign(B[A], s);
            y = assign(B[A + 2], 1);
            A += 3;
          } else if (B[A + 3] === '/' && B[A + 1] === ' ') { // Check for a complex fraction "123 1/2"
            v = assign(B[A], s);
            w = assign(B[A + 2], s);
            y = assign(B[A + 4], 1);
            A += 5;
          }

          if (B.length <= A) { // Check for more tokens on the stack
            d = y * z;
            s = /* void */
                    n = x + d * v + z * w;
            break;
          }

          /* Fall through on error */
        }
        default:
          throwInvalidParam();
      }

    if (d === 0) {
      throw new DivisionByZero();
    }

    P["s"] = s < 0 ? -1 : 1;
    P["n"] = Math.abs(n);
    P["d"] = Math.abs(d);
  };

  function modpow(b, e, m) {

    var r = 1;
    for (; e > 0; b = (b * b) % m, e >>= 1) {

      if (e & 1) {
        r = (r * b) % m;
      }
    }
    return r;
  }


  function cycleLen(n, d) {

    for (; d % 2 === 0;
            d /= 2) {
    }

    for (; d % 5 === 0;
            d /= 5) {
    }

    if (d === 1) // Catch non-cyclic numbers
      return 0;

    // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
    // 10^(d-1) % d == 1
    // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
    // as we want to translate the numbers to strings.

    var rem = 10 % d;
    var t = 1;

    for (; rem !== 1; t++) {
      rem = rem * 10 % d;

      if (t > MAX_CYCLE_LEN)
        return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
    }
    return t;
  }


     function cycleStart(n, d, len) {

    var rem1 = 1;
    var rem2 = modpow(10, len, d);

    for (var t = 0; t < 300; t++) { // s < ~log10(Number.MAX_VALUE)
      // Solve 10^s == 10^(s+t) (mod d)

      if (rem1 === rem2)
        return t;

      rem1 = rem1 * 10 % d;
      rem2 = rem2 * 10 % d;
    }
    return 0;
  }

  function gcd(a, b) {

    if (!a)
      return b;
    if (!b)
      return a;

    while (1) {
      a %= b;
      if (!a)
        return b;
      b %= a;
      if (!b)
        return a;
    }
  };

  /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */
  function Fraction(a, b) {

    if (!(this instanceof Fraction)) {
      return new Fraction(a, b);
    }

    parse(a, b);

    if (Fraction['REDUCE']) {
      a = gcd(P["d"], P["n"]); // Abuse a
    } else {
      a = 1;
    }

    this["s"] = P["s"];
    this["n"] = P["n"] / a;
    this["d"] = P["d"] / a;
  }

  /**
   * Boolean global variable to be able to disable automatic reduction of the fraction
   *
   */
  Fraction['REDUCE'] = 1;

  Fraction.prototype = {

    "s": 1,
    "n": 0,
    "d": 1,

    /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/
    "abs": function() {

      return new Fraction(this["n"], this["d"]);
    },

    /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/
    "neg": function() {

      return new Fraction(-this["s"] * this["n"], this["d"]);
    },

    /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/
    "add": function(a, b) {

      parse(a, b);
      return new Fraction(
              this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"],
              this["d"] * P["d"]
              );
    },

    /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/
    "sub": function(a, b) {

      parse(a, b);
      return new Fraction(
              this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"],
              this["d"] * P["d"]
              );
    },

    /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/
    "mul": function(a, b) {

      parse(a, b);
      return new Fraction(
              this["s"] * P["s"] * this["n"] * P["n"],
              this["d"] * P["d"]
              );
    },

    /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/
    "div": function(a, b) {

      parse(a, b);
      return new Fraction(
              this["s"] * P["s"] * this["n"] * P["d"],
              this["d"] * P["n"]
              );
    },

    /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/
    "clone": function() {
      return new Fraction(this);
    },

    /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/
    "mod": function(a, b) {

      if (isNaN(this['n']) || isNaN(this['d'])) {
        return new Fraction(NaN);
      }

      if (a === undefined) {
        return new Fraction(this["s"] * this["n"] % this["d"], 1);
      }

      parse(a, b);
      if (0 === P["n"] && 0 === this["d"]) {
        Fraction(0, 0); // Throw DivisionByZero
      }

      /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/

      /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */
      return new Fraction(
              this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]),
              P["d"] * this["d"]
              );
    },

    /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */
    "gcd": function(a, b) {

      parse(a, b);

      // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)

      return new Fraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
    },

    /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */
    "lcm": function(a, b) {

      parse(a, b);

      // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)

      if (P["n"] === 0 && this["n"] === 0) {
        return new Fraction;
      }
      return new Fraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
    },

    /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/
    "ceil": function(places) {

      places = Math.pow(10, places || 0);

      if (isNaN(this["n"]) || isNaN(this["d"])) {
        return new Fraction(NaN);
      }
      return new Fraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
    },

    /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/
    "floor": function(places) {

      places = Math.pow(10, places || 0);

      if (isNaN(this["n"]) || isNaN(this["d"])) {
        return new Fraction(NaN);
      }
      return new Fraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
    },

    /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/
    "round": function(places) {

      places = Math.pow(10, places || 0);

      if (isNaN(this["n"]) || isNaN(this["d"])) {
        return new Fraction(NaN);
      }
      return new Fraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
    },

    /**
     * Gets the inverse of the fraction, means numerator and denumerator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/
    "inverse": function() {

      return new Fraction(this["s"] * this["d"], this["n"]);
    },

    /**
     * Calculates the fraction to some integer exponent
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */
    "pow": function(m) {

      if (m < 0) {
        return new Fraction(Math.pow(this['s'] * this["d"], -m), Math.pow(this["n"], -m));
      } else {
        return new Fraction(Math.pow(this['s'] * this["n"], m), Math.pow(this["d"], m));
      }
    },

    /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/
    "equals": function(a, b) {

      parse(a, b);
      return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
    },

    /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/
    "compare": function(a, b) {

      parse(a, b);
      var t = (this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"]);
      return (0 < t) - (t < 0);
    },
    
    "simplify": function(eps) {
      
      // First naive implementation, needs improvement
      
      if (isNaN(this['n']) || isNaN(this['d'])) {
        return this;
      }

      var cont = this['abs']()['toContinued']();
      
      eps = eps || 0.001;
      
      function rec(a) {
        if (a.length === 1)
          return new Fraction(a[0]);
        return rec(a.slice(1))['inverse']()['add'](a[0]);
      }
      
      for (var i = 0; i < cont.length; i++) {
        var tmp = rec(cont.slice(0, i + 1));
        if (tmp['sub'](this['abs']())['abs']().valueOf() < eps) {
          return tmp['mul'](this['s']);
        }
      }
      return this;
    },

    /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */
    "divisible": function(a, b) {

      parse(a, b);
      return !(!(P["n"] * this["d"]) || ((this["n"] * P["d"]) % (P["n"] * this["d"])));
    },

    /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/
    'valueOf': function() {

      return this["s"] * this["n"] / this["d"];
    },

    /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction() => "4 1/3"
     **/
    'toFraction': function(excludeWhole) {

      var whole, str = "";
      var n = this["n"];
      var d = this["d"];
      if (this["s"] < 0) {
        str += '-';
      }

      if (d === 1) {
        str += n;
      } else {

        if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
          str += whole;
          str += " ";
          n %= d;
        }

        str += n;
        str += '/';
        str += d;
      }
      return str;
    },

    /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/
    'toLatex': function(excludeWhole) {

      var whole, str = "";
      var n = this["n"];
      var d = this["d"];
      if (this["s"] < 0) {
        str += '-';
      }

      if (d === 1) {
        str += n;
      } else {

        if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
          str += whole;
          n %= d;
        }

        str += "\\frac{";
        str += n;
        str += '}{';
        str += d;
        str += '}';
      }
      return str;
    },

    /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */
    'toContinued': function() {

      var t;
      var a = this['n'];
      var b = this['d'];
      var res = [];

      if (isNaN(this['n']) || isNaN(this['d'])) {
        return res;
      }

      do {
        res.push(Math.floor(a / b));
        t = a % b;
        a = b;
        b = t;
      } while (a !== 1);

      return res;
    },

    /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/
    'toString': function() {

      var g;
      var N = this["n"];
      var D = this["d"];

      if (isNaN(N) || isNaN(D)) {
        return "NaN";
      }

      if (!Fraction['REDUCE']) {
        g = gcd(N, D);
        N /= g;
        D /= g;
      }

      var dec = 15; // 15 = decimal places when no repitation

      var cycLen = cycleLen(N, D); // Cycle length
      var cycOff = cycleStart(N, D, cycLen); // Cycle start

      var str = this['s'] === -1 ? "-" : "";

      str += N / D | 0;

      N %= D;
      N *= 10;

      if (N)
        str += ".";

      if (cycLen) {

        for (var i = cycOff; i--; ) {
          str += N / D | 0;
          N %= D;
          N *= 10;
        }
        str += "(";
        for (var i = cycLen; i--; ) {
          str += N / D | 0;
          N %= D;
          N *= 10;
        }
        str += ")";
      } else {
        for (var i = dec; N && i--; ) {
          str += N / D | 0;
          N %= D;
          N *= 10;
        }
      }
      return str;
    }
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return Fraction;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === "object") {
    Object.defineProperty(exports, "__esModule", {'value': true});
    Fraction['default'] = Fraction;
    Fraction['Fraction'] = Fraction;
    module['exports'] = Fraction;
  } else {
    root['Fraction'] = Fraction;
  }

})(this);


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultTeam.1d25f26.png";

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(631);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("8a3b942a", content, true);

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".topFixedWrap[data-v-bcc90ab8]{width:100%;position:fixed;top:0;z-index:999}.tab-box-fixed[data-v-bcc90ab8]{position:fixed;z-index:10;top:0;left:0}.tab-box-sticky[data-v-bcc90ab8]{position:-webkit-sticky;position:sticky;top:0;left:0;z-index:10}.navBread[data-v-bcc90ab8]{width:100%;height:2.4rem;background:var(--mainColor);color:#fff;line-height:2.4rem}.navBread a[data-v-bcc90ab8]{padding:0 1rem;text-decoration:none;color:#fff;font-size:.8rem}.navBread .match[data-v-bcc90ab8]{font-size:1rem;display:inline-block;height:1.2rem;line-height:1.2rem;border-right:.05rem solid #119730}.bannerInformWrap[data-v-bcc90ab8]{width:100%;height:7.4rem;overflow:hidden;background:url(" + __webpack_require__(561) + ") no-repeat;background-size:cover}.bannerInformWrap dl[data-v-bcc90ab8]{width:32%;float:left;margin-top:2.2rem}.bannerCenterWrap[data-v-bcc90ab8]{width:36%;height:5rem;float:left;padding:1.1rem 0;color:#fff;font-size:.68rem;text-align:center}.bannerInformWrap dl dd[data-v-bcc90ab8],.bannerInformWrap dl dt[data-v-bcc90ab8]{width:5rem;margin:0 auto;color:#fff;font-size:.7rem;text-align:center}.bannerInformWrap dl dd[data-v-bcc90ab8]{width:3.2rem!important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin:0 auto}.bannerInformWrap dl dt img[data-v-bcc90ab8]{width:2.7rem;height:2.7rem;display:block;margin:0 auto 1rem}.status_ended .scorewrap span[data-v-bcc90ab8]{width:2.1rem;height:2.1rem;overflow:hidden;display:inline-block;background:hsla(0,0%,100%,.1);font-size:2rem;float:left;border-radius:.1rem;text-align:center;line-height:2rem}.rowLine[data-v-bcc90ab8]{float:left;width:.7rem;height:.2rem;display:inline-block;background:#fff;overflow:hidden;margin:1rem 1rem 0}.competename[data-v-bcc90ab8]{margin-bottom:.6rem;text-align:center;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.time[data-v-bcc90ab8]{font-size:.7rem;color:#fff;text-align:center}.scorewrap[data-v-bcc90ab8]{margin-bottom:1.2rem}.status_playing .scorewrap span[data-v-bcc90ab8]{width:2.2rem;height:2.2rem;overflow:hidden;display:inline-block;background:hsla(0,0%,100%,.1);font-size:2rem;float:left;border-radius:.2rem;color:var(--mainColor);line-height:2.2rem}.status_playing .rowLine[data-v-bcc90ab8]{background:var(--mainColor)}.status_playing .live[data-v-bcc90ab8]{width:6rem;height:1rem;background:var(--mainColor);border-radius:.02666667rem;display:block;color:#fff;font-size:.68rem;line-height:1rem;margin:0 auto}.play_arrow[data-v-bcc90ab8]{margin:.25rem .4rem 0 1rem;width:.3rem;height:.4rem;float:left}.unlive[data-v-bcc90ab8]{color:var(--mainColor);font-size:.8rem}.status_unstart[data-v-bcc90ab8]{font-size:.8rem}.status_unstart .vs[data-v-bcc90ab8]{font-size:1rem;margin-bottom:.9rem;padding-top:.8rem}.unstartTime[data-v-bcc90ab8]{height:1rem;line-height:1rem;overflow:hidden}.unstartLive[data-v-bcc90ab8]{width:2.4rem;height:.8rem;line-height:.8rem;display:inline-block;color:var(--mainColor);font-size:.6rem;border:1px solid var(--mainColor);border-radius:.02666667rem;float:left;margin:0 .2rem 0 .4rem;-webkit-transform:scale(.7);transform:scale(.7);position:relative;left:.7rem;top:.1rem}.unstartTime time[data-v-bcc90ab8]{float:left;font-size:.68rem}.tabWrap[data-v-bcc90ab8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:.1rem solid #eff1f4;width:100%;height:2.4rem;line-height:2.4rem;background:#fff}.tabWrap span[data-v-bcc90ab8]{-webkit-box-flex:1;-ms-flex:1;flex:1;height:2.4rem;line-height:2.4rem;float:left;text-align:center;color:#606369;font-size:.9rem;box-sizing:border-box}.tabWrap span.selected[data-v-bcc90ab8]{border-bottom:.1rem solid var(--mainColor);color:var(--mainColor);position:relative}.contentWrap[data-v-bcc90ab8]{position:relative;top:17.2rem;font-size:12px}.contentWrap iframe[data-v-bcc90ab8]{border:none}.ml15[data-v-bcc90ab8]{margin-left:.8rem}.operamini-tips[data-v-bcc90ab8]{background:#ff0;text-align:center;font-weight:700}[data-v-bcc90ab8]:root{color-scheme:light dark}@media (prefers-color-scheme:dark){.tabWrap[data-v-bcc90ab8]{border-bottom:.1rem solid #111;background:#1c1c1c}.tabWrap span[data-v-bcc90ab8]{color:#d5d5d5}}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/pages/AppMatchDetail.vue"],"names":[],"mappings":"AACA,+BACE,WAAY,AACZ,eAAgB,AAChB,MAAO,AACP,WAAa,CACd,AACD,gCACE,eAAgB,AAChB,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,iCACE,wBAAyB,AACzB,gBAAiB,AACjB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AACD,2BACE,WAAY,AACZ,cAAe,AACf,4BAA6B,AAC7B,WAAY,AACZ,kBAAoB,CACrB,AACD,6BACE,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,eAAiB,CAClB,AACD,kCACE,eAAgB,AAChB,qBAAsB,AACtB,cAAe,AACf,mBAAoB,AACpB,iCAAoC,CACrC,AACD,mCACE,WAAY,AACZ,cAAe,AACf,gBAAiB,AACjB,mDAAkE,AAClE,qBAAuB,CACxB,AACD,sCACE,UAAW,AACX,WAAY,AACZ,iBAAmB,CACpB,AACD,mCACE,UAAW,AACX,YAAa,AACb,WAAY,AACZ,iBAAqB,AACrB,WAAY,AACZ,iBAAkB,AAClB,iBAAmB,CACpB,AACD,kFAEE,WAAY,AACZ,cAAe,AACf,WAAY,AACZ,gBAAiB,AACjB,iBAAmB,CACpB,AACD,yCACE,uBAAyB,AACzB,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,aAAe,CAChB,AACD,6CACE,aAAc,AACd,cAAe,AACf,cAAe,AACf,kBAAoB,CACrB,AACD,+CACE,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,qBAAsB,AACtB,8BAAqC,AACrC,eAAgB,AAChB,WAAY,AACZ,oBAAqB,AACrB,kBAAmB,AACnB,gBAAkB,CACnB,AACD,0BACE,WAAY,AACZ,YAAa,AACb,aAAc,AACd,qBAAsB,AACtB,gBAAiB,AACjB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,8BACE,oBAAsB,AACtB,kBAAmB,AACnB,mBAAoB,AACpB,uBAAwB,AACxB,eAAiB,CAClB,AACD,uBACE,gBAAkB,AAClB,WAAY,AACZ,iBAAmB,CACpB,AACD,4BACE,oBAAsB,CACvB,AACD,iDACE,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,qBAAsB,AACtB,8BAAqC,AACrC,eAAgB,AAChB,WAAY,AACZ,oBAAsB,AACtB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,0CACE,2BAA6B,CAC9B,AACD,uCACE,WAAY,AACZ,YAAa,AACb,4BAA6B,AAC7B,2BAA6B,AAC7B,cAAe,AACf,WAAY,AACZ,iBAAmB,AACnB,iBAAkB,AAClB,aAAe,CAChB,AACD,6BACE,2BAA8B,AAC9B,YAAc,AACd,aAAe,AACf,UAAY,CACb,AACD,yBACE,uBAAwB,AACxB,eAAkB,CACnB,AACD,iCACE,eAAkB,CACnB,AACD,qCACE,eAAgB,AAChB,oBAAqB,AACrB,iBAAoB,CACrB,AACD,8BACE,YAAa,AACb,iBAAkB,AAClB,eAAiB,CAClB,AACD,8BACE,aAAc,AACd,aAAe,AACf,kBAAoB,AACpB,qBAAsB,AACtB,uBAAwB,AACxB,gBAAkB,AAClB,kCAAmC,AACnC,2BAA6B,AAC7B,WAAY,AACZ,uBAA0B,AAC1B,4BAA8B,AACtB,oBAAsB,AAC9B,kBAAmB,AACnB,WAAa,AACb,SAAY,CACb,AACD,mCACE,WAAY,AACZ,gBAAmB,CACpB,AACD,0BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kCAAmC,AACnC,WAAY,AACZ,cAAe,AACf,mBAAoB,AACpB,eAAiB,CAClB,AACD,+BACE,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,kBAAmB,AACnB,cAAe,AACf,gBAAiB,AACjB,qBAAuB,CACxB,AACD,wCACE,2CAA6C,AAC7C,uBAAwB,AACxB,iBAAmB,CACpB,AACD,8BACE,kBAAmB,AACnB,YAAa,AACb,cAAgB,CACjB,AACD,qCACE,WAAa,CACd,AACD,uBACE,iBAAoB,CACrB,AACD,iCACE,gBAAoB,AACpB,kBAAmB,AACnB,eAAkB,CACnB,AACD,uBACE,uBAAyB,CAC1B,AACD,mCACA,0BACI,+BAAgC,AAChC,kBAAoB,CACvB,AACD,+BACI,aAAe,CAClB,CACA","file":"AppMatchDetail.vue","sourcesContent":["\n.topFixedWrap[data-v-bcc90ab8] {\n  width: 100%;\n  position: fixed;\n  top: 0;\n  z-index: 999;\n}\n.tab-box-fixed[data-v-bcc90ab8] {\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.tab-box-sticky[data-v-bcc90ab8] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.navBread[data-v-bcc90ab8] {\n  width: 100%;\n  height: 2.4rem;\n  background: var(--mainColor);\n  color: #fff;\n  line-height: 2.4rem;\n}\n.navBread a[data-v-bcc90ab8] {\n  padding: 0 1rem;\n  text-decoration: none;\n  color: #fff;\n  font-size: .8rem;\n}\n.navBread .match[data-v-bcc90ab8] {\n  font-size: 1rem;\n  display: inline-block;\n  height: 1.2rem;\n  line-height: 1.2rem;\n  border-right: 0.05rem solid #119730;\n}\n.bannerInformWrap[data-v-bcc90ab8] {\n  width: 100%;\n  height: 7.4rem;\n  overflow: hidden;\n  background: url(../assets/match/videoMatchBannerBg.jpg) no-repeat;\n  background-size: cover;\n}\n.bannerInformWrap dl[data-v-bcc90ab8] {\n  width: 32%;\n  float: left;\n  margin-top: 2.2rem;\n}\n.bannerCenterWrap[data-v-bcc90ab8] {\n  width: 36%;\n  height: 5rem;\n  float: left;\n  padding: 1.1rem 0rem;\n  color: #fff;\n  font-size: .68rem;\n  text-align: center;\n}\n.bannerInformWrap dl dt[data-v-bcc90ab8],\n.bannerInformWrap dl dd[data-v-bcc90ab8] {\n  width: 5rem;\n  margin: 0 auto;\n  color: #fff;\n  font-size: .7rem;\n  text-align: center;\n}\n.bannerInformWrap dl dd[data-v-bcc90ab8] {\n  width: 3.2rem !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 0 auto;\n}\n.bannerInformWrap dl dt img[data-v-bcc90ab8] {\n  width: 2.7rem;\n  height: 2.7rem;\n  display: block;\n  margin: 0 auto 1rem;\n}\n.status_ended .scorewrap span[data-v-bcc90ab8] {\n  width: 2.1rem;\n  height: 2.1rem;\n  overflow: hidden;\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 2rem;\n  float: left;\n  border-radius: .1rem;\n  text-align: center;\n  line-height: 2rem;\n}\n.rowLine[data-v-bcc90ab8] {\n  float: left;\n  width: .7rem;\n  height: .2rem;\n  display: inline-block;\n  background: #fff;\n  overflow: hidden;\n  margin: 1rem 1rem 0;\n}\n.competename[data-v-bcc90ab8] {\n  margin-bottom: 0.6rem;\n  text-align: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.time[data-v-bcc90ab8] {\n  font-size: 0.7rem;\n  color: #fff;\n  text-align: center;\n}\n.scorewrap[data-v-bcc90ab8] {\n  margin-bottom: 1.2rem;\n}\n.status_playing .scorewrap span[data-v-bcc90ab8] {\n  width: 2.2rem;\n  height: 2.2rem;\n  overflow: hidden;\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 2rem;\n  float: left;\n  border-radius: 0.2rem;\n  color: var(--mainColor);\n  line-height: 2.2rem;\n}\n.status_playing .rowLine[data-v-bcc90ab8] {\n  background: var(--mainColor);\n}\n.status_playing .live[data-v-bcc90ab8] {\n  width: 6rem;\n  height: 1rem;\n  background: var(--mainColor);\n  border-radius: 0.02666667rem;\n  display: block;\n  color: #fff;\n  font-size: 0.68rem;\n  line-height: 1rem;\n  margin: 0 auto;\n}\n.play_arrow[data-v-bcc90ab8] {\n  margin: 0.25rem 0.4rem 0 1rem;\n  width: 0.3rem;\n  height: 0.4rem;\n  float: left;\n}\n.unlive[data-v-bcc90ab8] {\n  color: var(--mainColor);\n  font-size: 0.8rem;\n}\n.status_unstart[data-v-bcc90ab8] {\n  font-size: 0.8rem;\n}\n.status_unstart .vs[data-v-bcc90ab8] {\n  font-size: 1rem;\n  margin-bottom: .9rem;\n  padding-top: 0.8rem;\n}\n.unstartTime[data-v-bcc90ab8] {\n  height: 1rem;\n  line-height: 1rem;\n  overflow: hidden;\n}\n.unstartLive[data-v-bcc90ab8] {\n  width: 2.4rem;\n  height: 0.8rem;\n  line-height: 0.8rem;\n  display: inline-block;\n  color: var(--mainColor);\n  font-size: 0.6rem;\n  border: 1px solid var(--mainColor);\n  border-radius: 0.02666667rem;\n  float: left;\n  margin: 0 0.2rem 0 0.4rem;\n  -webkit-transform: scale(0.7);\n          transform: scale(0.7);\n  position: relative;\n  left: 0.7rem;\n  top: 0.1rem;\n}\n.unstartTime time[data-v-bcc90ab8] {\n  float: left;\n  font-size: 0.68rem;\n}\n.tabWrap[data-v-bcc90ab8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: .1rem solid #eff1f4;\n  width: 100%;\n  height: 2.4rem;\n  line-height: 2.4rem;\n  background: #fff;\n}\n.tabWrap span[data-v-bcc90ab8] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  height: 2.4rem;\n  line-height: 2.4rem;\n  float: left;\n  text-align: center;\n  color: #606369;\n  font-size: .9rem;\n  box-sizing: border-box;\n}\n.tabWrap span.selected[data-v-bcc90ab8] {\n  border-bottom: 0.1rem solid var(--mainColor);\n  color: var(--mainColor);\n  position: relative;\n}\n.contentWrap[data-v-bcc90ab8] {\n  position: relative;\n  top: 17.2rem;\n  font-size: 12px;\n}\n.contentWrap iframe[data-v-bcc90ab8] {\n  border: none;\n}\n.ml15[data-v-bcc90ab8] {\n  margin-left: 0.8rem;\n}\n.operamini-tips[data-v-bcc90ab8] {\n  background: #FFFF00;\n  text-align: center;\n  font-weight: bold;\n}\n[data-v-bcc90ab8]:root {\n  color-scheme: light dark;\n}\n@media (prefers-color-scheme: dark) {\n.tabWrap[data-v-bcc90ab8] {\n    border-bottom: .1rem solid #111;\n    background: #1c1c1c;\n}\n.tabWrap span[data-v-bcc90ab8] {\n    color: #d5d5d5;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_downloadHeader_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_downloadHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_downloadHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_nav_vue__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_downloadPopup_vue__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_downloadPopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_downloadPopup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_matchScore_vue__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_matchScore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_matchScore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_matchOverview_vue__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_matchOverview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_matchOverview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_matchAnalysis_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_matchAnalysis_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_matchAnalysis_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_matchDetailOdds_App_vue__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_matchDetailOdds_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_matchDetailOdds_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_matchDetail__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_matchDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__lang_matchDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_util_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__util_util_js__);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'matchDetail',
    data: function data() {
        return {
            downLoadHeaderShow: true,
            toggleSelect: 'Analysis',
            subtitleName: '',
            competeId: null,
            idUrl: '',
            idData: {},
            idMatchAnalysisUrl: '',
            idMatchOddsUrl: '',
            idMatchOverViewUrl: '',
            competeStatus: '',
            local_month_day: '',
            local_hour_minite: '',
            currentIframeSrc: '',
            isOperamini: false,
            scoreTabInfo: null,
            isExternalAccess: null
        };
    },
    asyncData: function asyncData(_ref) {
        var store = _ref.store,
            _ref$route$params = _ref.route.params,
            id = _ref$route$params.id,
            language = _ref$route$params.language;

        var locale = language && language.split('-')[0] || 'en';
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([store.dispatch('FETCH_MATCH_DETAIL_FORMATION', { matchId: id }), store.dispatch('FETCH_MATCH_OVERVIEW_FORMATION', { matchId: id, locale: locale }), store.dispatch('FETCH_MATCH_ANALYSIS_FORMATION', { matchId: id, locale: locale, isJSON: true }), store.dispatch('FETCH_MATCH_ODDS_EURO', { matchId: id }), store.dispatch('FETCH_MATCH_ODDS_ASIA', { matchId: id }), store.dispatch('FETCH_MATCH_ODDS_OVER_UNDER', { matchId: id })]);
        } else {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('id不存在');
        }
    },
    head: function head() {
        var canonicalLink = this.idData && this.idData.team_A_name ? [{
            vmid: 'canonical',
            rel: 'canonical',
            href: 'https://www.allfootballapp.com/match/' + this.$route.params.id
        }] : [];
        return {
            link: canonicalLink,
            title: this.idData.team_A_name + ' VS ' + this.idData.team_B_name + ' | ' + this.idData.competition_name + ' | ' + this.idData.date_utc + ' | All Football',
            meta: [{
                name: 'description',
                content: 'The live score, overview, odds, lineup, events, technical statistics, match analysis of ' + this.idData.competition_name + ' ' + this.idData.team_A_name + ' vs ' + this.idData.team_B_name + ' at ' + this.idData.date_utc
            }, {
                name: 'keywords',
                content: this.idData.competition_name + ', ' + this.idData.team_A_name + ', ' + this.idData.team_B_name
            }]
        };
    },

    computed: {
        matchDetailFormation: function matchDetailFormation() {
            return this.$store.state.matchDetailStore.matchDetailFormation;
        }
    },
    created: function created() {
        var _this = this;

        var that = this;
        this.competeId = this.$route.params.id;
        this.subtitleName = this.$route.params.subtitle;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__lang_matchDetail___default.a).map(function (locale) {
            return _this.$i18n.setLocaleMessage(locale, __WEBPACK_IMPORTED_MODULE_9__lang_matchDetail___default.a[locale]);
        });
        that.idData = that.matchDetailFormation.matchSample || {};
        that.idMatchAnalysisUrl = that.matchDetailFormation.matchAnalysis.url || '';
        that.idMatchOddsUrl = that.matchDetailFormation.matchOdds.url || '';
        that.idMatchOverViewUrl = that.matchDetailFormation.matchSK.url || '';
        that.competeStatus = that.idData.status || '';
        var utcTime = that.idData.start_play || '';
        that.local_month_day = that.formatData(utcTime).local_Month_Day || '';
        that.local_hour_minite = that.formatData(utcTime).local_hms || '';
        if (that.competeStatus === 'Played' || that.competeStatus === 'Playing') {
            that.currentIframeSrc = that.idMatchOverViewUrl;
            that.toggleSelect = 'OverView';
        } else if (that.competeStatus === 'Fixture') {
            that.currentIframeSrc = that.idMatchAnalysisUrl + '?m_station';
            that.toggleSelect = 'Analysis';
        }
    },
    updated: function updated() {
        var utilObj = __webpack_require__(500);
        utilObj.lazyload('teamWrap', 'detailTeamLogo');
    },
    mounted: function mounted() {
        this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1;
        if (this.isExternalAccess) {
            __webpack_require__.e/* import() */(20/* duplicate */).then(__webpack_require__.bind(null, 501)).then(function (module) {
                console.log('module', module);
            });
        } else {
            __webpack_require__.e/* import() */(19/* duplicate */).then(__webpack_require__.bind(null, 502)).then(function (module) {});
        }
        var utilObj = __webpack_require__(500);
        document.body.scrollTop = 0;
        this.isOperamini = utilObj.checkOperamini();
        utilObj.timeForInOut();
        this.checkScoreTab();
    },
    methods: {
        checkScoreTab: function checkScoreTab() {
            var _this2 = this;

            var sportdataApiBaseUrl = 'https://sportdata-v2.allfootballapp.com';
            if ("production" === 'development' || location.hostname.startsWith('beta')) {
                sportdataApiBaseUrl = 'https://beta-sportdata-v2.allfootballapp.com';
            }
            var matchId = Number(this.competeId) - 50000000;
            __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(sportdataApiBaseUrl + '/soccer/biz/match/score_tab?match_id=' + matchId + '&app=af').then(function (res) {
                if (res.data && res.data.score_tab) {
                    _this2.scoreTabInfo = res.data;
                    Object(__WEBPACK_IMPORTED_MODULE_11__util_util_js__["record"])('msite/matchDetail?action=showScoreTab&matchId=' + matchId);
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        tran12: function tran12(time) {
            var timeArr = time.split(':');
            var result = '';
            if (timeArr[0] > 12) {
                result = timeArr[0] - 12 + ':' + timeArr[1] + ' FM';
            } else {
                result = timeArr[0] + ':' + timeArr[1] + ' AM';
            }
            return result;
        },

        toggle: function toggle(toggleName) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            if (toggleName === 'OverView') {
                this.toggleSelect = 'OverView';
            } else if (toggleName === 'Analysis') {
                this.toggleSelect = 'Analysis';
            } else if (toggleName === 'Odds') {
                this.toggleSelect = 'Odds';
            } else if (toggleName === 'Score') {
                this.toggleSelect = 'Score';
            }
            var matchId = Number(this.competeId) - 50000000;
            Object(__WEBPACK_IMPORTED_MODULE_11__util_util_js__["record"])('msite/matchDetail?action=changeTab&tab=' + this.toggleSelect + '&matchId=' + matchId);
        },
        formatData: function formatData(gmtDate) {
            var date = new Date(gmtDate.replace(/-/g, '/')).getTime();
            var diffMin = new Date().getTimezoneOffset();
            var localDate = new Date(date - diffMin * 60 * 1000);
            var localMonth = localDate.getMonth() + 1;
            if (localMonth < 10) {
                localMonth = '0' + localMonth;
            }
            var localTimeDetail = ('' + localDate).split(' ');
            var localMonthDay = localMonth + '-' + localTimeDetail[2];
            return {
                local_Month_Day: localMonthDay,
                local_hms: localTimeDetail[4].slice(0, 5)
            };
        }
    },
    components: {
        downloadheader: __WEBPACK_IMPORTED_MODULE_2__components_downloadHeader_vue___default.a, navVue: __WEBPACK_IMPORTED_MODULE_3__components_nav_vue___default.a, downloadPopup: __WEBPACK_IMPORTED_MODULE_4__components_downloadPopup_vue___default.a, matchOverview: __WEBPACK_IMPORTED_MODULE_6__components_matchOverview_vue___default.a, matchAnalysis: __WEBPACK_IMPORTED_MODULE_7__components_matchAnalysis_vue___default.a, odds: __WEBPACK_IMPORTED_MODULE_8__components_matchDetailOdds_App_vue___default.a, matchScore: __WEBPACK_IMPORTED_MODULE_5__components_matchScore_vue___default.a
    }
});

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8150265c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(635);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("6cbba7aa", content, true);

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".match-score[data-v-8150265c]{position:fixed;left:0;bottom:0;width:100%}.match-score .player-score-iframe[data-v-8150265c]{width:100%;height:100%;margin:0;padding:0;border:none;display:block;overflow:hidden}.match-score .player-score-iframe #document[data-v-8150265c]{margin:0;padding:0;border:none}.match-score .player-score-iframe[data-v-8150265c]::-webkit-scrollbar{width:0!important;height:0!important}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/matchScore.vue"],"names":[],"mappings":"AACA,8BACE,eAAgB,AAChB,OAAQ,AACR,SAAU,AACV,UAAY,CACb,AACD,mDACE,WAAY,AACZ,YAAa,AACb,SAAU,AACV,UAAW,AACX,YAAa,AACb,cAAe,AACf,eAAiB,CAClB,AACD,6DACE,SAAU,AACV,UAAW,AACX,WAAa,CACd,AACD,sEACE,kBAAoB,AACpB,kBAAqB,CACtB","file":"matchScore.vue","sourcesContent":["\n.match-score[data-v-8150265c] {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n}\n.match-score .player-score-iframe[data-v-8150265c] {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n  display: block;\n  overflow: hidden;\n}\n.match-score .player-score-iframe #document[data-v-8150265c] {\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n.match-score .player-score-iframe[data-v-8150265c]::-webkit-scrollbar {\n  width: 0 !important;\n  height: 0 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util_util_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['matchId', 'scoreTabInfo'],
  data: function data() {
    return {
      top: '17.2rem',
      iframeUrl: ''
    };
  },
  mounted: function mounted() {
    var matchId = Number(this.matchId) - 50000000;
    var matchPlayerScoreBaseUrl = 'https://n.allfootballapp.com';
    if ("production" === 'development' || location.hostname.startsWith('beta')) {
      matchPlayerScoreBaseUrl = 'https://beta-n.allfootballapp.com';
    }
    this.iframeUrl = matchPlayerScoreBaseUrl + '/v2/matchPlayerScore?match_id=' + matchId + '&sport_type=' + (this.scoreTabInfo.sport_type || 'soccer') + '&tab_id=' + this.scoreTabInfo.tab_id;
    var iframeContainerEle = document.getElementById('contentWrap');
    if (iframeContainerEle) {
      this.top = getComputedStyle(iframeContainerEle).top || '17.2rem';
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__util_util_js__["record"])('msite/matchPlayerScore?action=view&matchId=' + matchId);
  }
});

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-score",
    style: ({
      'top': _vm.top
    })
  }, [_c('iframe', {
    staticClass: "player-score-iframe",
    attrs: {
      "src": _vm.iframeUrl,
      "frameborder": "0"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(639)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-364a85e9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(640);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("35a884cb", content, true);

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "body[data-v-364a85e9],html[data-v-364a85e9]{-webkit-touch-callout:none;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:15px;padding:0;margin:0;color:#333;background-color:#eff1f4;position:absolute;top:0;left:0;width:100%;height:auto;min-height:100%;overflow-x:hidden}.events[data-v-364a85e9]{background-color:#f5f5f5}section[data-v-364a85e9]{display:block;font-size:15px;height:30px;line-height:30px;font-weight:400;padding:0 0 0 15px;margin:0;background-color:#e2e4e6}.content[data-v-364a85e9]{margin:10px 15px}a[data-v-364a85e9]{color:#399e5c;text-decoration:none}.person[data-v-364a85e9]{color:#000;text-decoration:none}p[data-v-364a85e9]{line-height:1.6;text-align:justify;word-wrap:break-word;word-break:normal;margin:20px 0}dd[data-v-364a85e9],dl[data-v-364a85e9],dt[data-v-364a85e9],li[data-v-364a85e9],ul[data-v-364a85e9]{list-style:none;margin:0;padding:0}header h1[data-v-364a85e9]{font-size:20px;padding:0;margin:0;line-height:1.5}header time[data-v-364a85e9]{color:#999;font-size:12px;display:inline-block;padding:0;vertical-align:top;margin-left:6px}header h2[data-v-364a85e9]{line-height:20px;font-size:12px;padding:5px 0 0;font-weight:400;margin:0}article video[data-v-364a85e9]{display:block;margin:0 auto;width:100%;background-size:118px}.media-iframe[data-v-364a85e9]{text-indent:0;display:block;margin:0 auto;width:100%;min-height:100px}.media-container[data-v-364a85e9]{display:block;position:relative;z-index:1000;margin:0 auto}.media-container-video[data-v-364a85e9]{border-bottom:25px solid #000;border-top:25px solid #000}.media-holder[data-v-364a85e9]{position:absolute;left:0;top:0;z-index:999;width:100%;height:100%;background:url(" + __webpack_require__(641) + ") no-repeat 50%;background-size:40px 40px}.media-holder-video[data-v-364a85e9]{background:url(" + __webpack_require__(642) + ") no-repeat 50%;background-size:60px 60px}.floater[data-v-364a85e9]{float:left;height:50%;margin-bottom:-10px}.empty[data-v-364a85e9]{clear:both;height:20px;position:relative;text-align:center;color:#babdc2;font-size:14px}li[data-v-364a85e9],ol[data-v-364a85e9]{margin:0;padding:0}ol#timeline[data-v-364a85e9]{width:100%;padding-bottom:20px;background:url(" + __webpack_require__(643) + ") 50% repeat-y}ol#timeline li[data-v-364a85e9]{position:relative;color:#555;margin:10px 0;margin-top:20px}ol#timeline li div[data-v-364a85e9]{width:40%;border:1px solid #ddd;padding:5px 0;background:#fff;position:relative;border-radius:3px}ol#timeline p[data-v-364a85e9]{margin:0;padding:0;font-size:12px;height:20px;line-height:20px;text-indent:0}ol#timeline p img[data-v-364a85e9]{width:15px;vertical-align:middle}.content_p[data-v-364a85e9]{padding-bottom:41px}.show[data-v-364a85e9]{width:100%;font-size:12px;padding-top:13px;line-height:14px;border-top:1px solid #e9e9e9;background:#eff1f4}.show_main[data-v-364a85e9]{padding:0 15px}.show img[data-v-364a85e9]{width:12px;vertical-align:top;margin-right:3px}.show span[data-v-364a85e9]{display:inline-block;text-align:left;margin-bottom:13px}.show_main[data-v-364a85e9]{text-align:justify;text-justify:distribute-all-lines;text-align-last:justify;-moz-text-align-last:justify;-webkit-text-align-last:justify}@media screen and (-webkit-min-device-pixel-ratio:0){.show_main[data-v-364a85e9]:after{content:\"\";display:inline-block;overflow:hidden;width:0;height:0}}.cf[data-v-364a85e9]:after,.cf[data-v-364a85e9]:before{content:\"\";display:table}.cf[data-v-364a85e9]:after{clear:both}.cf[data-v-364a85e9]{zoom:1;clear:both;padding:0}ol#timeline .home[data-v-364a85e9]{float:left;text-align:right;padding-right:10px}ol#timeline .home p[data-v-364a85e9]{text-align:right;font-size:12px}ol#timeline .home span.arrow[data-v-364a85e9]{display:block;width:6px;height:8px;background:url(" + __webpack_require__(644) + ") 0 0 no-repeat;position:absolute;right:-6px;top:5px;background-size:cover}ol#timeline .away[data-v-364a85e9]{float:right;text-align:left;padding-left:10px;line-height:15px}ol#timeline .away span.arrow[data-v-364a85e9]{display:block;width:6px;height:8px;background:url(" + __webpack_require__(645) + ") 0 0 no-repeat;position:absolute;left:-6px;top:5px;background-size:cover}ol#timeline .away p[data-v-364a85e9]{text-align:left}ol#timeline .num[data-v-364a85e9]{width:20px;left:0;right:0;position:absolute;margin:auto;background:#16ac3a;border-radius:10px;color:#fff;font-family:arial;font-size:10px}.content .act[data-v-364a85e9],ol#timeline .num[data-v-364a85e9]{display:block;height:20px;text-align:center;line-height:20px;font-weight:400}.content .act[data-v-364a85e9]{width:100%;color:#16ac3a;font-size:14px;margin-top:5px}.content .dot[data-v-364a85e9]{margin:-5px auto 0}.content .dot[data-v-364a85e9],.content .dot_s[data-v-364a85e9]{display:block;width:8px;height:8px;border-radius:4px;background:#16ac3a}.content .dot_s[data-v-364a85e9]{margin:0 auto}ol#timeline>li[data-v-364a85e9]:first-child{margin-top:5px}.icon_start[data-v-364a85e9]{display:block;margin:0 auto;width:16px;height:16px;background:url(" + __webpack_require__(646) + ") 0 0 no-repeat;background-size:100%}.icon_end[data-v-364a85e9]{display:block;margin:5px auto 0;width:16px;height:16px;background:url(" + __webpack_require__(647) + ") 0 0 no-repeat;background-size:100%}.status[data-v-364a85e9]{width:96%;margin:0 auto;padding:0}.status table[data-v-364a85e9]{margin:0;padding:0;width:100%;word-break:keep-all}.status table.head[data-v-364a85e9]{border-bottom:1px solid #ddd}.status td[data-v-364a85e9],.status th[data-v-364a85e9]{margin:0;padding:0;width:100%;border-collapse:collapse;font-weight:400;font-size:12px;border:0}.status th[data-v-364a85e9]{height:40px;line-height:40px}.status td[data-v-364a85e9]{height:16px;line-height:16px;padding:7px 0;font-family:arial;color:#333}.status a[data-v-364a85e9]{color:#333}.status th img[data-v-364a85e9]{width:25px;height:25px;vertical-align:middle;margin:0;padding:0}.status .away[data-v-364a85e9]{width:43%;text-align:right;text-overflow:ellipsis}.status .home[data-v-364a85e9]{width:43%;text-align:left;text-overflow:ellipsis}.status .name[data-v-364a85e9]{width:14%;text-align:center}.status .rank[data-v-364a85e9]{margin:0 1px;width:77%;background:#e9e9e9;margin-top:2px}.status .rank[data-v-364a85e9],.status .ranks[data-v-364a85e9]{display:inline-block;height:12px;line-height:12px;border-radius:1px;vertical-align:top}.status .ranks[data-v-364a85e9]{background:#16ac3a}.status .ranks_l[data-v-364a85e9]{background:#888}span.text_lim[data-v-364a85e9]{display:inline-block;white-space:nowrap;overflow:hidden;line-break:strict;vertical-align:middle;text-overflow:ellipsis;width:90px}.empty[data-v-364a85e9]{padding-top:36%}.video[data-v-364a85e9]{position:relative}.video .mask[data-v-364a85e9]{width:100%;height:100%;position:absolute;top:0;left:0;background:url(https://dqdfiles.b0.upaiyun.com/app/icon_playing.png) 50% no-repeat rgba(0,0,0,.5);background-size:auto 20px;z-index:10000;display:none}.playing .mask[data-v-364a85e9]{display:block}.playing .media-holder-video[data-v-364a85e9]{display:none}ul.gif_container[data-v-364a85e9]{min-height:200px;padding:15px 10px 10px;font-size:0}ul.gif_container li[data-v-364a85e9]{background:#fff;display:inline-block;width:49%;min-height:100px;margin-bottom:8px;overflow:hidden;font-size:0;vertical-align:middle}ul.gif_container li[data-v-364a85e9]:nth-child(2n){margin-left:2%}ul.gif_container li .img_con[data-v-364a85e9]{background-repeat:no-repeat;background-position:50%;background-size:100% auto;height:128px;width:100%}ul.gif_container li .text_con[data-v-364a85e9]{font-size:12px;margin:0;padding:8px 8px 10px;height:52px;position:relative}ul.gif_container li .text_con p[data-v-364a85e9]{margin:0;height:30px;line-height:15px;text-align:left;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden}ul.gif_container li a[data-v-364a85e9]{display:block;color:#333}ul.gif_container li a[data-v-364a85e9]:visited{color:#999}.total_view[data-v-364a85e9]{position:absolute;left:8px;bottom:10px;color:#16ac3a}.comments[data-v-364a85e9]{position:absolute;right:8px;bottom:10px;color:#999}.gif[data-v-364a85e9]{background-image:url(" + __webpack_require__(648) + ");background-position:50%;background-size:20px 20px;height:20px;width:20px;display:block;z-index:2000}#app_news[data-v-364a85e9]{background:#fff}#app_news dd[data-v-364a85e9]{padding:0 14px;border-top:1px solid #eee;height:72px}#app_news dd a[data-v-364a85e9]{display:block;color:#333;height:52px;padding:10px 0;position:relative}#app_news dd a[data-v-364a85e9]:visited{color:#999}#app_news dd span[data-v-364a85e9]{color:#aaa;font-size:11px;position:absolute;right:0;bottom:9px}#app_news dd .img_news[data-v-364a85e9]{background-color:#e9e9e9;width:70px;height:52px;float:left;margin-right:10px;background-position:50%;background-size:100%}#app_news dd .video_news[data-v-364a85e9]{width:70px;height:52px;border-radius:2px;float:left;margin-right:12px;background-position:50%;background-size:100%}#app_news dd .video_icon[data-v-364a85e9]{background:url(https://dqdfiles.b0.upaiyun.com/app/video.png) 50% no-repeat rgba(0,0,0,.5);width:100%;height:100%;background-size:20px 20px}#app_news p[data-v-364a85e9]{padding:0 0 3px;line-height:18px;margin:0;font-size:14px;position:relative;bottom:2px}.loading[data-v-364a85e9]{position:absolute;width:45px;height:45px;background:url(" + __webpack_require__(649) + ") no-repeat;background-size:100%;margin:auto;top:0;bottom:0;left:0;right:0;-webkit-animation:spin-data-v-364a85e9 1s linear infinite;animation:spin-data-v-364a85e9 1s linear infinite}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-data-v-364a85e9{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/matchOverview.vue"],"names":[],"mappings":"AACA,4CAEI,2BAA4B,AAC5B,sDAA4D,AAC5D,eAAgB,AAChB,UAAW,AACX,SAAU,AACV,WAAY,AACZ,yBAA0B,AAC1B,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AAEb,gBAAiB,AACjB,iBAAmB,CACtB,AACD,yBACI,wBAA0B,CAC7B,AACD,yBACI,cAAe,AAEf,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,mBAAoB,AACpB,SAAU,AAEV,wBAA0B,CAC7B,AACD,0BACI,gBAAkB,CACrB,AACD,mBACI,cAAe,AACf,oBAAsB,CACzB,AACD,yBACI,WAAa,AACb,oBAAsB,CACzB,AACD,mBACI,gBAAiB,AACjB,mBAAoB,AACpB,qBAAsB,AACtB,kBAAmB,AACnB,aAAe,CAClB,AACD,oGAKI,gBAAiB,AACjB,SAAU,AACV,SAAW,CACd,AACD,2BACI,eAAgB,AAChB,UAAW,AACX,SAAU,AACV,eAAiB,CACpB,AACD,6BACI,WAAY,AACZ,eAAgB,AAChB,qBAAsB,AACtB,UAAW,AACX,mBAAoB,AACpB,eAAiB,CACpB,AACD,2BACI,iBAAkB,AAClB,eAAgB,AAChB,gBAAmB,AACnB,gBAAoB,AACpB,QAAU,CACb,AACD,+BACI,cAAe,AACf,cAAe,AACf,WAAY,AAEZ,qBAAuB,CAC1B,AACD,+BACI,cAAe,AACf,cAAe,AACf,cAAe,AACf,WAAY,AACZ,gBAAkB,CACrB,AACD,kCACI,cAAe,AACf,kBAAmB,AACnB,aAAc,AACd,aAAe,CAClB,AACD,wCACI,8BAA+B,AAC/B,0BAA4B,CAC/B,AACD,+BACI,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,YAAa,AACb,WAAY,AACZ,YAAa,AACb,uDAA0E,AAC1E,yBAA2B,CAC9B,AACD,qCACI,uDAAqE,AACrE,yBAA2B,CAC9B,AACD,0BACI,WAAY,AACZ,WAAY,AACZ,mBAAqB,CACxB,AACD,wBACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,cAAe,AACf,cAAgB,CACnB,AACD,wCAEI,SAAU,AACV,SAAW,CACd,AACD,6BACI,WAAY,AACZ,oBAAqB,AACrB,qDAAsE,CACzE,AACD,gCACI,kBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,eAAiB,CACpB,AACD,oCACI,UAAW,AACX,sBAAuB,AAEvB,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,iBAAmB,CACtB,AACD,+BACI,SAAU,AACV,UAAW,AACX,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,aAAe,CAClB,AACD,mCACI,WAAY,AACZ,qBAAuB,CAC1B,AACD,4BACI,mBAAqB,CACxB,AACD,uBACI,WAAY,AACZ,eAAgB,AAEhB,iBAAkB,AAClB,iBAAkB,AAClB,6BAA8B,AAE9B,kBAAoB,CACvB,AACD,4BACI,cAAgB,CACnB,AACD,2BACI,WAAY,AACZ,mBAAoB,AACpB,gBAAkB,CACrB,AACD,4BACI,qBAAsB,AACtB,gBAAiB,AACjB,kBAAoB,CACvB,AACD,4BACI,mBAAoB,AACpB,kCAAmC,AAEnC,wBAAyB,AAEzB,6BAA8B,AAE9B,+BAAiC,CAEpC,AAGD,qDACA,kCACQ,WAAY,AACZ,qBAAsB,AACtB,gBAAiB,AACjB,QAAS,AACT,QAAU,CACjB,CACA,AACD,uDAEI,WAAY,AACZ,aAAe,CAClB,AACD,2BACI,UAAY,CACf,AACD,qBACI,OAAQ,AACR,WAAY,AACZ,SAAW,CACd,AACD,mCACI,WAAY,AACZ,iBAAkB,AAClB,kBAAoB,CACvB,AACD,qCACI,iBAAkB,AAClB,cAAgB,CACnB,AACD,8CACI,cAAe,AACf,UAAW,AACX,WAAY,AACZ,uDAA2D,AAC3D,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,qBAAuB,CAC1B,AACD,mCACI,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,gBAAkB,CACrB,AACD,8CACI,cAAe,AACf,UAAW,AACX,WAAY,AACZ,uDAA2D,AAC3D,kBAAmB,AACnB,UAAW,AACX,QAAS,AACT,qBAAuB,CAC1B,AACD,qCACI,eAAiB,CACpB,AACD,kCAEI,WAAY,AAEZ,OAAQ,AACR,QAAS,AACT,kBAAmB,AACnB,YAAa,AACb,mBAAoB,AACpB,mBAAoB,AACpB,WAAY,AAIZ,kBAAmB,AACnB,cAAgB,CACnB,AACD,iEAhBI,cAAe,AAEf,YAAa,AAQb,kBAAmB,AACnB,iBAAkB,AAClB,eAAiB,CAcpB,AAVD,+BAEI,WAAY,AAEZ,cAAe,AAIf,eAAgB,AAChB,cAAgB,CACnB,AACD,+BAMI,kBAAyB,CAC5B,AACD,gEAPI,cAAe,AACf,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,kBAAoB,CAUvB,AAPD,iCAMI,aAAsB,CACzB,AACD,4CACI,cAAgB,CACnB,AACD,6BACI,cAAe,AACf,cAAe,AACf,WAAY,AACZ,YAAa,AACb,uDAAgE,AAChE,oBAAsB,CACzB,AACD,2BACI,cAAe,AACf,kBAAwB,AACxB,WAAY,AACZ,YAAa,AACb,uDAA8D,AAC9D,oBAAsB,CACzB,AACD,yBACI,UAAW,AACX,cAAe,AACf,SAAW,CACd,AACD,+BACI,SAAU,AACV,UAAW,AACX,WAAY,AACZ,mBAAqB,CACxB,AACD,oCACI,4BAA8B,CAEjC,AACD,wDAEI,SAAU,AACV,UAAW,AACX,WAAY,AACZ,yBAA0B,AAC1B,gBAAiB,AACjB,eAAgB,AAChB,QAAU,CACb,AACD,4BACI,YAAa,AACb,gBAAkB,CACrB,AACD,4BACI,YAAa,AACb,iBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,2BACI,UAAY,CACf,AACD,gCACI,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,SAAU,AACV,SAAW,CACd,AACD,+BACI,UAAW,AACX,iBAAkB,AAClB,sBAAwB,CAC3B,AACD,+BACI,UAAW,AACX,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,+BACI,UAAW,AACX,iBAAmB,CACtB,AACD,+BACI,aAAc,AAEd,UAAW,AAGX,mBAAoB,AAGpB,cAAgB,CACnB,AACD,+DATI,qBAAsB,AAEtB,YAAa,AACb,iBAAkB,AAElB,kBAAmB,AACnB,kBAAoB,CAUvB,AAPD,gCAII,kBAAoB,CAGvB,AACD,kCACI,eAAiB,CACpB,AACD,+BACI,qBAAsB,AACtB,mBAAoB,AACpB,gBAAiB,AACjB,kBAAmB,AACnB,sBAAuB,AACvB,uBAAwB,AACxB,UAAY,CACf,AACD,wBACI,eAAiB,CACpB,AACD,wBACI,iBAAmB,CACtB,AACD,8BACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,kGAAiH,AACjH,0BAA2B,AAC3B,cAAe,AACf,YAAc,CACjB,AACD,gCACI,aAAe,CAClB,AACD,8CACI,YAAc,CACjB,AAGD,kCACI,iBAAkB,AAClB,uBAAwB,AACxB,WAAa,CAChB,AACD,qCACI,gBAAoB,AACpB,qBAAsB,AACtB,UAAW,AACX,iBAAkB,AAClB,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,qBAAuB,CAC1B,AACD,mDACI,cAAgB,CACnB,AACD,8CACI,4BAA6B,AAC7B,wBAAmC,AACnC,0BAA2B,AAC3B,aAAc,AACd,UAAY,CACf,AACD,+CACI,eAAgB,AAChB,SAAU,AACV,qBAAsB,AACtB,YAAa,AACb,iBAAmB,CACtB,AACD,iDACI,SAAU,AACV,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,oBAAqB,AACrB,4BAA6B,AAC7B,qBAAsB,AACtB,eAAiB,CACpB,AACD,uCACI,cAAe,AACf,UAAe,CAClB,AACD,+CACI,UAAe,CAClB,AACD,6BACI,kBAAmB,AACnB,SAAU,AACV,YAAa,AACb,aAAe,CAClB,AACD,2BACI,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,UAAe,CAClB,AACD,sBACI,+CAAyD,AACzD,wBAAmC,AACnC,0BAA2B,AAC3B,YAAa,AACb,WAAY,AACZ,cAAe,AACf,YAAc,CACjB,AACD,2BACI,eAAiB,CACpB,AACD,8BACI,eAAgB,AAGhB,0BAA8B,AAE9B,WAAa,CAJhB,AAMD,gCACI,cAAe,AACf,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,iBAAmB,CACtB,AACD,wCACI,UAAe,CAClB,AACD,mCACI,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,UAAY,CACf,AACD,wCACI,yBAA0B,AAC1B,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,wBAAmC,AACnC,oBAAsB,CACzB,AACD,0CACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,wBAAmC,AACnC,oBAAsB,CACzB,AACD,0CACI,2FAA0G,AAC1G,WAAY,AACZ,YAAa,AACb,yBAA2B,CAC9B,AACD,6BACI,gBAAmB,AACnB,iBAAkB,AAClB,SAAU,AACV,eAAgB,AAChB,kBAAmB,AACnB,UAAY,CACf,AACD,0BACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,mDAA8D,AAC9D,qBAAsB,AACtB,YAAa,AACb,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,0DAA2D,AACnD,iDAAmD,CAC9D,AACD,wBACA,GACQ,gCAAkC,AAClC,uBAA0B,CACjC,CACA,AACD,gCACA,GACQ,gCAAkC,AAClC,uBAA0B,CACjC,CACA","file":"matchOverview.vue","sourcesContent":["\nhtml[data-v-364a85e9],\nbody[data-v-364a85e9] {\n    -webkit-touch-callout: none;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 15px;\n    padding: 0;\n    margin: 0;\n    color: #333;\n    background-color: #eff1f4;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: auto;\n    /* iOS position:fixed; elements fix (not 100%) */\n    min-height: 100%;\n    overflow-x: hidden;\n}\n.events[data-v-364a85e9] {\n    background-color: #f5f5f5;\n}\nsection[data-v-364a85e9] {\n    display: block;\n    /* vertical-align:middle; */\n    font-size: 15px;\n    height: 30px;\n    line-height: 30px;\n    font-weight: 400;\n    padding: 0 0 0 15px;\n    margin: 0;\n    /*color: 555;*/\n    background-color: #e2e4e6;\n}\n.content[data-v-364a85e9] {\n    margin: 10px 15px;\n}\na[data-v-364a85e9] {\n    color: #399e5c;\n    text-decoration: none;\n}\n.person[data-v-364a85e9] {\n    color: black;\n    text-decoration: none;\n}\np[data-v-364a85e9] {\n    line-height: 1.6;\n    text-align: justify;\n    word-wrap: break-word;\n    word-break: normal;\n    margin: 20px 0;\n}\nul[data-v-364a85e9],\nli[data-v-364a85e9],\ndl[data-v-364a85e9],\ndt[data-v-364a85e9],\ndd[data-v-364a85e9] {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\nheader h1[data-v-364a85e9] {\n    font-size: 20px;\n    padding: 0;\n    margin: 0;\n    line-height: 1.5;\n}\nheader time[data-v-364a85e9] {\n    color: #999;\n    font-size: 12px;\n    display: inline-block;\n    padding: 0;\n    vertical-align: top;\n    margin-left: 6px;\n}\nheader h2[data-v-364a85e9] {\n    line-height: 20px;\n    font-size: 12px;\n    padding: 5px 0 0 0;\n    font-weight: normal;\n    margin: 0;\n}\narticle video[data-v-364a85e9] {\n    display: block;\n    margin: 0 auto;\n    width: 100%;\n    /* background: url() #3e3e3e no-repeat center center; */\n    background-size: 118px;\n}\n.media-iframe[data-v-364a85e9] {\n    text-indent: 0;\n    display: block;\n    margin: 0 auto;\n    width: 100%;\n    min-height: 100px;\n}\n.media-container[data-v-364a85e9] {\n    display: block;\n    position: relative;\n    z-index: 1000;\n    margin: 0 auto;\n}\n.media-container-video[data-v-364a85e9] {\n    border-bottom: 25px #000 solid;\n    border-top: 25px #000 solid;\n}\n.media-holder[data-v-364a85e9] {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 999;\n    width: 100%;\n    height: 100%;\n    background: url('../assets/match/play@80x80.png') no-repeat center center;\n    background-size: 40px 40px;\n}\n.media-holder-video[data-v-364a85e9] {\n    background: url('../assets/match/video.png') no-repeat center center;\n    background-size: 60px 60px;\n}\n.floater[data-v-364a85e9] {\n    float: left;\n    height: 50%;\n    margin-bottom: -10px;\n}\n.empty[data-v-364a85e9] {\n    clear: both;\n    height: 20px;\n    position: relative;\n    text-align: center;\n    color: #babdc2;\n    font-size: 14px;\n}\nol[data-v-364a85e9],\nli[data-v-364a85e9] {\n    margin: 0;\n    padding: 0;\n}\nol#timeline[data-v-364a85e9] {\n    width: 100%;\n    padding-bottom: 20px;\n    background: url('../assets/match/bg_line.png') center center repeat-y;\n}\nol#timeline li[data-v-364a85e9] {\n    position: relative;\n    color: #555;\n    margin: 10px 0;\n    margin-top: 20px;\n}\nol#timeline li div[data-v-364a85e9] {\n    width: 40%;\n    border: 1px solid #ddd;\n    /*no*/\n    padding: 5px 0;\n    background: #fff;\n    position: relative;\n    border-radius: 3px;\n}\nol#timeline p[data-v-364a85e9] {\n    margin: 0;\n    padding: 0;\n    font-size: 12px;\n    height: 20px;\n    line-height: 20px;\n    text-indent: 0;\n}\nol#timeline p img[data-v-364a85e9] {\n    width: 15px;\n    vertical-align: middle;\n}\n.content_p[data-v-364a85e9] {\n    padding-bottom: 41px;\n}\n.show[data-v-364a85e9] {\n    width: 100%;\n    font-size: 12px;\n    /*height:14px;*/\n    padding-top: 13px;\n    line-height: 14px;\n    border-top: 1px solid #e9e9e9;\n    /*no*/\n    background: #eff1f4;\n}\n.show_main[data-v-364a85e9] {\n    padding: 0 15px;\n}\n.show img[data-v-364a85e9] {\n    width: 12px;\n    vertical-align: top;\n    margin-right: 3px;\n}\n.show span[data-v-364a85e9] {\n    display: inline-block;\n    text-align: left;\n    margin-bottom: 13px;\n}\n.show_main[data-v-364a85e9] {\n    text-align: justify;\n    text-justify: distribute-all-lines;\n    /*ie6-8*/\n    text-align-last: justify;\n    /* ie9*/\n    -moz-text-align-last: justify;\n    /*ff*/\n    -webkit-text-align-last: justify;\n    /*chrome 20+*/\n}\n\n/* chrome*/\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n.show_main[data-v-364a85e9]:after {\n        content: \"\";\n        display: inline-block;\n        overflow: hidden;\n        width: 0;\n        height: 0;\n}\n}\n.cf[data-v-364a85e9]:before,\n.cf[data-v-364a85e9]:after {\n    content: \"\";\n    display: table;\n}\n.cf[data-v-364a85e9]:after {\n    clear: both;\n}\n.cf[data-v-364a85e9] {\n    zoom: 1;\n    clear: both;\n    padding: 0;\n}\nol#timeline .home[data-v-364a85e9] {\n    float: left;\n    text-align: right;\n    padding-right: 10px;\n}\nol#timeline .home p[data-v-364a85e9] {\n    text-align: right;\n    font-size: 12px;\n}\nol#timeline .home span.arrow[data-v-364a85e9] {\n    display: block;\n    width: 6px;\n    height: 8px;\n    background: url('../assets/match/tri_l.png') 0 0 no-repeat;\n    position: absolute;\n    right: -6px;\n    top: 5px;\n    background-size: cover;\n}\nol#timeline .away[data-v-364a85e9] {\n    float: right;\n    text-align: left;\n    padding-left: 10px;\n    line-height: 15px;\n}\nol#timeline .away span.arrow[data-v-364a85e9] {\n    display: block;\n    width: 6px;\n    height: 8px;\n    background: url('../assets/match/tri_r.png') 0 0 no-repeat;\n    position: absolute;\n    left: -6px;\n    top: 5px;\n    background-size: cover;\n}\nol#timeline .away p[data-v-364a85e9] {\n    text-align: left;\n}\nol#timeline .num[data-v-364a85e9] {\n    display: block;\n    width: 20px;\n    height: 20px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    margin: auto;\n    background: #16ac3a;\n    border-radius: 10px;\n    color: #fff;\n    text-align: center;\n    line-height: 20px;\n    font-weight: 400;\n    font-family: arial;\n    font-size: 10px;\n}\n.content .act[data-v-364a85e9] {\n    display: block;\n    width: 100%;\n    height: 20px;\n    color: #16ac3a;\n    text-align: center;\n    line-height: 20px;\n    font-weight: 400;\n    font-size: 14px;\n    margin-top: 5px;\n}\n.content .dot[data-v-364a85e9] {\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-radius: 4px;\n    background: #16ac3a;\n    margin: -5px auto 0 auto;\n}\n.content .dot_s[data-v-364a85e9] {\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-radius: 4px;\n    background: #16ac3a;\n    margin: 0 auto 0 auto;\n}\nol#timeline > li[data-v-364a85e9]:first-child {\n    margin-top: 5px;\n}\n.icon_start[data-v-364a85e9] {\n    display: block;\n    margin: 0 auto;\n    width: 16px;\n    height: 16px;\n    background: url('../assets/match/icon_start.png') 0 0 no-repeat;\n    background-size: 100%;\n}\n.icon_end[data-v-364a85e9] {\n    display: block;\n    margin: 5px auto 0 auto;\n    width: 16px;\n    height: 16px;\n    background: url('../assets/match/icon_end.png') 0 0 no-repeat;\n    background-size: 100%;\n}\n.status[data-v-364a85e9] {\n    width: 96%;\n    margin: 0 auto;\n    padding: 0;\n}\n.status table[data-v-364a85e9] {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    word-break: keep-all;\n}\n.status table.head[data-v-364a85e9] {\n    border-bottom: 1px solid #ddd;\n    /*no*/\n}\n.status th[data-v-364a85e9],\n.status td[data-v-364a85e9] {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    border-collapse: collapse;\n    font-weight: 400;\n    font-size: 12px;\n    border: 0;\n}\n.status th[data-v-364a85e9] {\n    height: 40px;\n    line-height: 40px;\n}\n.status td[data-v-364a85e9] {\n    height: 16px;\n    line-height: 16px;\n    padding: 7px 0;\n    font-family: arial;\n    color: #333;\n}\n.status a[data-v-364a85e9] {\n    color: #333;\n}\n.status th img[data-v-364a85e9] {\n    width: 25px;\n    height: 25px;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n}\n.status .away[data-v-364a85e9] {\n    width: 43%;\n    text-align: right;\n    text-overflow: ellipsis;\n}\n.status .home[data-v-364a85e9] {\n    width: 43%;\n    text-align: left;\n    text-overflow: ellipsis;\n}\n.status .name[data-v-364a85e9] {\n    width: 14%;\n    text-align: center;\n}\n.status .rank[data-v-364a85e9] {\n    margin: 0 1px;\n    display: inline-block;\n    width: 77%;\n    height: 12px;\n    line-height: 12px;\n    background: #e9e9e9;\n    border-radius: 1px;\n    vertical-align: top;\n    margin-top: 2px;\n}\n.status .ranks[data-v-364a85e9] {\n    display: inline-block;\n    height: 12px;\n    line-height: 12px;\n    background: #16ac3a;\n    border-radius: 1px;\n    vertical-align: top;\n}\n.status .ranks_l[data-v-364a85e9] {\n    background: #888;\n}\nspan.text_lim[data-v-364a85e9] {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    line-break: strict;\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    width: 90px;\n}\n.empty[data-v-364a85e9] {\n    padding-top: 36%;\n}\n.video[data-v-364a85e9] {\n    position: relative;\n}\n.video .mask[data-v-364a85e9] {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: url(https://dqdfiles.b0.upaiyun.com/app/icon_playing.png) center center no-repeat rgba(0, 0, 0, 0.5);\n    background-size: auto 20px;\n    z-index: 10000;\n    display: none;\n}\n.playing .mask[data-v-364a85e9] {\n    display: block;\n}\n.playing .media-holder-video[data-v-364a85e9] {\n    display: none;\n}\n\n/*code for css*/\nul.gif_container[data-v-364a85e9] {\n    min-height: 200px;\n    padding: 15px 10px 10px;\n    font-size: 0;\n}\nul.gif_container li[data-v-364a85e9] {\n    background: #FFFFFF;\n    display: inline-block;\n    width: 49%;\n    min-height: 100px;\n    margin-bottom: 8px;\n    overflow: hidden;\n    font-size: 0;\n    vertical-align: middle;\n}\nul.gif_container li[data-v-364a85e9]:nth-child(even) {\n    margin-left: 2%;\n}\nul.gif_container li .img_con[data-v-364a85e9] {\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100% auto;\n    height: 128px;\n    width: 100%;\n}\nul.gif_container li .text_con[data-v-364a85e9] {\n    font-size: 12px;\n    margin: 0;\n    padding: 8px 8px 10px;\n    height: 52px;\n    position: relative;\n}\nul.gif_container li .text_con p[data-v-364a85e9] {\n    margin: 0;\n    height: 30px;\n    line-height: 15px;\n    text-align: left;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n}\nul.gif_container li a[data-v-364a85e9] {\n    display: block;\n    color: #333333;\n}\nul.gif_container li a[data-v-364a85e9]:visited {\n    color: #999999;\n}\n.total_view[data-v-364a85e9] {\n    position: absolute;\n    left: 8px;\n    bottom: 10px;\n    color: #16ac3a;\n}\n.comments[data-v-364a85e9] {\n    position: absolute;\n    right: 8px;\n    bottom: 10px;\n    color: #999999;\n}\n.gif[data-v-364a85e9] {\n    background-image: url('../assets/match/3x_gif_icon.png');\n    background-position: center center;\n    background-size: 20px 20px;\n    height: 20px;\n    width: 20px;\n    display: block;\n    z-index: 2000;\n}\n#app_news[data-v-364a85e9] {\n    background: #fff;\n}\n#app_news dd[data-v-364a85e9] {\n    padding: 0 14px;\n}\n#app_news dd[data-v-364a85e9] {\n    border-top: 1px solid #eeeeee;\n    /*no*/\n    height: 72px;\n}\n#app_news dd a[data-v-364a85e9] {\n    display: block;\n    color: #333;\n    height: 52px;\n    padding: 10px 0;\n    position: relative;\n}\n#app_news dd a[data-v-364a85e9]:visited {\n    color: #999999;\n}\n#app_news dd span[data-v-364a85e9] {\n    color: #aaa;\n    font-size: 11px;\n    position: absolute;\n    right: 0;\n    bottom: 9px;\n}\n#app_news dd .img_news[data-v-364a85e9] {\n    background-color: #e9e9e9;\n    width: 70px;\n    height: 52px;\n    float: left;\n    margin-right: 10px;\n    background-position: center center;\n    background-size: 100%;\n}\n#app_news dd .video_news[data-v-364a85e9] {\n    width: 70px;\n    height: 52px;\n    border-radius: 2px;\n    float: left;\n    margin-right: 12px;\n    background-position: center center;\n    background-size: 100%;\n}\n#app_news dd .video_icon[data-v-364a85e9] {\n    background: url(https://dqdfiles.b0.upaiyun.com/app/video.png) center center no-repeat rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    background-size: 20px 20px;\n}\n#app_news p[data-v-364a85e9] {\n    padding: 0 0 3px 0;\n    line-height: 18px;\n    margin: 0;\n    font-size: 14px;\n    position: relative;\n    bottom: 2px;\n}\n.loading[data-v-364a85e9] {\n    position: absolute;\n    width: 45px;\n    height: 45px;\n    background: url('../assets/match/loading-icon.png') no-repeat;\n    background-size: 100%;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    -webkit-animation: spin-data-v-364a85e9 1s linear infinite;\n            animation: spin-data-v-364a85e9 1s linear infinite;\n}\n@-webkit-keyframes spin {\n100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n}\n}\n@keyframes spin-data-v-364a85e9 {\n100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/play@80x80.0052e6a.png";

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/video.5c02d28.png";

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAMAAABFaP0WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjRBQjk2RkFFQ0Q2MTFFNDg0RTg4Mjg4REU1OUM2MTYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjRBQjk2RjlFQ0Q2MTFFNDg0RTg4Mjg4REU1OUM2MTYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzU4NUI5REJFNEIxMTFFNEI2Q0I5MkRFM0Y4Q0I2RDQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzU4NUI5RENFNEIxMTFFNEI2Q0I5MkRFM0Y4Q0I2RDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6XlUFwAAAABlBMVEUWrDoAAABaqTIbAAAADklEQVR42mJgAAGAAAMAAAYAAeBCEU4AAAAASUVORK5CYII="

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tri_l.ae7674f.png";

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tri_r.500c15b.png";

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_start.dfba46a.png";

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_end.036a353.png";

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3x_gif_icon.7314492.png";

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading-icon.c67c881.png";

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'overview',
    props: ['matchId'],
    data: function data() {
        return {
            match_data: {
                statistics: {
                    team_A: {},
                    team_B: {}
                }
            },
            isLoaded: false,
            is_empty: false,
            empty_msg: '',
            statistics_show: false,
            events_show: false
        };
    },

    computed: {
        matchOverviewFormation: function matchOverviewFormation() {
            return this.$store.state.matchDetailStore.matchOverviewFormation;
        }
    },
    created: function created() {
        if (this.matchOverviewFormation) {
            this.match_data = this.matchOverviewFormation;
            this.isLoaded = true;
            if (this.matchOverviewFormation.status === 'Fixture' || this.matchOverviewFormation.status === 'Postponed') {
                this.is_empty = true;
                this.empty_msg = this.$t('notPrepared');
                return;
            }
            if (this.matchOverviewFormation.statistics && this.matchOverviewFormation.statistics.team_A && this.matchOverviewFormation.statistics.team_B) {
                this.statistics_show = true;
            }
            if (this.matchOverviewFormation.events && this.matchOverviewFormation.events.length !== 0) {
                this.events_show = true;
            }
            if (!this.statistics_show && !this.events_show) {
                this.is_empty = true;
                this.empty_msg = this.$t('noData');
            }
        } else {
            this.isLoaded = true;
            this.is_empty = true;
            this.empty_msg = this.$t('noData');
        }
    },

    methods: {
        showDefault: function showDefault(team) {
            var defaultImg = __webpack_require__(607);
            event.target.src = defaultImg;
        },
        getHost: function getHost() {
            var hostname = location.hostname;
            var obj = {
                'localhost': 'https://api-test.allfootballapp.com',
                'test-n.allfootballapp.com': 'https://api-test.allfootballapp.com',
                'beta-n.allfootballapp.com': 'beta-api.allfootballapp.com',
                'n.allfootballapp.com': 'api.allfootballapp.com'
            };
            return obj[hostname];
        }
    }
});

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "overview"
    }
  }, [(!_vm.isLoaded) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), (_vm.is_empty) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v(_vm._s(_vm.empty_msg))]) : _c('div', {
    staticClass: "events"
  }, [(_vm.events_show) ? [_c('section', [_vm._v(_vm._s(_vm.$t('events')))]), _vm._v(" "), _c('div', {
    staticClass: "content content_p"
  }, [_c('span', {
    staticClass: "icon_start"
  }), _vm._v(" "), _c('ol', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.match_data.events), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "cf"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.minute))]), _vm._v(" "), (item.teamAEvents.length !== 0) ? _c('div', {
      staticClass: "home"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _vm._l((item.teamAEvents), function(team, index) {
      return _c('p', {
        key: index
      }, [_c('span', {
        staticClass: "person"
      }, [_c('span', {
        staticClass: "text_lim"
      }, [_vm._v(" " + _vm._s(team.person) + " ")]), _vm._v(" "), _c('img', {
        attrs: {
          "src": _vm.getImgSrc(team.event_pic)
        }
      })])])
    })], 2) : _vm._e(), _vm._v(" "), (item.teamBEvents.length !== 0) ? _c('div', {
      staticClass: "away"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _vm._l((item.teamBEvents), function(team, index) {
      return _c('p', {
        key: index
      }, [_c('span', {
        staticClass: "person"
      }, [_c('img', {
        attrs: {
          "src": _vm.getImgSrc(team.event_pic)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text_lim"
      }, [_vm._v(" " + _vm._s(team.person) + " ")])])])
    })], 2) : _vm._e()])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon_end"
  })]), _vm._v(" "), _c('div', {
    staticClass: "show"
  }, [_c('div', {
    staticClass: "show_main"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(652),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('goal')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(653),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('penalty')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(654),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('penaltySaved')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(655),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('ownGoal')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(656),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('assist')))])])])] : _vm._e(), _vm._v(" "), (_vm.statistics_show) ? [_c('section', [_vm._v(_vm._s(_vm.$t('statistics')))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('table', {
    staticClass: "head"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "away"
  }, [_c('span', {
    staticClass: "team"
  }, [_c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.match_data.statistics.team_A.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.match_data.statistics.team_A.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
    staticClass: "home"
  }, [_c('span', {
    staticClass: "team"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.match_data.statistics.team_B.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.match_data.statistics.team_B.name))])])])])])]), _vm._v(" "), (_vm.statistics_show) ? _c('table', [_c('tbody', _vm._l((_vm.match_data.statistics.list), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "away"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.team_A.value))]), _vm._v(" "), _c('span', {
      staticClass: "rank"
    }, [_c('span', {
      staticClass: "ranks",
      class: item.team_A.class,
      style: ({
        width: item.team_A.per + '%'
      })
    })])]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
      staticClass: "home"
    }, [_c('span', {
      staticClass: "rank"
    }, [_c('span', {
      staticClass: "ranks",
      class: item.team_B.class,
      style: ({
        width: item.team_B.per + '%'
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.team_B.value))])])])
  }))]) : _vm._e()])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "cf"
  }, [_c('span', {
    staticClass: "dot_s"
  })])
}]}

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_goal.8578830.png";

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_point.5156b91.png";

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_point_1.849dce5.png";

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_w.8d9879e.png";

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_a.a6c0ac3.png";

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(672),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27ea61cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("6f1e0cc3", content, true);

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "a[data-v-27ea61cc]{color:#000}body[data-v-27ea61cc],html[data-v-27ea61cc]{height:100%}body[data-v-27ea61cc]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;background:#eff1f4}div[data-v-27ea61cc],li[data-v-27ea61cc],ol[data-v-27ea61cc],p[data-v-27ea61cc],ul[data-v-27ea61cc]{margin:0;padding:0}body[data-v-27ea61cc]{margin:0;padding:0;font-size:12px;-webkit-font-smoothing:antialiased;position:relative}nav[data-v-27ea61cc]{font-size:14px;height:30px;line-height:30px;font-weight:700;color:#333;background:#e2e4e6;text-align:left;padding-left:16px}nav a[data-v-27ea61cc]{font-size:12px;float:right;margin-right:5px;color:#16ac3a;text-decoration:none}.container[data-v-27ea61cc]{position:relative}.forecast[data-v-27ea61cc]{top:5px;text-align:center;width:100%;font-size:14px;color:#999;margin-bottom:-15px;background:#eff1f4;padding-top:5px;margin-top:0}ul.vote_con[data-v-27ea61cc]{margin:0;height:120px;padding:15px 10%;background:#eff1f4;list-style:none}ul.vote_con li[data-v-27ea61cc]{width:33.3333333333%;float:left;position:relative}ul.vote_con li[data-v-27ea61cc]:first-child{left:-3%}ul.vote_con li[data-v-27ea61cc]:last-child{right:-3%}ul .vote_view[data-v-27ea61cc]{position:relative;width:86%;height:112px;margin:0 auto}ul .vote_view .bottom_vote[data-v-27ea61cc]{text-align:center;color:#fff;position:relative;height:30px;line-height:30px;font-size:14px;width:100%;border-bottom-left-radius:4px;border-bottom-right-radius:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}ul .vote_view p[data-v-27ea61cc]{color:#999;text-align:center;width:100%;margin:0;font-size:12px;height:35px;line-height:35px;white-space:nowrap}ul .vote_view p img[data-v-27ea61cc]{position:relative;bottom:1px;height:16px;width:16px;vertical-align:middle}ul .vote_view b[data-v-27ea61cc]{display:block;font-size:16px;color:#fff}ul .bottom_vote span[data-v-27ea61cc]{display:inline-block;margin-right:4px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdDMkI5M0YzRUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdDMkI5M0Y0RUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjFFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjJFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ZbxI3AAAA+klEQVR42mL8//8/AwnAAIi9gHglEN8lSgfIAhLwjv8Q8AmII4nRQ4rhrED85D8qsCWkj4mE4JEDYkE0sU5CmkixQAmIudDELIFYlVoW4DJIhloWmGBLI0D8gxoWgILGB4v4FyB+SA0L+oBYFIv4dSB+hk8jC5RWB2JWHCknCYiDcej/A8RaOBz6G4hvgtJq+X/agXJGIPEVS/KjFvgB8to/BtqB00zQsKIV2MzEQFtwgJYW3Abic7S04CAQ/6WlBRtJLYtIAR+A+BgtLQAFzztaWrAXubBjo7Lh/9Et+ENlCx4A8TXk0jQDiPuBmJ0Khn8C4kxkAYAAAwC3wR7EkrY5PgAAAABJRU5ErkJggg==);background-position:50%;background-size:12px 12px;background-repeat:no-repeat;height:12px;width:12px;vertical-align:middle;position:relative;bottom:1px}ul .bottom_vote span.voted[data-v-27ea61cc]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjgwRkYzQkNDRUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjgwRkYzQkNERUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjVFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjZFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4U4m8kAAAA6klEQVR42rSWywrCMBBF07QKWhUVRNy4EkXdufL/P0EXfoHShRXF+gC19Q5EKcGqgZkLh5ahySEhGeplWaYc0gBdsAGnfwZ4joI56IA7WID1rwHaYXL6tm7eAzADbU5BBZSs2oRTUAW+VWuBkEsQflkZi6BZUH9wCHxzPO3QabpwCKag/KGegOu3gYF51uhOFOxvH/QKxqe5o2uHLlhCF22Al7GSyYq2aKjkMtJmKVLZSwsirWQTSwqonR8kBTFtv6Qgcu1FLrmBnaQgNhIxwTbf7LS0IGWe/AyO+W66NO2YYyWvv413ngIMAJZ8LcWM3z54AAAAAElFTkSuQmCC)}ul .vote_view .vote_box[data-v-27ea61cc]{position:relative;left:0;height:72px;width:100%;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.05);overflow:hidden}#away .progress[data-v-27ea61cc]{background:#f12b2b}#away .bottom_vote[data-v-27ea61cc]{background:#cd2525}#away .clicked[data-v-27ea61cc]{color:#dc6767}#home .progress[data-v-27ea61cc]{background:#49c867}#home .bottom_vote[data-v-27ea61cc]{background:#3eaa58}#home .clicked[data-v-27ea61cc]{color:#78c48a}#draw .progress[data-v-27ea61cc]{background:#1d9ff9}#draw .bottom_vote[data-v-27ea61cc]{background:#1987d4}#draw .clicked[data-v-27ea61cc]{color:#5eabe1}.progress_con[data-v-27ea61cc]{position:relative;width:100%;height:100%}.progress[data-v-27ea61cc]{position:absolute;border-top-left-radius:4px;border-top-right-radius:4px;bottom:0;width:100%;height:20px;line-height:20px;z-index:1;text-align:center;color:#151515;font-weight:700;transition:background .25s ease}.content.preview[data-v-27ea61cc]{background:#eff1f4;margin:0}.content iframe[data-v-27ea61cc]{width:100%;border:none;margin:0}.content.overview p[data-v-27ea61cc]{background:#eff1f4;margin:0;width:100%;position:absolute;bottom:0;top:50px;font-size:14px;line-height:220px;color:#999;text-align:center}#mask[data-v-27ea61cc]{position:fixed;margin:auto;top:180px;left:0;right:0;height:40px;line-height:40px;text-align:center}#mask span[data-v-27ea61cc]{font-size:14px;padding:10px 16px;text-align:center;line-height:25px;border-radius:4px;color:#fff;background-color:#383a3c;display:inline-block;max-width:67%}input[data-v-27ea61cc]{border:0;margin:0;padding:0;width:0;height:0}nav.tab[data-v-27ea61cc]{text-align:center;display:block;width:100%;background:#eff1f4;height:auto;padding:16px 0;line-height:0}nav.tab ul[data-v-27ea61cc]{display:inline-block;border:1px solid #16ac3a;font-size:14px;border-radius:2px;width:64%;font-size:0;list-style:none;padding:0;height:28px}nav.tab li[data-v-27ea61cc]{list-style:none;display:inline-block;width:50%;font-size:14px;line-height:28px;height:28px;color:#16ac3a}nav.tab li a[data-v-27ea61cc]{display:block;color:inherit;font-size:inherit;text-align:inherit;width:100%;padding:0;margin:0}nav.tab li.current[data-v-27ea61cc]{background:#16ac3a;color:#fff}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/matchAnalysis.vue"],"names":[],"mappings":"AACA,mBACI,UAAY,CACf,AACD,4CAEI,WAAa,CAChB,AACD,sBAEI,sDAA4D,AAC5D,kBAAoB,CACvB,AACD,oGAKI,SAAU,AACV,SAAW,CACd,AACD,sBACI,SAAU,AACV,UAAW,AACX,eAAgB,AAChB,mCAAoC,AACpC,iBAAmB,CACtB,AACD,qBACI,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,uBACI,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,cAAe,AACf,oBAAsB,CACzB,AACD,4BACI,iBAAmB,CACtB,AACD,2BACI,QAAS,AACT,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,WAAe,AACf,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,YAAc,CACjB,AAED,6BACI,SAAU,AACV,aAAc,AACd,iBAAkB,AAClB,mBAAoB,AACpB,eAAiB,CACpB,AACD,gCACI,qBAAsB,AACtB,WAAY,AACZ,iBAAmB,CACtB,AACD,4CACI,QAAU,CACb,AACD,2CACI,SAAW,CACd,AACD,+BACI,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,aAAe,CAClB,AACD,4CACI,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,WAAY,AACZ,8BAA+B,AAC/B,+BAAgC,AAChC,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,iCACI,WAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,kBAAoB,CACvB,AACD,qCACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,qBAAuB,CAC1B,AACD,iCACI,cAAe,AACf,eAAgB,AAChB,UAAY,CACf,AACD,sCACI,qBAAsB,AACtB,iBAAkB,AAClB,yjDAA0jD,AAC1jD,wBAAmC,AACnC,0BAA2B,AAC3B,4BAA6B,AAC7B,YAAa,AACb,WAAY,AACZ,sBAAuB,AACvB,kBAAmB,AACnB,UAAY,CACf,AACD,4CACI,giDAAkiD,CACriD,AACD,yCACI,kBAAmB,AACnB,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,6CAAoD,AACpD,eAAiB,CACpB,AACD,iCACI,kBAAoB,CACvB,AACD,oCACI,kBAAoB,CACvB,AACD,gCACI,aAAe,CAClB,AACD,iCACI,kBAAoB,CACvB,AACD,oCACI,kBAAoB,CACvB,AACD,gCACI,aAAe,CAClB,AACD,iCACI,kBAAoB,CACvB,AACD,oCACI,kBAAoB,CACvB,AACD,gCACI,aAAe,CAClB,AACD,+BACI,kBAAmB,AACnB,WAAY,AACZ,WAAa,CAChB,AACD,2BACI,kBAAmB,AACnB,2BAA4B,AAC5B,4BAA6B,AAC7B,SAAU,AACV,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,UAAW,AACX,kBAAmB,AACnB,cAAe,AACf,gBAAkB,AAClB,+BAAkC,CACrC,AACD,kCACI,mBAAoB,AACpB,QAAU,CACb,AACD,iCACI,WAAY,AACZ,YAAa,AACb,QAAU,CACb,AACD,qCACI,mBAAoB,AACpB,SAAU,AACV,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,eAAgB,AAChB,kBAAmB,AACnB,WAAY,AACZ,iBAAmB,CACtB,AACD,uBACI,eAAgB,AAChB,YAAa,AACb,UAAW,AACX,OAAQ,AACR,QAAS,AACT,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACtB,AACD,4BACI,eAAgB,AAChB,kBAAmB,AACnB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,yBAA0B,AAC1B,qBAAsB,AACtB,aAAe,CAClB,AAGD,uBACI,SAAU,AACV,SAAU,AACV,UAAW,AACX,QAAS,AACT,QAAU,CACb,AACD,yBACI,kBAAmB,AACnB,cAAe,AACf,WAAY,AACZ,mBAAoB,AACpB,YAAa,AACb,eAAgB,AAChB,aAAe,CAClB,AACD,4BACI,qBAAsB,AACtB,yBAA0B,AAE1B,eAAgB,AAChB,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,gBAAiB,AACjB,UAAW,AACX,WAAa,CAChB,AACD,4BACI,gBAAiB,AACjB,qBAAsB,AACtB,UAAW,AACX,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,aAAe,CAClB,AACD,8BACI,cAAe,AACf,cAAe,AACf,kBAAmB,AACnB,mBAAoB,AACpB,WAAY,AACZ,UAAW,AACX,QAAU,CACb,AACD,oCACI,mBAAoB,AACpB,UAAY,CACf","file":"matchAnalysis.vue","sourcesContent":["\na[data-v-27ea61cc] {\n    color: #000;\n}\nhtml[data-v-27ea61cc],\nbody[data-v-27ea61cc] {\n    height: 100%;\n}\nbody[data-v-27ea61cc] {\n    /*设置英文字体*/\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    background: #eff1f4;\n}\np[data-v-27ea61cc],\ndiv[data-v-27ea61cc],\nul[data-v-27ea61cc],\nol[data-v-27ea61cc],\nli[data-v-27ea61cc]{\n    margin: 0;\n    padding: 0;\n}\nbody[data-v-27ea61cc] {\n    margin: 0;\n    padding: 0;\n    font-size: 12px;\n    -webkit-font-smoothing: antialiased;\n    position: relative;\n}\nnav[data-v-27ea61cc] {\n    font-size: 14px;\n    height: 30px;\n    line-height: 30px;\n    font-weight: 700;\n    color: #333;\n    background: #e2e4e6;\n    text-align: left;\n    padding-left: 16px;\n}\nnav a[data-v-27ea61cc] {\n    font-size: 12px;\n    float: right;\n    margin-right: 5px;\n    color: #16ac3a;\n    text-decoration: none;\n}\n.container[data-v-27ea61cc] {\n    position: relative;\n}\n.forecast[data-v-27ea61cc] {\n    top: 5px;\n    text-align: center;\n    width: 100%;\n    font-size: 14px;\n    color: #999999;\n    margin-bottom: -15px;\n    background: #eff1f4;\n    padding-top: 5px;\n    margin-top: 0;\n}\n/*预测样式*/\nul.vote_con[data-v-27ea61cc] {\n    margin: 0;\n    height: 120px;\n    padding: 15px 10%;\n    background: #eff1f4;\n    list-style: none;\n}\nul.vote_con li[data-v-27ea61cc] {\n    width: 33.3333333333%;\n    float: left;\n    position: relative;\n}\nul.vote_con li[data-v-27ea61cc]:first-child {\n    left: -3%;\n}\nul.vote_con li[data-v-27ea61cc]:last-child {\n    right: -3%;\n}\nul .vote_view[data-v-27ea61cc] {\n    position: relative;\n    width: 86%;\n    height: 112px;\n    margin: 0 auto;\n}\nul .vote_view .bottom_vote[data-v-27ea61cc] {\n    text-align: center;\n    color: #fff;\n    position: relative;\n    height: 30px;\n    line-height: 30px;\n    font-size: 14px;\n    width: 100%;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\nul .vote_view p[data-v-27ea61cc] {\n    color: #999999;\n    text-align: center;\n    width: 100%;\n    margin: 0;\n    font-size: 12px;\n    height: 35px;\n    line-height: 35px;\n    white-space: nowrap;\n}\nul .vote_view p img[data-v-27ea61cc] {\n    position: relative;\n    bottom: 1px;\n    height: 16px;\n    width: 16px;\n    vertical-align: middle;\n}\nul .vote_view b[data-v-27ea61cc] {\n    display: block;\n    font-size: 16px;\n    color: #fff;\n}\nul .bottom_vote span[data-v-27ea61cc] {\n    display: inline-block;\n    margin-right: 4px;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdDMkI5M0YzRUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdDMkI5M0Y0RUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjFFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjJFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ZbxI3AAAA+klEQVR42mL8//8/AwnAAIi9gHglEN8lSgfIAhLwjv8Q8AmII4nRQ4rhrED85D8qsCWkj4mE4JEDYkE0sU5CmkixQAmIudDELIFYlVoW4DJIhloWmGBLI0D8gxoWgILGB4v4FyB+SA0L+oBYFIv4dSB+hk8jC5RWB2JWHCknCYiDcej/A8RaOBz6G4hvgtJq+X/agXJGIPEVS/KjFvgB8to/BtqB00zQsKIV2MzEQFtwgJYW3Abic7S04CAQ/6WlBRtJLYtIAR+A+BgtLQAFzztaWrAXubBjo7Lh/9Et+ENlCx4A8TXk0jQDiPuBmJ0Khn8C4kxkAYAAAwC3wR7EkrY5PgAAAABJRU5ErkJggg==);\n    background-position: center center;\n    background-size: 12px 12px;\n    background-repeat: no-repeat;\n    height: 12px;\n    width: 12px;\n    vertical-align: middle;\n    position: relative;\n    bottom: 1px;\n}\nul .bottom_vote span.voted[data-v-27ea61cc] {\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjgwRkYzQkNDRUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjgwRkYzQkNERUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjVFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjZFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4U4m8kAAAA6klEQVR42rSWywrCMBBF07QKWhUVRNy4EkXdufL/P0EXfoHShRXF+gC19Q5EKcGqgZkLh5ahySEhGeplWaYc0gBdsAGnfwZ4joI56IA7WID1rwHaYXL6tm7eAzADbU5BBZSs2oRTUAW+VWuBkEsQflkZi6BZUH9wCHxzPO3QabpwCKag/KGegOu3gYF51uhOFOxvH/QKxqe5o2uHLlhCF22Al7GSyYq2aKjkMtJmKVLZSwsirWQTSwqonR8kBTFtv6Qgcu1FLrmBnaQgNhIxwTbf7LS0IGWe/AyO+W66NO2YYyWvv413ngIMAJZ8LcWM3z54AAAAAElFTkSuQmCC);\n}\nul .vote_view .vote_box[data-v-27ea61cc] {\n    position: relative;\n    left: 0;\n    height: 72px;\n    width: 100%;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    overflow: hidden;\n}\n#away .progress[data-v-27ea61cc] {\n    background: #f12b2b;\n}\n#away .bottom_vote[data-v-27ea61cc] {\n    background: #cd2525;\n}\n#away .clicked[data-v-27ea61cc] {\n    color: #dc6767;\n}\n#home .progress[data-v-27ea61cc] {\n    background: #49c867;\n}\n#home .bottom_vote[data-v-27ea61cc] {\n    background: #3eaa58;\n}\n#home .clicked[data-v-27ea61cc] {\n    color: #78c48a;\n}\n#draw .progress[data-v-27ea61cc] {\n    background: #1d9ff9;\n}\n#draw .bottom_vote[data-v-27ea61cc] {\n    background: #1987d4;\n}\n#draw .clicked[data-v-27ea61cc] {\n    color: #5eabe1;\n}\n.progress_con[data-v-27ea61cc] {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n.progress[data-v-27ea61cc] {\n    position: absolute;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    bottom: 0;\n    width: 100%;\n    height: 20px;\n    line-height: 20px;\n    z-index: 1;\n    text-align: center;\n    color: #151515;\n    font-weight: bold;\n    transition: background 250ms ease;\n}\n.content.preview[data-v-27ea61cc] {\n    background: #eff1f4;\n    margin: 0;\n}\n.content iframe[data-v-27ea61cc] {\n    width: 100%;\n    border: none;\n    margin: 0;\n}\n.content.overview p[data-v-27ea61cc] {\n    background: #eff1f4;\n    margin: 0;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    top: 50px;\n    font-size: 14px;\n    line-height: 220px;\n    color: #999;\n    text-align: center;\n}\n#mask[data-v-27ea61cc] {\n    position: fixed;\n    margin: auto;\n    top: 180px;\n    left: 0;\n    right: 0;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n}\n#mask span[data-v-27ea61cc] {\n    font-size: 14px;\n    padding: 10px 16px;\n    text-align: center;\n    line-height: 25px;\n    border-radius: 4px;\n    color: #fff;\n    background-color: #383a3c;\n    display: inline-block;\n    max-width: 67%;\n}\n\n/*未知模块*/\ninput[data-v-27ea61cc] {\n    border: 0;\n    margin: 0;\n    padding: 0;\n    width: 0;\n    height: 0;\n}\nnav.tab[data-v-27ea61cc] {\n    text-align: center;\n    display: block;\n    width: 100%;\n    background: #eff1f4;\n    height: auto;\n    padding: 16px 0;\n    line-height: 0;\n}\nnav.tab ul[data-v-27ea61cc] {\n    display: inline-block;\n    border: 1px solid #16ac3a;\n    /*no*/\n    font-size: 14px;\n    border-radius: 2px;\n    width: 64%;\n    font-size: 0;\n    list-style: none;\n    padding: 0;\n    height: 28px;\n}\nnav.tab li[data-v-27ea61cc] {\n    list-style: none;\n    display: inline-block;\n    width: 50%;\n    font-size: 14px;\n    line-height: 28px;\n    height: 28px;\n    color: #16ac3a;\n}\nnav.tab li a[data-v-27ea61cc] {\n    display: block;\n    color: inherit;\n    font-size: inherit;\n    text-align: inherit;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n}\nnav.tab li.current[data-v-27ea61cc] {\n    background: #16ac3a;\n    color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fingerprintjs__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fingerprintjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fingerprintjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pastGames_vue__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pastGames_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pastGames_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skeleton_vue__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skeleton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__skeleton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isShowOverview: false,
            tabShow: 'preview',
            voteData: {
                data: [{ id: 1, name: 'Home', num: 0, percent: 0 }, { id: 2, name: 'Draw', num: 0, percent: 0 }, { id: 3, name: 'Away', num: 0, percent: 0 }],
                total_num: 0,
                select_opt: []
            },
            analysisData: null,
            animateFinished: false,
            elAnalysisHtml: '',
            elOverviewHtml: '',
            homeImgSrc: '',
            awayImgSrc: '',
            UUID: ''
        };
    },

    props: ['matchId'],
    components: {
        PastGames: __WEBPACK_IMPORTED_MODULE_1__pastGames_vue___default.a,
        Skeleton: __WEBPACK_IMPORTED_MODULE_2__skeleton_vue___default.a
    },
    computed: {
        matchAnalysisFormation: function matchAnalysisFormation() {
            return this.$store.state.matchDetailStore.matchAnalysisFormation;
        }
    },
    created: function created() {
        this.homeImgSrc = this.matchAnalysisFormation.team_A_logo || '';
        this.awayImgSrc = this.matchAnalysisFormation.team_B_logo || '';
        this.analysisData = this.matchAnalysisFormation || null;
    },
    mounted: function mounted() {
        var _this = this;

        this.UUID = 'CA' + new __WEBPACK_IMPORTED_MODULE_0_fingerprintjs___default.a({ canvas: true }).get();
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/v2/vote/result/match/' + this.matchId, {
            headers: {
                uuid: this.UUID
            },
            params: {
                language: this.$i18n.local
            }
        }).then(function (res) {
            var data = res.data;
            if (data.errCode === 0) {
                _this.voteData = data.data;
                _this.votePercent(_this.voteData);
            }
        }).catch(function () {
            console.log('出错了');
        });
    },

    watch: {
        elOverviewHtml: function elOverviewHtml() {
            this.resizeIframeHeight();
        }
    },
    methods: {
        votePercent: function votePercent(voteData) {
            var percents = [];
            var offsetPercent = 0;

            voteData.data.forEach(function (item) {
                var per = voteData.total_num ? item.num / voteData.total_num * 100 : 0;
                item.percent = Math.round(per);
                offsetPercent += item.percent;

                percents.push(per - Math.floor(per));
            });
            if (!offsetPercent) {
                return;
            }
            if (offsetPercent > 100) {
                var i = percents.indexOf(Math.min.apply(null, percents));
                voteData.data[i].percent -= 1;
            } else if (offsetPercent < 100) {
                var _i = percents.indexOf(Math.max.apply(null, percents));
                voteData.data[_i].percent += 1;
            }
        },
        height: function height(num) {
            if (!this.voteData.total_num) {
                return 20;
            }
            return Math.floor(num / this.voteData.total_num * 52 + 20);
        },
        votable: function votable() {
            if (this.isMatchStart()) {
                return false;
            }
            if (this.voteData.select_opt && this.voteData.select_opt.length) {
                return false;
            }

            return true;
        },
        voted: function voted(id) {
            if (this.voteData.select_opt && this.voteData.select_opt.some(function (item) {
                return +item === id;
            })) {
                return true;
            }
            return false;
        },
        vote: function vote(id) {
            var _this2 = this;

            if (this.votable() && !this.voted(id)) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/v2/vote/match/' + this.matchId + '?match_id=' + this.matchId + '&opt_id=' + id, {
                    headers: {
                        uuid: this.UUID
                    },
                    params: {
                        language: this.$i18n.local
                    }
                }).then(function (res) {
                    if (res.status !== 200) {
                        return;
                    }
                    var data = res.data;
                    if (!data.errCode) {
                        _this2.voteData.select_opt.push(id);
                        _this2.voteData.data[id - 1].num++;
                        _this2.voteData.total_num++;
                        _this2.votePercent(_this2.voteData);
                    }
                });
            }
        },
        resizeIframeHeight: function resizeIframeHeight() {
            var frame = document.getElementById('overviewFrame');
            if (!this.elOverviewHtml || !frame) {
                return;
            }

            var iframeDoc = frame.contentDocument || frame.contentWindow.document;

            iframeDoc.open();
            iframeDoc.write(this.elOverviewHtml);
            iframeDoc.close();

            frame.style.height = iframeDoc.body.scrollHeight + 'px';
        },
        isMatchStart: function isMatchStart() {
            var voteData = this.voteData;
            if (voteData && voteData.start_time) {
                var date = new Date(voteData.start_time.replace(/-/g, '/')).getTime();
                var diffMin = new Date().getTimezoneOffset();
                date = date - diffMin * 60 * 1000;
                var nowDate = new Date().getTime();

                return nowDate >= date;
            }
            return true;
        }
    }
});

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* fingerprintJS 0.5.3 - Fast browser fingerprint library
* https://github.com/Valve/fingerprintjs
* Copyright (c) 2013 Valentin Vasilyev (valentin.vasilyev@outlook.com)
* Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*/

;(function (name, context, definition) {
  if (typeof module !== 'undefined' && module.exports) { module.exports = definition(); }
  else if (true) { !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); }
  else { context[name] = definition(); }
})('Fingerprint', this, function () {
  'use strict';
  
  var Fingerprint = function (options) {
    var nativeForEach, nativeMap;
    nativeForEach = Array.prototype.forEach;
    nativeMap = Array.prototype.map;

    this.each = function (obj, iterator, context) {
      if (obj === null) {
        return;
      }
      if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          if (iterator.call(context, obj[i], i, obj) === {}) return;
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (iterator.call(context, obj[key], key, obj) === {}) return;
          }
        }
      }
    };

    this.map = function(obj, iterator, context) {
      var results = [];
      // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.
      if (obj == null) return results;
      if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
      this.each(obj, function(value, index, list) {
        results[results.length] = iterator.call(context, value, index, list);
      });
      return results;
    };

    if (typeof options == 'object'){
      this.hasher = options.hasher;
      this.screen_resolution = options.screen_resolution;
      this.canvas = options.canvas;
      this.ie_activex = options.ie_activex;
    } else if(typeof options == 'function'){
      this.hasher = options;
    }
  };

  Fingerprint.prototype = {
    get: function(){
      var keys = [];
      keys.push(navigator.userAgent);
      keys.push(navigator.language);
      keys.push(screen.colorDepth);
      if (this.screen_resolution) {
        var resolution = this.getScreenResolution();
        if (typeof resolution !== 'undefined'){ // headless browsers, such as phantomjs
          keys.push(this.getScreenResolution().join('x'));
        }
      }
      keys.push(new Date().getTimezoneOffset());
      keys.push(this.hasSessionStorage());
      keys.push(this.hasLocalStorage());
      keys.push(!!window.indexedDB);
      //body might not be defined at this point or removed programmatically
      if(document.body){
        keys.push(typeof(document.body.addBehavior));
      } else {
        keys.push(typeof undefined);
      }
      keys.push(typeof(window.openDatabase));
      keys.push(navigator.cpuClass);
      keys.push(navigator.platform);
      keys.push(navigator.doNotTrack);
      keys.push(this.getPluginsString());
      if(this.canvas && this.isCanvasSupported()){
        keys.push(this.getCanvasFingerprint());
      }
      if(this.hasher){
        return this.hasher(keys.join('###'), 31);
      } else {
        return this.murmurhash3_32_gc(keys.join('###'), 31);
      }
    },

    /**
     * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
     * 
     * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
     * @see http://github.com/garycourt/murmurhash-js
     * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
     * @see http://sites.google.com/site/murmurhash/
     * 
     * @param {string} key ASCII only
     * @param {number} seed Positive integer only
     * @return {number} 32-bit positive integer hash 
     */

    murmurhash3_32_gc: function(key, seed) {
      var remainder, bytes, h1, h1b, c1, c2, k1, i;
      
      remainder = key.length & 3; // key.length % 4
      bytes = key.length - remainder;
      h1 = seed;
      c1 = 0xcc9e2d51;
      c2 = 0x1b873593;
      i = 0;
      
      while (i < bytes) {
          k1 = 
            ((key.charCodeAt(i) & 0xff)) |
            ((key.charCodeAt(++i) & 0xff) << 8) |
            ((key.charCodeAt(++i) & 0xff) << 16) |
            ((key.charCodeAt(++i) & 0xff) << 24);
        ++i;
        
        k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

        h1 ^= k1;
            h1 = (h1 << 13) | (h1 >>> 19);
        h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
        h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
      }
      
      k1 = 0;
      
      switch (remainder) {
        case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
        case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
        case 1: k1 ^= (key.charCodeAt(i) & 0xff);
        
        k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
        h1 ^= k1;
      }
      
      h1 ^= key.length;

      h1 ^= h1 >>> 16;
      h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
      h1 ^= h1 >>> 13;
      h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
      h1 ^= h1 >>> 16;

      return h1 >>> 0;
    },

    // https://bugzilla.mozilla.org/show_bug.cgi?id=781447
    hasLocalStorage: function () {
      try{
        return !!window.localStorage;
      } catch(e) {
        return true; // SecurityError when referencing it means it exists
      }
    },
    
    hasSessionStorage: function () {
      try{
        return !!window.sessionStorage;
      } catch(e) {
        return true; // SecurityError when referencing it means it exists
      }
    },

    isCanvasSupported: function () {
      var elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    },

    isIE: function () {
      if(navigator.appName === 'Microsoft Internet Explorer') {
        return true;
      } else if(navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)){// IE 11
        return true;
      }
      return false;
    },

    getPluginsString: function () {
      if(this.isIE() && this.ie_activex){
        return this.getIEPluginsString();
      } else {
        return this.getRegularPluginsString();
      }
    },

    getRegularPluginsString: function () {
      return this.map(navigator.plugins, function (p) {
        var mimeTypes = this.map(p, function(mt){
          return [mt.type, mt.suffixes].join('~');
        }).join(',');
        return [p.name, p.description, mimeTypes].join('::');
      }, this).join(';');
    },

    getIEPluginsString: function () {
      if(window.ActiveXObject){
        var names = ['ShockwaveFlash.ShockwaveFlash',//flash plugin
          'AcroPDF.PDF', // Adobe PDF reader 7+
          'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
          'QuickTime.QuickTime', // QuickTime
          // 5 versions of real players
          'rmocx.RealPlayer G2 Control',
          'rmocx.RealPlayer G2 Control.1',
          'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
          'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
          'RealPlayer',
          'SWCtl.SWCtl', // ShockWave player
          'WMPlayer.OCX', // Windows media player
          'AgControl.AgControl', // Silverlight
          'Skype.Detection'];
          
        // starting to detect plugins in IE
        return this.map(names, function(name){
          try{
            new ActiveXObject(name);
            return name;
          } catch(e){
            return null;
          }
        }).join(';');
      } else {
        return ""; // behavior prior version 0.5.0, not breaking backwards compat.
      }
    },

    getScreenResolution: function () {
      return [screen.height, screen.width];
    },

    getCanvasFingerprint: function () {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      // https://www.browserleaks.com/canvas#how-does-it-work
      var txt = 'http://valve.github.io';
      ctx.textBaseline = "top";
      ctx.font = "14px 'Arial'";
      ctx.textBaseline = "alphabetic";
      ctx.fillStyle = "#f60";
      ctx.fillRect(125,1,62,20);
      ctx.fillStyle = "#069";
      ctx.fillText(txt, 2, 15);
      ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
      ctx.fillText(txt, 4, 17);
      return canvas.toDataURL();
    }
  };


  return Fingerprint;

});


/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fd95a5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(664);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("63fcadfb", content, true);

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "a[data-v-1fd95a5a]{color:#000}body[data-v-1fd95a5a],html[data-v-1fd95a5a]{height:100%}body[data-v-1fd95a5a]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;background:#eff1f4}div[data-v-1fd95a5a],li[data-v-1fd95a5a],ol[data-v-1fd95a5a],p[data-v-1fd95a5a],ul[data-v-1fd95a5a]{margin:0;padding:0}body[data-v-1fd95a5a]{margin:0;padding:0;-webkit-font-smoothing:antialiased;position:relative}nav[data-v-1fd95a5a]{font-size:14px;height:30px;line-height:30px;font-weight:700;color:#333;background:#e2e4e6;text-align:left;padding-left:16px}nav a[data-v-1fd95a5a]{font-size:12px;float:right;margin-right:5px;color:#16ac3a;text-decoration:none}.t[data-v-1fd95a5a]{border-bottom:1px solid #ddd}.con[data-v-1fd95a5a]{width:100%}.con .channel-wrap[data-v-1fd95a5a]{font-size:0}.con .channel[data-v-1fd95a5a]{width:50%;display:inline-block;box-sizing:border-box;height:40px;border-bottom:1px solid #ddd;border-right:1px solid #ddd;text-align:center;line-height:40px;font-size:14px;color:#333;font-weight:700}.con .channel[data-v-1fd95a5a]:nth-child(2n){border-right:none!important}.con .channel[data-v-1fd95a5a]:last-child,.con .channel[data-v-1fd95a5a]:nth-last-child(2):nth-child(odd){border-bottom:none!important}.con .title[data-v-1fd95a5a]{padding:0 10px;background:#eff1f4;font-weight:700;color:#333;height:35px;line-height:35px;border-bottom:1px solid #ddd}.help[data-v-1fd95a5a]{display:inline-block;width:14px;height:14px;font-size:0;background:url(" + __webpack_require__(665) + ") no-repeat;vertical-align:middle;background-size:100% 100%;float:none}.con .title_1[data-v-1fd95a5a]{padding:0 10px 0 16px;background:#eff1f4;font-weight:700;color:#333;height:35px;line-height:35px}.con .box[data-v-1fd95a5a]{background:#eff1f4;padding:10px 10px 5px}.con .box table[data-v-1fd95a5a]{width:100%}.con .box td[data-v-1fd95a5a]{width:30%;height:auto;line-height:20px;font-weight:700;color:#333;text-align:left;display:inline-block;font-size:14px;border:0;background:none;vertical-align:text-top}.con .box td.mid[data-v-1fd95a5a]{width:40%;text-align:center}.con .box td.away[data-v-1fd95a5a]{text-align:right}div.bar[data-v-1fd95a5a]{height:25px;line-height:25px;padding:0 10px 16px;border-bottom:1px solid #ddd}div.bar td[data-v-1fd95a5a]{color:#fff;padding:0;margin:0;border:0;font-size:12px}div.bar .lose[data-v-1fd95a5a]{background:#f12b2b;text-align:right;padding-right:5px}div.bar .win[data-v-1fd95a5a]{background:#49c867;text-align:left;padding-left:5px}div.bar .draw[data-v-1fd95a5a]{background:#1d9ff9}img[data-v-1fd95a5a]{width:20px;margin:0 5px 0 0;vertical-align:middle}.con .title img[data-v-1fd95a5a]{width:20px!important;height:auto!important;display:inline-block}table[data-v-1fd95a5a]{border-collapse:collapse;width:100%;max-width:100%;word-break:break-word}table th[data-v-1fd95a5a]{height:25px;line-height:1.2;color:#999;font-size:11px;-webkit-transform:scale(.9);transform:scale(.9)}table td[data-v-1fd95a5a],table th[data-v-1fd95a5a]{vertical-align:middle;text-align:center;border-bottom:1px solid #ddd}table td[data-v-1fd95a5a]{color:#555;height:30px;padding:3px 0}table td p[data-v-1fd95a5a]{line-height:10px;font-size:10px;height:10px;margin:0;padding:0;font-family:arial;text-align:center;-webkit-transform:scale(.8);transform:scale(.8)}div.none[data-v-1fd95a5a]{height:55px;line-height:55px;text-align:center;font-size:14px;color:#999}.match-prediction-result[data-v-1fd95a5a],.match-prediction[data-v-1fd95a5a]{text-align:center}.match-prediction h2[data-v-1fd95a5a]{font-size:18px;color:#333;margin:20px 0 15px}.match-prediction-result h2[data-v-1fd95a5a]{font-size:18px;color:#16ac3a;margin:20px 0 15px}.match-prediction-result h2.long-title[data-v-1fd95a5a]{font-size:14px}.match-prediction .btn[data-v-1fd95a5a]{display:inline-block;width:146px;height:36px;color:#fff;background-color:var(--mainColor);font-size:16px;text-decoration:none;font-weight:700;border-radius:2px;line-height:36px}.match-prediction-result p[data-v-1fd95a5a],.match-prediction p[data-v-1fd95a5a]{color:#8c9399;line-height:1.4;padding:0 10px;margin-bottom:15px}.match-prediction p.free-chance[data-v-1fd95a5a]{color:#333}.match-prediction p.free-chance b[data-v-1fd95a5a]{color:#16ac3a;font-size:15px}.list_1 .date[data-v-1fd95a5a]{width:50px}.list_1 .cup[data-v-1fd95a5a]{width:70px}.list_1 .away[data-v-1fd95a5a],.list_1 .home[data-v-1fd95a5a]{width:88px}.list_1 .stat[data-v-1fd95a5a]{width:24px}.list_2 .name[data-v-1fd95a5a]{text-align:left}.list_2 .rank[data-v-1fd95a5a]{width:24px}.list_2 tr.top td[data-v-1fd95a5a]{background:#16ac3a;color:#fff;border-bottom:1px solid #128a2e}span.stat[data-v-1fd95a5a]{display:inline-block;padding:0 5px;height:16px;line-height:17px;color:#fff}tr.lose td.team[data-v-1fd95a5a],tr.lose td.team a[data-v-1fd95a5a]{color:#f12b2b}tr.lose span.stat[data-v-1fd95a5a]{background:#f12b2b}tr.draw td.team[data-v-1fd95a5a],tr.draw td.team a[data-v-1fd95a5a]{color:#1d9ff9}tr.draw span.stat[data-v-1fd95a5a]{background:#1d9ff9}tr.win td.team[data-v-1fd95a5a],tr.win td.team a[data-v-1fd95a5a]{color:#49c867}tr.win span.stat[data-v-1fd95a5a]{background:#49c867}.list_3 td[data-v-1fd95a5a],.list_3 th[data-v-1fd95a5a]{border:1px solid #ddd;padding:10px 18px 10px 10px;height:20px;line-height:20px;text-align:left;border-collapse:collapse}.list_3 th[data-v-1fd95a5a]{color:#333;font-size:12px;background:#eff1f4;-webkit-transform:scale(1);transform:scale(1)}.list_3 td[data-v-1fd95a5a]{position:relative;width:50%}.list_3 td a[data-v-1fd95a5a]{text-decoration:none}.content span.num[data-v-1fd95a5a]{display:inline-block;width:18px;margin:-2px 5px 0 0;height:18px;text-align:center;line-height:18px;background:#eff1f4;vertical-align:middle;border-radius:18px;font-family:arial}span.reason[data-v-1fd95a5a]{position:absolute;top:13px;right:15px;width:16px;height:16px;background:#000}span.reason_red[data-v-1fd95a5a],span.suspension[data-v-1fd95a5a]{width:9px;height:12px;border-radius:2px;background:#e20004}span.reason_yellow[data-v-1fd95a5a]{width:9px;height:12px;border-radius:2px;background:#f9f115}span.injury[data-v-1fd95a5a],span.reason_injured[data-v-1fd95a5a]{width:12px;height:12px;border:1px solid #ddd;background:#eff1f4;text-align:center;line-height:12px;border-radius:2px;color:#e20004;font-size:12px;font-weight:700;font-family:arial}td.company[data-v-1fd95a5a]{width:80px}#odd_list a[data-v-1fd95a5a]{text-decoration:none}#odd_list td[data-v-1fd95a5a]{max-width:100px;overflow:hidden;text-overflow:ellipsis}input[data-v-1fd95a5a]{border:0;margin:0;padding:0;width:0;height:0}nav.tab[data-v-1fd95a5a]{text-align:center;display:block;width:100%;background:#eff1f4;height:auto;padding:16px 0;line-height:0}nav.tab ul[data-v-1fd95a5a]{display:inline-block;border:1px solid #16ac3a;font-size:14px;border-radius:2px;width:64%;font-size:0;list-style:none;padding:0;height:28px}nav.tab li[data-v-1fd95a5a]{list-style:none;display:inline-block;width:50%;font-size:14px;line-height:28px;height:28px;color:#16ac3a}nav.tab li a[data-v-1fd95a5a]{display:block;color:inherit;font-size:inherit;text-align:inherit;width:100%;padding:0;margin:0}nav.tab li.current[data-v-1fd95a5a]{background:#16ac3a;color:#fff}.preview .vue-dialog[data-v-1fd95a5a]{font-size:17px;top:20vw!important}.preview .vue-dialog .dialog-content[data-v-1fd95a5a]{padding:25px;font-size:17px;text-align:center;line-height:1.5}.preview .vue-dialog-button[data-v-1fd95a5a]{font-size:17px!important;color:#16ac3a;height:45px;line-height:45px;border-radius:0}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/pastGames.vue"],"names":[],"mappings":"AACA,mBACI,UAAY,CACf,AACD,4CAEI,WAAa,CAChB,AACD,sBAEI,sDAA4D,AAC5D,kBAAoB,CACvB,AACD,oGAKI,SAAU,AACV,SAAW,CACd,AACD,sBACI,SAAU,AACV,UAAW,AACX,mCAAoC,AACpC,iBAAmB,CACtB,AACD,qBACI,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,uBACI,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,cAAe,AACf,oBAAsB,CACzB,AACD,oBACI,4BAA8B,CAEjC,AACD,sBACI,UAAY,CACf,AACD,oCACI,WAAa,CAChB,AACD,+BACI,UAAW,AACX,qBAAsB,AACtB,sBAAuB,AACvB,YAAa,AACb,6BAA8B,AAC9B,4BAA6B,AAC7B,kBAAmB,AACnB,iBAAkB,AAClB,eAAgB,AAChB,WAAY,AACZ,eAAkB,CACrB,AACD,6CACI,2BAA8B,CACjC,AACD,0GACI,4BAA+B,CAClC,AACD,6BACI,eAAgB,AAChB,mBAAoB,AACpB,gBAAiB,AACjB,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,4BAA8B,CACjC,AACD,uBACI,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,YAAa,AACb,mDAAoD,AACpD,sBAAuB,AACvB,0BAA2B,AAC3B,UAAY,CACf,AACD,+BACI,sBAAuB,AACvB,mBAAoB,AACpB,gBAAiB,AACjB,WAAY,AACZ,YAAa,AACb,gBAAkB,CACrB,AACD,2BACI,mBAAoB,AACpB,qBAA4B,CAC/B,AACD,iCACI,UAAY,CACf,AACD,8BACI,UAAW,AACX,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,gBAAiB,AACjB,qBAAsB,AACtB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,uBAAyB,CAC5B,AACD,kCACI,UAAW,AACX,iBAAmB,CACtB,AACD,mCACI,gBAAkB,CACrB,AACD,yBACI,YAAa,AACb,iBAAkB,AAClB,oBAA0B,AAC1B,4BAA8B,CAEjC,AACD,4BACI,WAAY,AACZ,UAAW,AACX,SAAU,AACV,SAAU,AACV,cAAgB,CACnB,AACD,+BACI,mBAAoB,AACpB,iBAAkB,AAClB,iBAAmB,CACtB,AACD,8BACI,mBAAoB,AACpB,gBAAiB,AACjB,gBAAkB,CACrB,AACD,+BACI,kBAAoB,CACvB,AACD,qBACI,WAAY,AACZ,iBAAkB,AAClB,qBAAuB,CAC1B,AACD,iCACI,qBAAuB,AACvB,sBAAwB,AACxB,oBAAsB,CACzB,AACD,uBACI,yBAA0B,AAC1B,WAAY,AACZ,eAAgB,AAChB,qBAAuB,CAC1B,AACD,0BACI,YAAa,AACb,gBAAiB,AAGjB,WAAY,AACZ,eAAgB,AAGhB,4BAA8B,AAC9B,mBAAsB,CACzB,AACD,oDATI,sBAAuB,AACvB,kBAAmB,AAGnB,4BAA8B,CAajC,AARD,0BACI,WAAY,AACZ,YAAa,AACb,aAAe,CAKlB,AACD,4BACI,iBAAkB,AAClB,eAAgB,AAChB,YAAa,AACb,SAAU,AACV,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AACnB,4BAA8B,AAC9B,mBAAsB,CACzB,AACD,0BACI,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,UAAY,CACf,AACD,6EACI,iBAAmB,CACtB,AACD,sCACI,eAAgB,AAChB,WAAY,AACZ,kBAAoB,CACvB,AACD,6CACI,eAAgB,AAChB,cAAe,AACf,kBAAoB,CACvB,AACD,wDACI,cAAgB,CACnB,AACD,wCACI,qBAAsB,AACtB,YAAa,AACb,YAAa,AACb,WAAY,AACZ,kCAAmC,AACnC,eAAgB,AAChB,qBAAsB,AACtB,gBAAkB,AAClB,kBAAmB,AACnB,gBAAkB,CACrB,AACD,iFACI,cAAe,AACf,gBAAiB,AACjB,eAAgB,AAChB,kBAAoB,CACvB,AACD,iDACI,UAAY,CACf,AACD,mDACI,cAAe,AACf,cAAgB,CACnB,AACD,+BACI,UAAY,CACf,AACD,8BACI,UAAY,CACf,AAID,8DACI,UAAY,CACf,AACD,+BACI,UAAY,CACf,AACD,+BACI,eAAiB,CACpB,AACD,+BACI,UAAY,CACf,AACD,mCACI,mBAAoB,AACpB,WAAY,AACZ,+BAAiC,CAEpC,AACD,2BACI,qBAAsB,AACtB,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,UAAY,CACf,AAID,oEACI,aAAe,CAClB,AACD,mCACI,kBAAoB,CACvB,AAID,oEACI,aAAe,CAClB,AACD,mCACI,kBAAoB,CACvB,AAID,kEACI,aAAe,CAClB,AACD,kCACI,kBAAoB,CACvB,AACD,wDAEI,sBAAuB,AAEvB,4BAA6B,AAC7B,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,wBAA0B,CAC7B,AACD,4BACI,WAAY,AACZ,eAAgB,AAChB,mBAAoB,AACpB,2BAA4B,AAC5B,kBAAoB,CACvB,AACD,4BACI,kBAAmB,AACnB,SAAW,CACd,AACD,8BACI,oBAAsB,CACzB,AACD,mCACI,qBAAsB,AACtB,WAAY,AACZ,oBAAqB,AACrB,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,mBAAoB,AACpB,sBAAuB,AACvB,mBAAoB,AAGpB,iBAAmB,CACtB,AACD,6BACI,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,eAAiB,CACpB,AAOD,kEACI,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,kBAAoB,CACvB,AACD,oCACI,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,kBAAoB,CACvB,AAeD,kEAbI,WAAY,AACZ,YAAa,AACb,sBAAuB,AAEvB,mBAAoB,AACpB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CAetB,AACD,4BACI,UAAY,CACf,AACD,6BACI,oBAAsB,CACzB,AACD,8BACI,gBAAiB,AACjB,gBAAiB,AACjB,sBAAwB,CAC3B,AAGD,uBACI,SAAU,AACV,SAAU,AACV,UAAW,AACX,QAAS,AACT,QAAU,CACb,AACD,yBACI,kBAAmB,AACnB,cAAe,AACf,WAAY,AACZ,mBAAoB,AACpB,YAAa,AACb,eAAgB,AAChB,aAAe,CAClB,AACD,4BACI,qBAAsB,AACtB,yBAA0B,AAE1B,eAAgB,AAChB,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,gBAAiB,AACjB,UAAW,AACX,WAAa,CAChB,AACD,4BACI,gBAAiB,AACjB,qBAAsB,AACtB,UAAW,AACX,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,aAAe,CAClB,AACD,8BACI,cAAe,AACf,cAAe,AACf,kBAAmB,AACnB,mBAAoB,AACpB,WAAY,AACZ,UAAW,AACX,QAAU,CACb,AACD,oCACI,mBAAoB,AACpB,UAAY,CACf,AAGD,sCACI,eAAgB,AAChB,kBAAqB,CACxB,AACD,sDACI,aAAc,AACd,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CACpB,AACD,6CACI,yBAA2B,AAC3B,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,eAAiB,CACpB","file":"pastGames.vue","sourcesContent":["\na[data-v-1fd95a5a] {\n    color: #000;\n}\nhtml[data-v-1fd95a5a],\nbody[data-v-1fd95a5a] {\n    height: 100%;\n}\nbody[data-v-1fd95a5a] {\n    /*设置英文字体*/\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    background: #eff1f4;\n}\np[data-v-1fd95a5a],\ndiv[data-v-1fd95a5a],\nul[data-v-1fd95a5a],\nol[data-v-1fd95a5a],\nli[data-v-1fd95a5a] {\n    margin: 0;\n    padding: 0;\n}\nbody[data-v-1fd95a5a] {\n    margin: 0;\n    padding: 0;\n    -webkit-font-smoothing: antialiased;\n    position: relative;\n}\nnav[data-v-1fd95a5a] {\n    font-size: 14px;\n    height: 30px;\n    line-height: 30px;\n    font-weight: 700;\n    color: #333;\n    background: #e2e4e6;\n    text-align: left;\n    padding-left: 16px;\n}\nnav a[data-v-1fd95a5a] {\n    font-size: 12px;\n    float: right;\n    margin-right: 5px;\n    color: #16ac3a;\n    text-decoration: none;\n}\n.t[data-v-1fd95a5a] {\n    border-bottom: 1px solid #ddd;\n    /*no*/\n}\n.con[data-v-1fd95a5a] {\n    width: 100%;\n}\n.con .channel-wrap[data-v-1fd95a5a] {\n    font-size: 0;\n}\n.con .channel[data-v-1fd95a5a] {\n    width: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    height: 40px;\n    border-bottom: 1px solid #ddd; /*px*/\n    border-right: 1px solid #ddd; /*px*/\n    text-align: center;\n    line-height: 40px;\n    font-size: 14px;\n    color: #333;\n    font-weight: bold;\n}\n.con .channel[data-v-1fd95a5a]:nth-child(even) {\n    border-right: none !important;\n}\n.con .channel[data-v-1fd95a5a]:nth-last-child(2):nth-child(odd), .con .channel[data-v-1fd95a5a]:last-child {\n    border-bottom: none !important;\n}\n.con .title[data-v-1fd95a5a] {\n    padding: 0 10px;\n    background: #eff1f4;\n    font-weight: 700;\n    color: #333;\n    height: 35px;\n    line-height: 35px;\n    border-bottom: 1px solid #ddd;\n}\n.help[data-v-1fd95a5a] {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    font-size: 0;\n    background: url(../assets/match/help.png) no-repeat;\n    vertical-align: middle;\n    background-size: 100% 100%;\n    float: none;\n}\n.con .title_1[data-v-1fd95a5a] {\n    padding: 0 10px 0 16px;\n    background: #eff1f4;\n    font-weight: 700;\n    color: #333;\n    height: 35px;\n    line-height: 35px;\n}\n.con .box[data-v-1fd95a5a] {\n    background: #eff1f4;\n    padding: 10px 10px 5px 10px;\n}\n.con .box table[data-v-1fd95a5a] {\n    width: 100%;\n}\n.con .box td[data-v-1fd95a5a] {\n    width: 30%;\n    height: auto;\n    line-height: 20px;\n    font-weight: 700;\n    color: #333;\n    text-align: left;\n    display: inline-block;\n    font-size: 14px;\n    border: 0;\n    background: none;\n    vertical-align: text-top;\n}\n.con .box td.mid[data-v-1fd95a5a] {\n    width: 40%;\n    text-align: center;\n}\n.con .box td.away[data-v-1fd95a5a] {\n    text-align: right;\n}\ndiv.bar[data-v-1fd95a5a] {\n    height: 25px;\n    line-height: 25px;\n    padding: 0 10px 16px 10px;\n    border-bottom: 1px solid #ddd;\n    /*no*/\n}\ndiv.bar td[data-v-1fd95a5a] {\n    color: #fff;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    font-size: 12px;\n}\ndiv.bar .lose[data-v-1fd95a5a] {\n    background: #f12b2b;\n    text-align: right;\n    padding-right: 5px;\n}\ndiv.bar .win[data-v-1fd95a5a] {\n    background: #49c867;\n    text-align: left;\n    padding-left: 5px;\n}\ndiv.bar .draw[data-v-1fd95a5a] {\n    background: #1d9ff9;\n}\nimg[data-v-1fd95a5a] {\n    width: 20px;\n    margin: 0 5px 0 0;\n    vertical-align: middle;\n}\n.con .title img[data-v-1fd95a5a] {\n    width: 20px !important;\n    height: auto !important;\n    display: inline-block;\n}\ntable[data-v-1fd95a5a] {\n    border-collapse: collapse;\n    width: 100%;\n    max-width: 100%;\n    word-break: break-word;\n}\ntable th[data-v-1fd95a5a] {\n    height: 25px;\n    line-height: 1.2;\n    vertical-align: middle;\n    text-align: center;\n    color: #999;\n    font-size: 11px;\n    border-bottom: 1px solid #ddd;\n    /*no*/\n    -webkit-transform: scale(0.9);\n    transform: scale(0.9);\n}\ntable td[data-v-1fd95a5a] {\n    color: #555;\n    height: 30px;\n    padding: 3px 0;\n    border-bottom: 1px solid #ddd;\n    /*no*/\n    vertical-align: middle;\n    text-align: center;\n}\ntable td p[data-v-1fd95a5a] {\n    line-height: 10px;\n    font-size: 10px;\n    height: 10px;\n    margin: 0;\n    padding: 0;\n    font-family: arial;\n    text-align: center;\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n}\ndiv.none[data-v-1fd95a5a] {\n    height: 55px;\n    line-height: 55px;\n    text-align: center;\n    font-size: 14px;\n    color: #999;\n}\n.match-prediction[data-v-1fd95a5a], .match-prediction-result[data-v-1fd95a5a] {\n    text-align: center;\n}\n.match-prediction h2[data-v-1fd95a5a] {\n    font-size: 18px;\n    color: #333;\n    margin: 20px 0 15px;\n}\n.match-prediction-result h2[data-v-1fd95a5a] {\n    font-size: 18px;\n    color: #16ac3a;\n    margin: 20px 0 15px;\n}\n.match-prediction-result h2.long-title[data-v-1fd95a5a] {\n    font-size: 14px;\n}\n.match-prediction .btn[data-v-1fd95a5a] {\n    display: inline-block;\n    width: 146px;\n    height: 36px;\n    color: #fff;\n    background-color: var(--mainColor);\n    font-size: 16px;\n    text-decoration: none;\n    font-weight: bold;\n    border-radius: 2px;\n    line-height: 36px;\n}\n.match-prediction p[data-v-1fd95a5a], .match-prediction-result p[data-v-1fd95a5a] {\n    color: #8c9399;\n    line-height: 1.4;\n    padding: 0 10px;\n    margin-bottom: 15px;\n}\n.match-prediction p.free-chance[data-v-1fd95a5a] {\n    color: #333;\n}\n.match-prediction p.free-chance b[data-v-1fd95a5a] {\n    color: #16ac3a;\n    font-size: 15px;\n}\n.list_1 .date[data-v-1fd95a5a] {\n    width: 50px;\n}\n.list_1 .cup[data-v-1fd95a5a] {\n    width: 70px;\n}\n.list_1 .home[data-v-1fd95a5a] {\n    width: 88px;\n}\n.list_1 .away[data-v-1fd95a5a] {\n    width: 88px;\n}\n.list_1 .stat[data-v-1fd95a5a] {\n    width: 24px;\n}\n.list_2 .name[data-v-1fd95a5a] {\n    text-align: left;\n}\n.list_2 .rank[data-v-1fd95a5a] {\n    width: 24px;\n}\n.list_2 tr.top td[data-v-1fd95a5a] {\n    background: #16ac3a;\n    color: #fff;\n    border-bottom: 1px solid #128a2e;\n    /*no*/\n}\nspan.stat[data-v-1fd95a5a] {\n    display: inline-block;\n    padding: 0 5px;\n    height: 16px;\n    line-height: 17px;\n    color: #fff;\n}\ntr.lose td.team[data-v-1fd95a5a] {\n    color: #f12b2b;\n}\ntr.lose td.team a[data-v-1fd95a5a] {\n    color: #f12b2b;\n}\ntr.lose span.stat[data-v-1fd95a5a] {\n    background: #f12b2b;\n}\ntr.draw td.team[data-v-1fd95a5a] {\n    color: #1d9ff9;\n}\ntr.draw td.team a[data-v-1fd95a5a] {\n    color: #1d9ff9;\n}\ntr.draw span.stat[data-v-1fd95a5a] {\n    background: #1d9ff9;\n}\ntr.win td.team[data-v-1fd95a5a] {\n    color: #49c867;\n}\ntr.win td.team a[data-v-1fd95a5a] {\n    color: #49c867;\n}\ntr.win span.stat[data-v-1fd95a5a] {\n    background: #49c867;\n}\n.list_3 td[data-v-1fd95a5a],\n.list_3 th[data-v-1fd95a5a] {\n    border: 1px solid #ddd;\n    /*no*/\n    padding: 10px 18px 10px 10px;\n    height: 20px;\n    line-height: 20px;\n    text-align: left;\n    border-collapse: collapse;\n}\n.list_3 th[data-v-1fd95a5a] {\n    color: #333;\n    font-size: 12px;\n    background: #eff1f4;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n}\n.list_3 td[data-v-1fd95a5a] {\n    position: relative;\n    width: 50%;\n}\n.list_3 td a[data-v-1fd95a5a] {\n    text-decoration: none;\n}\n.content span.num[data-v-1fd95a5a] {\n    display: inline-block;\n    width: 18px;\n    margin: -2px 5px 0 0;\n    height: 18px;\n    text-align: center;\n    line-height: 18px;\n    background: #eff1f4;\n    vertical-align: middle;\n    border-radius: 18px;\n    /*border: 1px solid #dfdfdf;*/\n    /*no*/\n    font-family: arial;\n}\nspan.reason[data-v-1fd95a5a] {\n    position: absolute;\n    top: 13px;\n    right: 15px;\n    width: 16px;\n    height: 16px;\n    background: #000;\n}\nspan.reason_red[data-v-1fd95a5a] {\n    width: 9px;\n    height: 12px;\n    border-radius: 2px;\n    background: #e20004;\n}\nspan.suspension[data-v-1fd95a5a] {\n    width: 9px;\n    height: 12px;\n    border-radius: 2px;\n    background: #e20004;\n}\nspan.reason_yellow[data-v-1fd95a5a] {\n    width: 9px;\n    height: 12px;\n    border-radius: 2px;\n    background: #f9f115;\n}\nspan.reason_injured[data-v-1fd95a5a] {\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ddd;\n    /*no*/\n    background: #eff1f4;\n    text-align: center;\n    line-height: 12px;\n    border-radius: 2px;\n    color: #e20004;\n    font-size: 12px;\n    font-weight: 700;\n    font-family: arial;\n}\nspan.injury[data-v-1fd95a5a] {\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ddd;\n    /*no*/\n    background: #eff1f4;\n    text-align: center;\n    line-height: 12px;\n    border-radius: 2px;\n    color: #e20004;\n    font-size: 12px;\n    font-weight: 700;\n    font-family: arial;\n}\ntd.company[data-v-1fd95a5a] {\n    width: 80px;\n}\n#odd_list a[data-v-1fd95a5a] {\n    text-decoration: none;\n}\n#odd_list td[data-v-1fd95a5a] {\n    max-width: 100px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/*未知模块*/\ninput[data-v-1fd95a5a] {\n    border: 0;\n    margin: 0;\n    padding: 0;\n    width: 0;\n    height: 0;\n}\nnav.tab[data-v-1fd95a5a] {\n    text-align: center;\n    display: block;\n    width: 100%;\n    background: #eff1f4;\n    height: auto;\n    padding: 16px 0;\n    line-height: 0;\n}\nnav.tab ul[data-v-1fd95a5a] {\n    display: inline-block;\n    border: 1px solid #16ac3a;\n    /*no*/\n    font-size: 14px;\n    border-radius: 2px;\n    width: 64%;\n    font-size: 0;\n    list-style: none;\n    padding: 0;\n    height: 28px;\n}\nnav.tab li[data-v-1fd95a5a] {\n    list-style: none;\n    display: inline-block;\n    width: 50%;\n    font-size: 14px;\n    line-height: 28px;\n    height: 28px;\n    color: #16ac3a;\n}\nnav.tab li a[data-v-1fd95a5a] {\n    display: block;\n    color: inherit;\n    font-size: inherit;\n    text-align: inherit;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n}\nnav.tab li.current[data-v-1fd95a5a] {\n    background: #16ac3a;\n    color: #fff;\n}\n\n/*dialog*/\n.preview .vue-dialog[data-v-1fd95a5a] {\n    font-size: 17px;\n    top: 20vw !important;\n}\n.preview .vue-dialog .dialog-content[data-v-1fd95a5a] {\n    padding: 25px;\n    font-size: 17px;\n    text-align: center;\n    line-height: 1.5;\n}\n.preview .vue-dialog-button[data-v-1fd95a5a] {\n    font-size: 17px !important;\n    color: #16ac3a;\n    height: 45px;\n    line-height: 45px;\n    border-radius: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/help.07012f6.png";

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_match_defaultTeam_png__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_match_defaultTeam_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_match_defaultTeam_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        gameData: Object
    },
    data: function data() {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
            has_odds: null,
            cup_table: null,
            match_live: null,
            battle_history: null,
            sideline: null,
            league_table: null,
            recent_record: null,
            tips: null,
            aver: null,
            priceText: '',
            paybackTimer: null,

            isLogin: true,
            locale: 'en',
            isExternalAccess: null
        }, this.gameData);
        return data;
    },
    mounted: function mounted() {
        var query = __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(location.search);
        this.locale = query['language'] || query['locale'] || 'en';
        this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1;
        if (this.isExternalAccess) {
            __webpack_require__.e/* import() */(20/* duplicate */).then(__webpack_require__.bind(null, 501)).then(function (module) {
                console.log('module', module);
            });
        } else {
            __webpack_require__.e/* import() */(19/* duplicate */).then(__webpack_require__.bind(null, 502)).then(function (module) {});
        }
    },

    methods: {
        loadDefaultImg: function loadDefaultImg(event) {
            var dom = event.target;
            dom.src = __WEBPACK_IMPORTED_MODULE_1__assets_match_defaultTeam_png___default.a;
        },
        scameJump: function scameJump() {},
        isPayAble: function isPayAble() {
            if (this.tips.title && this.tips.content) {
                return true;
            }

            if (this.gameData.status && this.gameData.status !== 'Playing' && this.gameData.status !== 'Played') {
                return true;
            }

            var date = new Date(this.gameData.start_play.replace(/-/g, '/')).getTime();
            var offset = new Date().getTimezoneOffset();
            date = date - offset * 60 * 1000;
            var nowDate = new Date().getTime();

            return nowDate - date < 60 * 60 * 1000;
        },
        pay: function pay() {},
        payback: function payback() {
            var me = this;

            if (!this.paybackTimer) {
                this.paybackTimer = setTimeout(function () {
                    me.hideLoading();
                }, 15000);
            }

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/v2/match/predict_detail', {
                params: {
                    match_id: this.gameData.match_id,
                    _t: new Date().getTime()
                }
            }).then(function (response) {
                var res = response.data;
                if (!res.data || !res.data.title) {
                    setTimeout(me.payback.bind(me), 200);
                    return;
                }

                me.paybackTimer && clearTimeout(me.paybackTimer);
                me.paybackTimer = null;
                me.hideLoading();

                me.tips = res.data;
            });
        },
        hideLoading: function hideLoading() {}
    }
});

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.match_live && _vm.match_live.length) ? [_c('nav', [_vm._v(_vm._s(_vm.$t('broadcast')))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "channel-wrap"
  }, _vm._l((_vm.match_live), function(item) {
    return _c('span', {
      key: item,
      staticClass: "channel"
    }, [_vm._v(_vm._s(item))])
  }))])] : _vm._e(), _vm._v(" "), _c('nav', [_vm._v(_vm._s(_vm.$t('past_games')))]), _vm._v(" "), (_vm.battle_history) ? _c('article', {
    staticClass: "con"
  }, [(_vm.battle_history['list'] && _vm.battle_history['list'].length) ? [_c('div', {
    staticClass: "box"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "home"
  }, [_vm._v(_vm._s(_vm.team_A))]), _vm._v(" "), _c('td', {
    staticClass: "mid"
  }, [_vm._v(_vm._s(_vm.$t('pg_lng', {
    count: _vm.battle_history.list.length
  })))]), _vm._v(" "), _c('td', {
    staticClass: "away"
  }, [_vm._v(_vm._s(_vm.team_B))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "win",
    style: ({
      width: _vm.battle_history['percent']['win'] + '%'
    })
  }, [_vm._v(_vm._s(_vm.$tc('pg_w', 10, {
    count: _vm.battle_history['team_A']['win']
  })) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "draw",
    style: ({
      width: _vm.battle_history['percent']['draw'] + '%'
    })
  }, [_vm._v(_vm._s(_vm.$tc('pg_d',
    10, {
      count: _vm.battle_history['team_A']['draw']
    })) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "lose",
    style: ({
      width: _vm.battle_history['percent']['lose'] + '%'
    })
  }, [_vm._v(_vm._s(_vm.$tc('pg_w',
    10, {
      count: _vm.battle_history['team_B']['win']
    })) + "\n                        ")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "list_1"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('pg_date')))]), _vm._v(" "), _c('th', {
    staticClass: "cup"
  }, [_vm._v(_vm._s(_vm.$t('pg_competition')))]), _vm._v(" "), _c('th', {
    staticClass: "home"
  }, [_vm._v(_vm._s(_vm.$t('pg_home')))]), _vm._v(" "), _c('th', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.$t('pg_result')))]), _vm._v(" "), _c('th', {
    staticClass: "away"
  }, [_vm._v(_vm._s(_vm.$t('pg_away')))])]), _vm._v(" "), _vm._l((_vm.battle_history.list), function(match, num) {
    return _c('tr', {
      key: match.match_href,
      class: match['color']
    }, [_c('td', {
      staticClass: "time"
    }, [_c('p', [_vm._v(_vm._s(match['date']))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(match['year']))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(match['competition']))]), _vm._v(" "), _c('td', {
      class: {
        team: match['main_team'] == 'team_A'
      }
    }, [_vm._v(_vm._s(match['team_A_name']))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": match['match_href']
      }
    }, [_c('span', {
      staticClass: "stat"
    }, [_vm._v(_vm._s(match['score']))])])]), _vm._v(" "), _c('td', {
      class: {
        team: match['main_team'] == 'team_B'
      }
    }, [_vm._v(_vm._s(match['team_B_name']))])])
  })], 2)])] : _c('div', {
    staticClass: "none"
  }, [_vm._v(_vm._s(_vm.$t('pg_no')))])], 2) : _vm._e(), _vm._v(" "), (_vm.sideline && _vm.sideline.max) ? [_c('nav', {
    staticClass: "t"
  }, [_vm._v(" " + _vm._s(_vm.$t('absentee')) + " " + _vm._s(_vm.sideline.max))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('table', {
    staticClass: "list_3"
  }, [_c('tbody', [_c('tr', [_c('th', [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.team_A_logo),
      "alt": ""
    },
    on: {
      "error": _vm.loadDefaultImg
    }
  }), _vm._v(" " + _vm._s(_vm.team_A) + "\n                    ")]), _vm._v(" "), _c('th', [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.team_B_logo),
      "alt": ""
    },
    on: {
      "error": _vm.loadDefaultImg
    }
  }), _vm._v(" " + _vm._s(_vm.team_B) + "\n                    ")])]), _vm._v(" "), _vm._l((_vm.sideline.max), function(i) {
    return _c('tr', {
      key: i
    }, [_c('td', [(_vm.sideline['team_A'][i - 1]) ? [_c('span', {
      staticClass: "num"
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_A'][i - 1]['shirtnumber']))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.sideline['team_A'][i - 1]['href']
      }
    }, [_vm._v(_vm._s(_vm.sideline['team_A'][i - 1]['name']) + " ")]), _vm._v(" "), _c('span', {
      class: 'reason ' + _vm.sideline['team_A'][i - 1]['reason']
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_A'][i - 1]['reason_char']) + " ")])] : _vm._e()], 2), _vm._v(" "), _c('td', [(_vm.sideline['team_B'][i - 1]) ? [_c('span', {
      staticClass: "num"
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_B'][i - 1]['shirtnumber']))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.sideline['team_B'][i - 1]['href']
      }
    }, [_vm._v(_vm._s(_vm.sideline['team_B'][i - 1]['name']) + " ")]), _vm._v(" "), _c('span', {
      class: 'reason ' + _vm.sideline['team_B'][i - 1]['reason']
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_B'][i - 1]['reason_char']) + " ")])] : _vm._e()], 2)])
  })], 2)])])] : _vm._e(), _vm._v(" "), (_vm.league_table) ? [_c('nav', {
    staticClass: "t"
  }, [_vm._v(_vm._s(_vm.$t('league_table')))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_vm._l((_vm.league_table), function(tables, team) {
    return (team !== 'name') ? [_c('div', {
      key: team,
      staticClass: "title"
    }, [_c('img', {
      attrs: {
        "src": team === 'team_A' ? _vm.getImgSrc(_vm.team_A_logo) : _vm.getImgSrc(_vm.team_B_logo),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v(" " + _vm._s(team === 'team_A' ? _vm.team_A : _vm.team_B) + "\n                ")]), _vm._v(" "), _c('table', {
      key: tables.name
    }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('lt_format')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_p')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_w')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_d')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_l')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_f')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_a')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_pts')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_rank')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_wp')))])]), _vm._v(" "), _vm._l((tables), function(table, tabletype) {
      return _c('tr', {
        key: table.name
      }, [_c('td', [_vm._v(_vm._s(_vm.$t('lt_' + table['name'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_total']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_won']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_lost']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['goals_pro']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['goals_against']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['points']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['rank']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['win_rate']))])])
    })], 2)])] : _vm._e()
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.cup_table) ? [_c('nav', [_vm._v(_vm._s(_vm.cup_table['name']))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('table', {
    staticClass: "list_2"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "rank"
  }), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('ct_team')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_p')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_w')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_d')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_l')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_fa')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_pts')))])]), _vm._v(" "), _vm._l((_vm.cup_table.list), function(team, rank) {
    return _c('tr', {
      key: rank,
      class: {
        top: team.color == 'green'
      }
    }, [_c('td', [_vm._v(_vm._s(team['rank']))]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgSrc(team['logo']),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v(" " + _vm._s(team['name']) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_total']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_won']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_lost']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['goals_pro']) + "/" + _vm._s(team['goals_against']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['points']))])])
  })], 2)])])] : _vm._e(), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "odd"
    }
  }, [_vm._v(_vm._s(_vm.$t('odds')) + "\n        ")]), _vm._v(" "), (_vm.has_odds) ? _c('article', {
    staticClass: "con",
    attrs: {
      "id": "odd_list"
    }
  }, [_c('div', {
    staticClass: "title_1"
  }, [_vm._v(_vm._s(_vm.$t('odds_handicap')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tab://4"
    }
  }, [_c('table', {
    staticClass: "list_4"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_home_lose')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_hdp')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_away_lose')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "title_1"
  }, [_vm._v(_vm._s(_vm.$t('odds_1x2')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tab://4"
    }
  }, [_c('table', {
    staticClass: "list_4"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_home_win')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_draw')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_away_win')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])]), _vm._v(" "), (_vm.aver) ? _c('tr', [_c('td', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_average')))]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.$t('odds_spot')))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['homeWin']) ? _vm.aver['now']['homeWin'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['draw']) ? _vm.aver['now']['draw'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['awayWin']) ? _vm.aver['now']['awayWin'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['ts']) ? _vm.aver['now']['ts'] : '---'))])]) : _vm._e()])])])]) : _c('div', {
    staticClass: "none"
  }, [_vm._v(_vm._s(_vm.$t('odds_no')))]), _vm._v(" "), _c('nav', [_vm._v(_vm._s(_vm.$t('recent_games')))]), _vm._v(" "), _vm._l((_vm.recent_record), function(matches, team) {
    return (team !== 'name') ? _c('article', {
      key: team,
      staticClass: "con"
    }, [_c('div', {
      staticClass: "title t"
    }, [_c('img', {
      attrs: {
        "src": team === 'team_A' ? _vm.getImgSrc(_vm.team_A_logo) : _vm.getImgSrc(_vm.team_B_logo),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v(" " + _vm._s(team ===
      'team_A' ? _vm.team_A : _vm.team_B) + "\n        ")]), _vm._v(" "), (matches && matches.length) ? _c('table', {
      staticClass: "list_1"
    }, [_c('tbody', [_c('tr', [_c('th', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.$t('rg_date')))]), _vm._v(" "), _c('th', {
      staticClass: "cup"
    }, [_vm._v(_vm._s(_vm.$t('rg_competition')))]), _vm._v(" "), _c('th', {
      staticClass: "home"
    }, [_vm._v(_vm._s(_vm.$t('rg_home')))]), _vm._v(" "), _c('th', {
      staticClass: "stat"
    }, [_vm._v(_vm._s(_vm.$t('rg_result')))]), _vm._v(" "), _c('th', {
      staticClass: "away"
    }, [_vm._v(_vm._s(_vm.$t('rg_away')))])]), _vm._v(" "), _vm._l((matches), function(match, id) {
      return _c('tr', {
        key: id,
        class: match['color']
      }, [_c('td', {
        staticClass: "time"
      }, [_c('p', [_vm._v(_vm._s(match['date']))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(match['year']))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(match['competition']))]), _vm._v(" "), _c('td', {
        class: {
          team: match['main_team'] === 'team_A'
        }
      }, [_vm._v(_vm._s(match['team_A_name']))]), _vm._v(" "), _c('td', [_c('a', {
        attrs: {
          "href": match['match_href']
        }
      }, [_c('span', {
        staticClass: "stat"
      }, [_vm._v(_vm._s(match['score']))])])]), _vm._v(" "), _c('td', {
        class: {
          team: match['main_team'] === 'team_B'
        }
      }, [_vm._v(_vm._s(match['team_B_name']))])])
    })], 2)]) : _c('div', {
      staticClass: "none"
    }, [_vm._v(_vm._s(_vm.$t('rg_no')))])]) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(669)
}
var Component = __webpack_require__(182)(
  /* script */
  null,
  /* template */
  __webpack_require__(671),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10693492",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(670);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("363bdc75", content, true);

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".background-masker[data-v-10693492]{background:#eff1f4;position:absolute}.past-game-skeleton[data-v-10693492]{background:#dfdfdf;margin:0 auto;width:100%}.past-game-skeleton nav[data-v-10693492]{background:rgba(0,0,0,.1);position:relative}.past-game-skeleton nav .background-masker[data-v-10693492]{background:#e2e4e6}.past-game-skeleton .con[data-v-10693492]{height:102px;position:relative}.past-game-skeleton .left[data-v-10693492]{width:15px;top:0;bottom:0;left:0}.past-game-skeleton .right[data-v-10693492]{width:15px;top:0;bottom:0;right:0}.past-game-skeleton .nav-top[data-v-10693492]{height:8px;left:15px;right:15px;top:0}.past-game-skeleton .nav-right[data-v-10693492]{top:0;bottom:0;left:95px;right:0}.past-game-skeleton .nav-bottom[data-v-10693492]{height:8px;left:15px;right:15px;bottom:0}.past-game-skeleton .gap1[data-v-10693492]{left:15px;right:15px;height:15px;top:0}.past-game-skeleton .gap2[data-v-10693492]{left:15px;right:15px;height:15px;top:29px}.past-game-skeleton .gap3[data-v-10693492]{left:15px;right:15px;height:15px;top:58px}.past-game-skeleton .gap4[data-v-10693492]{left:15px;right:15px;height:15px;top:87px}.past-game-skeleton .gap5[data-v-10693492]{left:15px;right:15px;height:15px;top:116px}.past-game-skeleton .gap6[data-v-10693492]{left:15px;right:15px;height:15px;top:145px}.placeholder[data-v-10693492]{display:inline-block;height:14px;width:80px;background:#c9c9c9;vertical-align:middle}.con .placeholder[data-v-10693492]{display:block;margin:10px auto;width:96%;background:#dfdfdf}@-webkit-keyframes placeHolderShimmer{0%{background-position:-234px 0}to{background-position:234px 0}}@keyframes placeHolderShimmer-data-v-10693492{0%{background-position:-234px 0}to{background-position:234px 0}}.animated-background[data-v-10693492]{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:placeHolderShimmer-data-v-10693492;animation-name:placeHolderShimmer-data-v-10693492;-webkit-animation-timing-function:linear;animation-timing-function:linear;background:#dfdfdf;background:linear-gradient(90deg,#dfdfdf 8%,#c9c9c9 18%,#dfdfdf 33%);background-size:800px 104px;position:relative}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/skeleton.vue"],"names":[],"mappings":"AACA,oCACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,mBAAoB,AACpB,cAAe,AACf,UAAY,CACb,AACD,yCACE,0BAA+B,AAC/B,iBAAmB,CACpB,AACD,4DACE,kBAAoB,CACrB,AACD,0CACE,aAAc,AACd,iBAAmB,CACpB,AACD,2CACE,WAAY,AACZ,MAAO,AACP,SAAU,AACV,MAAQ,CACT,AACD,4CACE,WAAY,AACZ,MAAO,AACP,SAAU,AACV,OAAS,CACV,AACD,8CACE,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,KAAO,CACR,AACD,gDACE,MAAO,AACP,SAAU,AACV,UAAW,AACX,OAAS,CACV,AACD,iDACE,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,QAAU,CACX,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,KAAS,CACV,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,QAAU,CACX,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,QAAU,CACX,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,QAAU,CACX,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,SAAW,CACZ,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,SAAW,CACZ,AACD,8BACE,qBAAsB,AACtB,YAAa,AACb,WAAY,AACZ,mBAAoB,AACpB,qBAAuB,CACxB,AACD,mCACE,cAAe,AACf,iBAAkB,AAClB,UAAW,AACX,kBAAoB,CACrB,AACD,sCACA,GACI,4BAA8B,CACjC,AACD,GACI,2BAA6B,CAChC,CACA,AACD,8CACA,GACI,4BAA8B,CACjC,AACD,GACI,2BAA6B,CAChC,CACA,AACD,sCACE,8BAA+B,AACvB,sBAAuB,AAC/B,qCAAsC,AAC9B,6BAA8B,AACtC,2CAA4C,AACpC,mCAAoC,AAC5C,0DAA2D,AACnD,kDAAmD,AAC3D,yCAA0C,AAClC,iCAAkC,AAC1C,mBAAoB,AACpB,qEAA4E,AAC5E,4BAA6B,AAC7B,iBAAmB,CACpB","file":"skeleton.vue","sourcesContent":["\n.background-masker[data-v-10693492] {\n  background: #eff1f4;\n  position: absolute;\n}\n.past-game-skeleton[data-v-10693492] {\n  background: #dfdfdf;\n  margin: 0 auto;\n  width: 100%;\n}\n.past-game-skeleton nav[data-v-10693492] {\n  background: rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.past-game-skeleton nav .background-masker[data-v-10693492] {\n  background: #e2e4e6;\n}\n.past-game-skeleton .con[data-v-10693492] {\n  height: 102px;\n  position: relative;\n}\n.past-game-skeleton .left[data-v-10693492] {\n  width: 15px;\n  top: 0;\n  bottom: 0;\n  left: 0;\n}\n.past-game-skeleton .right[data-v-10693492] {\n  width: 15px;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n.past-game-skeleton .nav-top[data-v-10693492] {\n  height: 8px;\n  left: 15px;\n  right: 15px;\n  top: 0;\n}\n.past-game-skeleton .nav-right[data-v-10693492] {\n  top: 0;\n  bottom: 0;\n  left: 95px;\n  right: 0;\n}\n.past-game-skeleton .nav-bottom[data-v-10693492] {\n  height: 8px;\n  left: 15px;\n  right: 15px;\n  bottom: 0;\n}\n.past-game-skeleton .gap1[data-v-10693492] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 0px;\n}\n.past-game-skeleton .gap2[data-v-10693492] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 29px;\n}\n.past-game-skeleton .gap3[data-v-10693492] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 58px;\n}\n.past-game-skeleton .gap4[data-v-10693492] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 87px;\n}\n.past-game-skeleton .gap5[data-v-10693492] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 116px;\n}\n.past-game-skeleton .gap6[data-v-10693492] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 145px;\n}\n.placeholder[data-v-10693492] {\n  display: inline-block;\n  height: 14px;\n  width: 80px;\n  background: #c9c9c9;\n  vertical-align: middle;\n}\n.con .placeholder[data-v-10693492] {\n  display: block;\n  margin: 10px auto;\n  width: 96%;\n  background: #dfdfdf;\n}\n@-webkit-keyframes placeHolderShimmer {\n0% {\n    background-position: -234px 0;\n}\n100% {\n    background-position: 234px 0;\n}\n}\n@keyframes placeHolderShimmer-data-v-10693492 {\n0% {\n    background-position: -234px 0;\n}\n100% {\n    background-position: 234px 0;\n}\n}\n.animated-background[data-v-10693492] {\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-name: placeHolderShimmer-data-v-10693492;\n          animation-name: placeHolderShimmer-data-v-10693492;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  background: #dfdfdf;\n  background: linear-gradient(to right, #dfdfdf 8%, #c9c9c9 18%, #dfdfdf 33%);\n  background-size: 800px 104px;\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 671:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "past-game-skeleton background-masker"
  }, [_c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])])])
}]}

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content preview"
  }, [_c('nav', {
    staticClass: "sum"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('prediction')) + "\n            "), (_vm.voteData.total_num) ? [_vm._v(_vm._s(_vm.$tc('voteNum', 10, {
    count: _vm.voteData.total_num
  })))] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.voteData.name && _vm.isShowOverview) ? _c('p', {
    staticClass: "forecast"
  }, [_vm._v(_vm._s(_vm.voteData.name))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "vote_con"
  }, _vm._l((_vm.voteData.data), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "vote_view",
      attrs: {
        "id": item.name.toLowerCase(),
        "data-vote": "1"
      }
    }, [_c('div', {
      staticClass: "vote_box"
    }, [_c('div', {
      staticClass: "progress_con"
    }, [_c('div', {
      staticClass: "progress",
      style: ({
        'height': _vm.height(item.num) + 'px',
        'line-height': _vm.height(item.num) + 'px'
      })
    }, [_c('b', [_vm._v(_vm._s(item.percent) + "%")])])])]), _vm._v(" "), _c('div', {
      staticClass: "bottom_vote",
      class: {
        'clicked': !_vm.votable(item.id) || _vm.voted(item.id)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.vote(item.id)
        }
      }
    }, [_c('span'), _vm._v(" " + _vm._s(_vm.voted(item.id) ? _vm.$t('voted') : _vm.$t('vote')) + "\n                        ")]), _vm._v(" "), _c('p', [(item.id === 1) ? _c('img', {
      attrs: {
        "alt": "",
        "src": _vm.getImgSrc(_vm.homeImgSrc)
      }
    }) : _vm._e(), _vm._v(" "), (item.id === 3) ? _c('img', {
      attrs: {
        "alt": "",
        "src": _vm.getImgSrc(_vm.awayImgSrc)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.name.toLowerCase())))])])])])
  }))]), _vm._v(" "), (_vm.analysisData) ? _c('past-games', {
    attrs: {
      "game-data": _vm.analysisData
    }
  }) : _c('skeleton'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mask"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('matchNotStart')))])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(679),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60b24177",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("1d65135c", content, true);

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "a[data-v-60b24177]{color:#000}body[data-v-60b24177],html[data-v-60b24177]{height:100%}body[data-v-60b24177]{margin:0;padding:0;width:100%;background:#eff1f4;font-size:12px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;position:relative}.no-data[data-v-60b24177]{font-size:12px;text-align:center;color:#babdc2;line-height:23px;padding-top:42%;background:#fff!important;position:absolute;top:0;bottom:0;width:100%}.top[data-v-60b24177]{padding:1em;height:27px;position:relative;z-index:2}nav[data-v-60b24177]{height:25px;line-height:25px;color:#16ac3a;border:1px solid #16ac3a;border-radius:2px;float:left;width:72%;margin:1em;font-size:0;white-space:nowrap;padding-left:0}nav[data-v-60b24177],nav span[data-v-60b24177]{text-align:center;overflow:hidden;text-overflow:ellipsis}nav span[data-v-60b24177]{display:inline-block;width:33.3%;font-size:12px;border-left:1px solid #16ac3a;box-sizing:border-box}nav span[data-v-60b24177]:first-child{border:none}nav span.sel[data-v-60b24177]{color:#fff;background:#16ac3a}div.rate-menu[data-v-60b24177]{float:right;line-height:27px;position:relative;max-width:25%;white-space:nowrap}div.rate-menu span[data-v-60b24177]{display:block;text-align:right}div.rate-menu span i[data-v-60b24177]{font-style:normal;overflow:hidden;text-overflow:ellipsis;max-width:85%;float:left}div.rate-menu span[data-v-60b24177]:after{content:\"\";display:inline-block;height:12px;width:24px;background:url(" + __webpack_require__(676) + ") no-repeat;background-size:50%;background-position:50%;-webkit-transform:rotate(180deg);transform:rotate(180deg);vertical-align:-2px;transition:-webkit-transform .15s linear;transition:transform .15s linear;transition:transform .15s linear,-webkit-transform .15s linear}div.rate-menu span.unfold[data-v-60b24177]:after{vertical-align:-1px;-webkit-transform:none;transform:none}div.rate-menu ul[data-v-60b24177]{position:absolute;top:27px;list-style:none;border:1px solid #eee;z-index:2;background:#fff;right:0;text-align:center;padding:0;margin:0;min-width:200px}div.rate-menu li[data-v-60b24177]{display:block;line-height:45px;border-bottom:1px solid #eee;overflow:hidden;padding:0 10px;text-overflow:ellipsis}div.rate-menu li.sel[data-v-60b24177]{color:#16ac3a}table[data-v-60b24177]{border-collapse:collapse;width:100%}.list_4[data-v-60b24177]{border-spacing:0}.list_4 th[data-v-60b24177]{text-align:center;-webkit-transform:scale(1);transform:scale(1);color:#333;background:#eefcf1;border:1px solid #ddd;margin:0;padding:0;height:24px;line-height:24px;word-break:break-word}.list_4 td[data-v-60b24177]{background:#fff;height:28px;line-height:28px;text-align:center}.list_4 tr th[data-v-60b24177]:first-child{font-weight:700;width:80px}.list_4 tr th[data-v-60b24177]:nth-child(2){width:60px}.list_4 tr th[data-v-60b24177]:nth-child(3),.list_4 tr th[data-v-60b24177]:nth-child(4),.list_4 tr th[data-v-60b24177]:nth-child(5){width:50px}.list_4 tr th[data-v-60b24177]:nth-child(6){width:80px}.list_4 tbody:nth-child(odd) td[data-v-60b24177]{background:#eefcf1}.list_4 tbody[data-v-60b24177]{border-top:1px solid #ddd}.red[data-v-60b24177]{color:#e52000}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/matchDetailOdds/App.vue"],"names":[],"mappings":"AACA,mBACE,UAAY,CACb,AACD,4CAEE,WAAa,CACd,AACD,sBACE,SAAU,AACV,UAAW,AACX,WAAY,AACZ,mBAAoB,AACpB,eAAgB,AAEhB,sDAA4D,AAC5D,iBAAmB,CACpB,AACD,0BACE,eAAgB,AAChB,kBAAmB,AACnB,cAAe,AACf,iBAAkB,AAClB,gBAAiB,AACjB,0BAA4B,AAC5B,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,UAAY,CACb,AACD,sBACE,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,SAAW,CACZ,AACD,qBACE,YAAa,AACb,iBAAkB,AAElB,cAAe,AACf,yBAA0B,AAE1B,kBAAmB,AACnB,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,YAAa,AAGb,mBAAoB,AACpB,cAAgB,CACjB,AACD,+CAdE,kBAAmB,AASnB,gBAAiB,AACjB,sBAAwB,CAczB,AAVD,0BACE,qBAAsB,AAEtB,YAAa,AACb,eAAgB,AAChB,8BAA+B,AAE/B,qBAAuB,CAGxB,AACD,sCACE,WAAa,CACd,AACD,8BACE,WAAY,AACZ,kBAAoB,CACrB,AACD,+BACE,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,cAAe,AACf,kBAAoB,CACrB,AACD,oCACE,cAAe,AACf,gBAAkB,CACnB,AACD,sCACE,kBAAmB,AACnB,gBAAiB,AACjB,uBAAwB,AACxB,cAAe,AACf,UAAY,CACb,AACD,0CACE,WAAY,AACZ,qBAAsB,AACtB,YAAa,AACb,WAAY,AACZ,mDAA4C,AAC5C,oBAAqB,AACrB,wBAA4B,AAC5B,iCAAmC,AAC3B,yBAA2B,AACnC,oBAAqB,AACrB,yCAA2C,AAC3C,iCAAmC,AACnC,8DAAmE,CACpE,AACD,iDACE,oBAAqB,AACrB,uBAAwB,AAChB,cAAgB,CACzB,AACD,kCACE,kBAAmB,AACnB,SAAU,AACV,gBAAiB,AACjB,sBAAuB,AAEvB,UAAW,AACX,gBAAiB,AACjB,QAAS,AACT,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,eAAiB,CAClB,AACD,kCACE,cAAe,AACf,iBAAkB,AAClB,6BAA8B,AAE9B,gBAAiB,AACjB,eAAgB,AAChB,sBAAwB,CACzB,AACD,sCACE,aAAe,CAChB,AACD,uBACE,yBAA0B,AAC1B,UAAY,CACb,AACD,yBACE,gBAAkB,CACnB,AACD,4BACE,kBAAmB,AACnB,2BAA4B,AACpB,mBAAoB,AAC5B,WAAY,AACZ,mBAAoB,AACpB,sBAAuB,AAEvB,SAAU,AACV,UAAW,AACX,YAAa,AACb,iBAAkB,AAClB,qBAAuB,CACxB,AACD,4BACE,gBAAiB,AACjB,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,2CACE,gBAAiB,AAGjB,UAAY,CAFb,AAID,4CACE,UAAY,CACb,AAOD,oIACE,UAAY,CACb,AACD,4CACE,UAAY,CACb,AACD,iDACE,kBAAoB,CACrB,AACD,+BACE,yBAA2B,CAC5B,AACD,sBACE,aAAe,CAChB","file":"App.vue","sourcesContent":["\na[data-v-60b24177] {\n  color: #000;\n}\nhtml[data-v-60b24177],\nbody[data-v-60b24177] {\n  height: 100%;\n}\nbody[data-v-60b24177] {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  background: #eff1f4;\n  font-size: 12px;\n  /*-webkit-font-smoothing: antialiased;*/\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  position: relative;\n}\n.no-data[data-v-60b24177] {\n  font-size: 12px;\n  text-align: center;\n  color: #babdc2;\n  line-height: 23px;\n  padding-top: 42%;\n  background: #fff !important;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n}\n.top[data-v-60b24177] {\n  padding: 1em;\n  height: 27px;\n  position: relative;\n  z-index: 2;\n}\nnav[data-v-60b24177] {\n  height: 25px;\n  line-height: 25px;\n  text-align: center;\n  color: #16ac3a;\n  border: 1px solid #16ac3a;\n  /*no*/\n  border-radius: 2px;\n  float: left;\n  width: 72%;\n  margin: 1em;\n  font-size: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-left: 0;\n}\nnav span[data-v-60b24177] {\n  display: inline-block;\n  text-align: center;\n  width: 33.3%;\n  font-size: 12px;\n  border-left: 1px solid #16ac3a;\n  /*no*/\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\nnav span[data-v-60b24177]:first-child {\n  border: none;\n}\nnav span.sel[data-v-60b24177] {\n  color: #fff;\n  background: #16ac3a;\n}\ndiv.rate-menu[data-v-60b24177] {\n  float: right;\n  line-height: 27px;\n  position: relative;\n  max-width: 25%;\n  white-space: nowrap;\n}\ndiv.rate-menu span[data-v-60b24177] {\n  display: block;\n  text-align: right;\n}\ndiv.rate-menu span i[data-v-60b24177] {\n  font-style: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 85%;\n  float: left;\n}\ndiv.rate-menu span[data-v-60b24177]:after {\n  content: '';\n  display: inline-block;\n  height: 12px;\n  width: 24px;\n  background: url(assets/arrow.png) no-repeat;\n  background-size: 50%;\n  background-position: center;\n  -webkit-transform: rotateZ(180deg);\n          transform: rotateZ(180deg);\n  vertical-align: -2px;\n  transition: -webkit-transform 0.15s linear;\n  transition: transform 0.15s linear;\n  transition: transform 0.15s linear, -webkit-transform 0.15s linear;\n}\ndiv.rate-menu span.unfold[data-v-60b24177]:after {\n  vertical-align: -1px;\n  -webkit-transform: none;\n          transform: none;\n}\ndiv.rate-menu ul[data-v-60b24177] {\n  position: absolute;\n  top: 27px;\n  list-style: none;\n  border: 1px solid #eee;\n  /*no*/\n  z-index: 2;\n  background: #fff;\n  right: 0;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  min-width: 200px;\n}\ndiv.rate-menu li[data-v-60b24177] {\n  display: block;\n  line-height: 45px;\n  border-bottom: 1px solid #eee;\n  /*no*/\n  overflow: hidden;\n  padding: 0 10px;\n  text-overflow: ellipsis;\n}\ndiv.rate-menu li.sel[data-v-60b24177] {\n  color: #16ac3a;\n}\ntable[data-v-60b24177] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.list_4[data-v-60b24177] {\n  border-spacing: 0;\n}\n.list_4 th[data-v-60b24177] {\n  text-align: center;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  color: #333;\n  background: #eefcf1;\n  border: 1px solid #ddd;\n  /*no*/\n  margin: 0;\n  padding: 0;\n  height: 24px;\n  line-height: 24px;\n  word-break: break-word;\n}\n.list_4 td[data-v-60b24177] {\n  background: #fff;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n}\n.list_4 tr th[data-v-60b24177]:nth-child(1) {\n  font-weight: 700;\n}\n.list_4 tr th[data-v-60b24177]:nth-child(1) {\n  width: 80px;\n}\n.list_4 tr th[data-v-60b24177]:nth-child(2) {\n  width: 60px;\n}\n.list_4 tr th[data-v-60b24177]:nth-child(3) {\n  width: 50px;\n}\n.list_4 tr th[data-v-60b24177]:nth-child(4) {\n  width: 50px;\n}\n.list_4 tr th[data-v-60b24177]:nth-child(5) {\n  width: 50px;\n}\n.list_4 tr th[data-v-60b24177]:nth-child(6) {\n  width: 80px;\n}\n.list_4 tbody:nth-child(odd) td[data-v-60b24177] {\n  background: #eefcf1;\n}\n.list_4 tbody[data-v-60b24177] {\n  border-top: 1px solid #ddd;\n}\n.red[data-v-60b24177] {\n  color: #e52000;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow.9d74e1a.png";

/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dateformat__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dateformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fraction_js__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fraction_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fraction_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_matchDetail__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_matchDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lang_matchDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);








var URI_PREFIX =  true ? '/v2' : '';

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            currentTab: 'euro',
            dataLoad: false,
            currentRate: 'Decimal',
            rateMenuShow: false,
            oddsTabs: ['euro', 'asia', 'over_under'],
            oddsRates: ['Decimal', 'Fractional', 'American'],
            list: {
                euro: [],
                asia: [],
                over_under: []
            }
        };
    },

    computed: {
        matchOddsFormation: function matchOddsFormation() {
            return this.$store.state.matchDetailStore.matchOddsFormation;
        }
    },
    created: function created() {},
    mounted: function mounted() {
        if (window.localStorage && window.localStorage.currentRate) {
            this.currentRate = localStorage.currentRate;
        }
        if (!this.$route.params.id) {
            this.dataLoad = true;
            return;
        }
        this.dataLoad = true;
        this.$set(this.list, 'euro', this.matchOddsFormation.euro.data || []);
        this.$set(this.list, 'asia', this.matchOddsFormation.asia.data || []);
        this.$set(this.list, 'over_under', this.matchOddsFormation.overUnder.data || []);
    },

    watch: {
        currentRate: function currentRate() {
            if (window.localStorage) {
                localStorage.currentRate = this.currentRate;
            }
        }
    },
    methods: {
        oddsFormat: function oddsFormat(odds) {
            if (this.currentTab !== 'euro') {
                return odds;
            }
            if (/^\d+(\.\d+)?$/.test(odds.toString())) {
                if (this.currentRate === 'American') {
                    if (odds >= 2) {
                        return Math.floor((odds - 1) * 100);
                    } else {
                        return Math.floor(100 / (1 - odds));
                    }
                }

                if (this.currentRate === 'Fractional') {
                    return new __WEBPACK_IMPORTED_MODULE_1_fraction_js___default.a(odds).toFraction();
                }
            }

            return odds;
        },
        gotoDetail: function gotoDetail(id, type) {
            var m = parseInt(this.$route.query.id);
            if (m <= 50000000) {
                m += 50000000;
            }
            this.$router.push('/matchOdds?matchId=50956312&companyId=1183&type=euro&rate=Decimal&language=en-US');
        }
    },
    filters: {
        date: function date(str) {
            return __WEBPACK_IMPORTED_MODULE_0_dateformat___default()(str.replace(/-/g, '/'), 'dd mmm, HH:MM');
        }
    }
});

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

(function(global) {
  'use strict';

  var dateFormat = (function() {
      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|"[^"]*"|'[^']*'/g;
      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
      var timezoneClip = /[^-+\dA-Z]/g;
  
      // Regexes and supporting functions are cached through closure
      return function (date, mask, utc, gmt) {
  
        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
          mask = date;
          date = undefined;
        }
  
        date = date || new Date;
  
        if(!(date instanceof Date)) {
          date = new Date(date);
        }
  
        if (isNaN(date)) {
          throw TypeError('Invalid date');
        }
  
        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
  
        // Allow setting the utc/gmt argument via the mask
        var maskSlice = mask.slice(0, 4);
        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
          mask = mask.slice(4);
          utc = true;
          if (maskSlice === 'GMT:') {
            gmt = true;
          }
        }
  
        var _ = utc ? 'getUTC' : 'get';
        var d = date[_ + 'Date']();
        var D = date[_ + 'Day']();
        var m = date[_ + 'Month']();
        var y = date[_ + 'FullYear']();
        var H = date[_ + 'Hours']();
        var M = date[_ + 'Minutes']();
        var s = date[_ + 'Seconds']();
        var L = date[_ + 'Milliseconds']();
        var o = utc ? 0 : date.getTimezoneOffset();
        var W = getWeek(date);
        var N = getDayOfWeek(date);
        var flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dateFormat.i18n.dayNames[D],
          dddd: dateFormat.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dateFormat.i18n.monthNames[m],
          mmmm: dateFormat.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(Math.round(L / 10)),
          t:    H < 12 ? dateFormat.i18n.timeNames[0] : dateFormat.i18n.timeNames[1],
          tt:   H < 12 ? dateFormat.i18n.timeNames[2] : dateFormat.i18n.timeNames[3],
          T:    H < 12 ? dateFormat.i18n.timeNames[4] : dateFormat.i18n.timeNames[5],
          TT:   H < 12 ? dateFormat.i18n.timeNames[6] : dateFormat.i18n.timeNames[7],
          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
          W:    W,
          N:    N
        };
  
        return mask.replace(token, function (match) {
          if (match in flags) {
            return flags[match];
          }
          return match.slice(1, match.length - 1);
        });
      };
    })();

  dateFormat.masks = {
    'default':               'ddd mmm dd yyyy HH:MM:ss',
    'shortDate':             'm/d/yy',
    'mediumDate':            'mmm d, yyyy',
    'longDate':              'mmmm d, yyyy',
    'fullDate':              'dddd, mmmm d, yyyy',
    'shortTime':             'h:MM TT',
    'mediumTime':            'h:MM:ss TT',
    'longTime':              'h:MM:ss TT Z',
    'isoDate':               'yyyy-mm-dd',
    'isoTime':               'HH:MM:ss',
    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
    ],
    monthNames: [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ],
    timeNames: [
      'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
    ]
  };

function pad(val, len) {
  val = String(val);
  len = len || 2;
  while (val.length < len) {
    val = '0' + val;
  }
  return val;
}

/**
 * Get the ISO 8601 week number
 * Based on comments from
 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
 *
 * @param  {Object} `date`
 * @return {Number}
 */
function getWeek(date) {
  // Remove time components of date
  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  // Change date to Thursday same week
  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);

  // Take January 4th as it is always in week 1 (see ISO 8601)
  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);

  // Change date to Thursday same week
  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);

  // Check if daylight-saving-time-switch occurred and correct for it
  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
  targetThursday.setHours(targetThursday.getHours() - ds);

  // Number of weeks between target Thursday and first Thursday
  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
  return 1 + Math.floor(weekDiff);
}

/**
 * Get ISO-8601 numeric representation of the day of the week
 * 1 (for Monday) through 7 (for Sunday)
 * 
 * @param  {Object} `date`
 * @return {Number}
 */
function getDayOfWeek(date) {
  var dow = date.getDay();
  if(dow === 0) {
    dow = 7;
  }
  return dow;
}

/**
 * kind-of shortcut
 * @param  {*} val
 * @return {String}
 */
function kindOf(val) {
  if (val === null) {
    return 'null';
  }

  if (val === undefined) {
    return 'undefined';
  }

  if (typeof val !== 'object') {
    return typeof val;
  }

  if (Array.isArray(val)) {
    return 'array';
  }

  return {}.toString.call(val)
    .slice(8, -1).toLowerCase();
};



  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return dateFormat;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = dateFormat;
  } else {
    global.dateFormat = dateFormat;
  }
})(this);


/***/ }),

/***/ 679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoad) ? _c('div', [_c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "rate-menu"
  }, [_c('span', {
    class: _vm.rateMenuShow ? 'unfold' : '',
    on: {
      "click": function($event) {
        _vm.rateMenuShow = !_vm.rateMenuShow
      }
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.$t(_vm.currentRate)))])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rateMenuShow),
      expression: "rateMenuShow"
    }],
    on: {
      "click": function($event) {
        _vm.rateMenuShow = false
      }
    }
  }, _vm._l((_vm.oddsRates), function(rate) {
    return _c('li', {
      key: rate,
      class: _vm.currentRate === rate ? 'sel' : '',
      on: {
        "click": function($event) {
          _vm.currentRate = rate
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(rate)) + "\n                    ")])
  }))]), _vm._v(" "), _c('nav', [_c('span', {
    class: _vm.currentTab === 'euro' ? 'sel' : '',
    attrs: {
      "id": "erou"
    },
    on: {
      "click": function($event) {
        _vm.currentTab = 'euro'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('odds_1x2')))]), _vm._v(" "), _c('span', {
    class: _vm.currentTab === 'asia' ? 'sel' : '',
    attrs: {
      "id": "asia"
    },
    on: {
      "click": function($event) {
        _vm.currentTab = 'asia'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('odds_handicap')))]), _vm._v(" "), _c('span', {
    class: _vm.currentTab === 'over_under' ? 'sel' : '',
    attrs: {
      "id": "ballsizer"
    },
    on: {
      "click": function($event) {
        _vm.currentTab = 'over_under'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('odds_ou')))])])]), _vm._v(" "), (_vm.currentTab === 'euro') ? _c('table', {
    staticClass: "list_4",
    attrs: {
      "id": "erouList"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_home_win')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_draw')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_away_win')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])])]), _vm._v(" "), _vm._l((_vm.list['euro']), function($euroCompany, index) {
    return _c('tbody', {
      key: index,
      on: {
        "click": function($event) {
          _vm.gotoDetail($euroCompany['company']['id'], 'euro')
        }
      }
    }, [_c('tr', [_c('td', {
      staticClass: "company",
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s($euroCompany['company']['name']))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($euroCompany['odds']['last']['home'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($euroCompany['odds']['last']['draw'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($euroCompany['odds']['last']['away'])))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s(_vm._f("date")($euroCompany['odds']['last']['timestamp'])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Initial")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($euroCompany['odds']['first']['home'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($euroCompany['odds']['first']['draw'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($euroCompany['odds']['first']['away'])))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.currentTab === 'asia') ? _c('table', {
    staticClass: "list_4",
    attrs: {
      "id": "asiaList"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_home_lose')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_hdp')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_away_lose')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])])]), _vm._v(" "), _vm._l((_vm.list['asia']), function($asiaCompany, $index) {
    return _c('tbody', {
      key: $index,
      on: {
        "click": function($event) {
          _vm.gotoDetail($asiaCompany['company']['id'], 'asia')
        }
      }
    }, [_c('tr', [_c('td', {
      staticClass: "company",
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s($asiaCompany['company']['name']))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($asiaCompany['odds']['last']['home'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s($asiaCompany['odds']['last']['draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($asiaCompany['odds']['last']['away'])))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s(_vm._f("date")($asiaCompany['odds']['last']['timestamp'])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Initial")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($asiaCompany['odds']['first']['home'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s($asiaCompany['odds']['first']['draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($asiaCompany['odds']['first']['away'])))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.currentTab === 'over_under') ? _c('table', {
    staticClass: "list_4",
    attrs: {
      "id": "ballsizerList"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_over')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_total')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_under')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])])]), _vm._v(" "), _vm._l((_vm.list['over_under']), function($asiaCompany, $index) {
    return _c('tbody', {
      key: $index,
      on: {
        "click": function($event) {
          _vm.gotoDetail($asiaCompany['company']['id'], 'size')
        }
      }
    }, [_c('tr', [_c('td', {
      staticClass: "company",
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s($asiaCompany['company']['name']))]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($asiaCompany['odds']['last']['home'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s($asiaCompany['odds']['last']['draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($asiaCompany['odds']['last']['away'])))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s(_vm._f("date")($asiaCompany['odds']['last']['timestamp'])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Initial")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($asiaCompany['odds']['first']['home'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s($asiaCompany['odds']['first']['draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat($asiaCompany['odds']['first']['away'])))])])])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.dataLoad && (!_vm.list[_vm.currentTab] || !_vm.list[_vm.currentTab].length)) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v(_vm._s(_vm.$t('odds_no_data')) + "\n    ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "red"
  }, [_vm._v("Spot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "red"
  }, [_vm._v("Spot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "red"
  }, [_vm._v("Spot")])])
}]}

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), _c('div', {
    staticClass: "topFixedWrap",
    attrs: {
      "id": "topFixed"
    }
  }, [(_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please download our\n            professional APP.")]) : _vm._e(), _vm._v(" "), _c('downloadheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downLoadHeaderShow),
      expression: "downLoadHeaderShow"
    }],
    attrs: {
      "id": "headwrap"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "navBread"
  }, [_c('a', {
    staticClass: "match",
    attrs: {
      "href": "/matchs"
    }
  }, [_vm._v("Match")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/matchs/' + _vm.subtitleName,
      "id": "matchSubtitJump"
    }
  }, [_vm._v(_vm._s(_vm.subtitleName))])]), _vm._v(" "), _c('div', {
    staticClass: "bannerInformWrap clearfix",
    attrs: {
      "id": "teamWrap"
    }
  }, [_c('dl', {
    staticClass: "bannerLeft"
  }, [_c('dt', [_c('img', {
    directives: [{
      name: "team-logo",
      rawName: "v-team-logo"
    }],
    staticClass: "detailTeamLogo",
    attrs: {
      "src": _vm.getImgSrc(_vm.idData.team_A_logo),
      "alt": _vm.idData.team_A_name
    }
  })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.idData.team_A_name))])]), _vm._v(" "), _c('div', {
    staticClass: "bannerCenterWrap"
  }, [(_vm.competeStatus === 'Played') ? _c('div', {
    staticClass: "status_ended"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('div', {
    staticClass: "scorewrap clearfix"
  }, [_c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.idData.fs_A))]), _c('b', {
    staticClass: "rowLine"
  }), _c('span', [_vm._v(_vm._s(_vm.idData.fs_B))])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))])]) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Playing') ? _c('div', {
    staticClass: "status_playing"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('div', {
    staticClass: "scorewrap clearfix"
  }, [_c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.idData.fs_A))]), _c('b', {
    staticClass: "rowLine"
  }), _c('span', [_vm._v(_vm._s(_vm.idData.fs_B))])]), _vm._v(" "), (_vm.idData.livingFlag) ? _c('p', {
    staticClass: "live"
  }, [_c('img', {
    staticClass: "play_arrow",
    attrs: {
      "src": __webpack_require__(559),
      "alt": ""
    }
  }), _c('span', {
    staticClass: "fl"
  }, [_vm._v("LIVE IN " + _vm._s(_vm.idData.minute) + "'")])]) : _vm._e(), _vm._v(" "), (!_vm.idData.livingFlag) ? _c('p', {
    staticClass: "unlive"
  }, [_vm._v(_vm._s(_vm.idData.minute) + "'")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Fixture') ? _c('div', {
    staticClass: "status_unstart"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('p', {
    staticClass: "vs"
  }, [_vm._v("VS")]), _vm._v(" "), _c('div', {
    staticClass: "unstartTime clearfix"
  }, [(_vm.idData.livingFlag) ? _c('span', {
    staticClass: "unstartLive"
  }, [_vm._v("LIVE")]) : _vm._e(), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))])])]) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Postponed' || _vm.competeStatus === 'Cancelled' || _vm.competeStatus === 'Suspended') ? _c('div', {
    staticClass: "status_unstart"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('p', {
    staticClass: "vs"
  }, [_vm._v("VS")]), _vm._v(" "), _c('div', {
    staticClass: "unstartTime clearfix"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.competeStatus))])])]) : _vm._e()]), _vm._v(" "), _c('dl', {
    staticClass: "bannerRight"
  }, [_c('dt', [_c('img', {
    directives: [{
      name: "team-logo",
      rawName: "v-team-logo"
    }],
    staticClass: "detailTeamLogo",
    attrs: {
      "alt": _vm.idData.team_B_name,
      "src": _vm.getImgSrc(_vm.idData.team_B_logo)
    }
  })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.idData.team_B_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "tabWrap"
  }, [(_vm.scoreTabInfo) ? _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Score'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Score')
      }
    }
  }, [_vm._v("Score")]) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'OverView'
    },
    on: {
      "click": function($event) {
        _vm.toggle('OverView')
      }
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Analysis'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Analysis')
      }
    }
  }, [_vm._v("Analysis")]), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Odds'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Odds')
      }
    }
  }, [_vm._v("Odds")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.toggleSelect === 'Score' && _vm.scoreTabInfo) ? _c('matchScore', {
    attrs: {
      "matchId": _vm.competeId,
      "scoreTabInfo": _vm.scoreTabInfo
    }
  }) : _vm._e(), _vm._v(" "), _c('match-overview', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'OverView'),
      expression: "toggleSelect === 'OverView'"
    }],
    staticClass: "tabContent",
    attrs: {
      "matchId": _vm.competeId
    }
  }), _vm._v(" "), _c('match-analysis', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Analysis'),
      expression: "toggleSelect === 'Analysis'"
    }],
    staticClass: "tabContent",
    attrs: {
      "matchId": _vm.competeId
    }
  }), _vm._v(" "), _c('odds', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Odds'),
      expression: "toggleSelect === 'Odds'"
    }]
  })], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.18f2c2548f9bbd4828ad.js